export var agodaIcons = {
    "fill.brand.circle-ecodeals": {
        "default": {
            "default": {
                "plain": "3f501bb8",
                "symbol": "4799ee9c"
            }
        }
    },
    "fill.brand.circle-loyaltycash": {
        "default": {
            "default": {
                "plain": "e252c7aa",
                "symbol": "a1cee893"
            }
        },
        "v3": {
            "default": {
                "plain": "e252c7aa",
                "symbol": "a1cee893"
            }
        }
    },
    "fill.brand.ecodeals": {
        "default": {
            "default": {
                "plain": "86014c04",
                "symbol": "7d80ac41"
            }
        }
    },
    "fill.brand.homes": {
        "default": {
            "default": {
                "plain": "d185094a",
                "symbol": "b642ecc4"
            }
        },
        "v3": {
            "default": {
                "plain": "d185094a",
                "symbol": "b642ecc4"
            }
        }
    },
    "fill.brand.logo": {
        "default": {
            "default": {
                "plain": "9c205ac0",
                "symbol": "9130264d"
            }
        },
        "v3": {
            "default": {
                "plain": "d9b16701",
                "symbol": "6770c90d"
            }
        }
    },
    "fill.brand.logo2": {
        "default": {
            "default": {
                "plain": "e2c74399",
                "symbol": "e190398b"
            }
        },
        "v3": {
            "default": {
                "plain": "6ee335f7",
                "symbol": "cb30c8f4"
            }
        }
    },
    "fill.brand.loyaltycash": {
        "default": {
            "default": {
                "plain": "4709fe05",
                "symbol": "ac24392f"
            }
        },
        "v3": {
            "default": {
                "plain": "4709fe05",
                "symbol": "ac24392f"
            }
        }
    },
    "fill.brand.loyaltypoints": {
        "default": {
            "default": {
                "plain": "2dc91370",
                "symbol": "293c7c63"
            }
        },
        "v3": {
            "default": {
                "plain": "2dc91370",
                "symbol": "293c7c63"
            }
        }
    },
    "fill.brand.tripsavings": {
        "default": {
            "default": {
                "plain": "b0a9ce92",
                "symbol": "b885ab41"
            }
        }
    },
    "line.brand.circle-ecodeals": {
        "default": {
            "default": {
                "plain": "dfb0fa9f",
                "symbol": "068c301c"
            }
        }
    },
    "line.brand.ecodeals": {
        "default": {
            "default": {
                "plain": "4c53d734",
                "symbol": "b49b063f"
            }
        }
    },
    "line.brand.loyaltypoints": {
        "default": {
            "default": {
                "plain": "10bad691",
                "symbol": "61ab4536"
            }
        },
        "v3": {
            "default": {
                "plain": "10bad691",
                "symbol": "61ab4536"
            }
        }
    },
    "line.brand.tripsavings": {
        "default": {
            "default": {
                "plain": "dad3fb12",
                "symbol": "2d8ea228"
            }
        }
    }
};
export var defaultIcons = {
    "fill.accommodation.apartment": {
        "default": {
            "default": {
                "plain": "cc6f273b",
                "symbol": "93cf872b"
            }
        },
        "v3": {
            "default": {
                "plain": "b3a54472",
                "symbol": "60676aca"
            }
        }
    },
    "fill.accommodation.apartment-hand": {
        "default": {
            "default": {
                "plain": "8625ca83",
                "symbol": "b51e137d"
            }
        },
        "v3": {
            "default": {
                "plain": "b3a54472",
                "symbol": "60676aca"
            }
        }
    },
    "fill.accommodation.bungalow": {
        "default": {
            "default": {
                "plain": "927efcba",
                "symbol": "442c0269"
            }
        },
        "v3": {
            "default": {
                "plain": "5712baa2",
                "symbol": "29fa72dc"
            }
        }
    },
    "fill.accommodation.cabin": {
        "default": {
            "default": {
                "plain": "42358985",
                "symbol": "793ed462"
            }
        },
        "v3": {
            "default": {
                "plain": "972806e5",
                "symbol": "459922b7"
            }
        }
    },
    "fill.accommodation.capsule-female": {
        "default": {
            "default": {
                "plain": "b5d9d8d4",
                "symbol": "9a311a7f"
            }
        },
        "v3": {
            "default": {
                "plain": "691f7017",
                "symbol": "eb5703be"
            }
        }
    },
    "fill.accommodation.capsule-hotel": {
        "default": {
            "default": {
                "plain": "2e07467c",
                "symbol": "3d7cf650"
            }
        },
        "v3": {
            "default": {
                "plain": "691f7017",
                "symbol": "eb5703be"
            }
        }
    },
    "fill.accommodation.capsule-male": {
        "default": {
            "default": {
                "plain": "6f739b4b",
                "symbol": "2ef8351f"
            }
        },
        "v3": {
            "default": {
                "plain": "691f7017",
                "symbol": "eb5703be"
            }
        }
    },
    "fill.accommodation.castle": {
        "default": {
            "default": {
                "plain": "87e375ad",
                "symbol": "e4b15b48"
            }
        },
        "v3": {
            "default": {
                "plain": "d235cc1f",
                "symbol": "3f5058a9"
            }
        }
    },
    "fill.accommodation.cave": {
        "default": {
            "default": {
                "plain": "ce9cf69a",
                "symbol": "a79bd1db"
            }
        },
        "v3": {
            "default": {
                "plain": "feda0e42",
                "symbol": "841593f5"
            }
        }
    },
    "fill.accommodation.chalet": {
        "default": {
            "default": {
                "plain": "d64f36c7",
                "symbol": "2d011b83"
            }
        },
        "v3": {
            "default": {
                "plain": "d7d54b02",
                "symbol": "27d607ea"
            }
        }
    },
    "fill.accommodation.circle-ryokan": {
        "default": {
            "default": {
                "plain": "b3c7f8ce",
                "symbol": "91c327a4"
            }
        },
        "v3": {
            "default": {
                "plain": "cc52a9a8",
                "symbol": "3a13a48c"
            }
        }
    },
    "fill.accommodation.cottage": {
        "default": {
            "default": {
                "plain": "ddd54bd8",
                "symbol": "92f8bedf"
            }
        },
        "v3": {
            "default": {
                "plain": "fa5001ce",
                "symbol": "44a337a8"
            }
        }
    },
    "fill.accommodation.country-house": {
        "default": {
            "default": {
                "plain": "df2379dd",
                "symbol": "5ad8db90"
            }
        },
        "v3": {
            "default": {
                "plain": "d9df5673",
                "symbol": "c266edc3"
            }
        }
    },
    "fill.accommodation.dome-house": {
        "default": {
            "default": {
                "plain": "06036516",
                "symbol": "9aa2ab10"
            }
        },
        "v3": {
            "default": {
                "plain": "234d3071",
                "symbol": "513d7da7"
            }
        }
    },
    "fill.accommodation.family-room": {
        "default": {
            "default": {
                "plain": "fd5042d0",
                "symbol": "44fc53c1"
            }
        },
        "v3": {
            "default": {
                "plain": "7576e6ba",
                "symbol": "d5cd458e"
            }
        }
    },
    "fill.accommodation.farmstay": {
        "default": {
            "default": {
                "plain": "9427fbd1",
                "symbol": "273b0241"
            }
        },
        "v3": {
            "default": {
                "plain": "0d2306e0",
                "symbol": "73dfd8e7"
            }
        }
    },
    "fill.accommodation.haveli": {
        "default": {
            "default": {
                "plain": "0ee50c15",
                "symbol": "206a93ac"
            }
        },
        "v3": {
            "default": {
                "plain": "54d0c895",
                "symbol": "9651d1a5"
            }
        }
    },
    "fill.accommodation.hotel": {
        "default": {
            "default": {
                "plain": "9142081a",
                "symbol": "d107c904"
            }
        },
        "v3": {
            "default": {
                "plain": "20bcd7d9",
                "symbol": "cbca261b"
            }
        }
    },
    "fill.accommodation.hotel-arrow-in": {
        "default": {
            "default": {
                "plain": "4bad8b83",
                "symbol": "9600e03e"
            }
        }
    },
    "fill.accommodation.hotel-arrow-out": {
        "default": {
            "default": {
                "plain": "dbf4f1be",
                "symbol": "6bc18714"
            }
        }
    },
    "fill.accommodation.hotel-flight": {
        "default": {
            "default": {
                "plain": "2f5eefc3",
                "symbol": "39cd88b4"
            }
        },
        "v3": {
            "default": {
                "plain": "5e4b4a43",
                "symbol": "4a72f430"
            }
        }
    },
    "fill.accommodation.hotel-luxury": {
        "default": {
            "default": {
                "plain": "65974c3b",
                "symbol": "6d497d1b"
            }
        },
        "v3": {
            "default": {
                "plain": "7e5c02b2",
                "symbol": "70291a83"
            }
        }
    },
    "fill.accommodation.house": {
        "default": {
            "default": {
                "plain": "c2ab2ac6",
                "symbol": "ed15895f"
            }
        },
        "v3": {
            "default": {
                "plain": "424bd00e",
                "symbol": "04827e47"
            }
        }
    },
    "fill.accommodation.houseboat": {
        "default": {
            "default": {
                "plain": "777a23bb",
                "symbol": "6acb4ce5"
            }
        },
        "v3": {
            "default": {
                "plain": "c68f7149",
                "symbol": "6464a711"
            }
        }
    },
    "fill.accommodation.igloo": {
        "default": {
            "default": {
                "plain": "02be2a9a",
                "symbol": "b05e9de1"
            }
        },
        "v3": {
            "default": {
                "plain": "ce61e563",
                "symbol": "65aaeba0"
            }
        }
    },
    "fill.accommodation.inn": {
        "default": {
            "default": {
                "plain": "103e0330",
                "symbol": "692f4595"
            }
        },
        "v3": {
            "default": {
                "plain": "5779b8f3",
                "symbol": "2753d7f8"
            }
        }
    },
    "fill.accommodation.lodge": {
        "default": {
            "default": {
                "plain": "6ea3b34a",
                "symbol": "a58f8f90"
            }
        },
        "v3": {
            "default": {
                "plain": "7d9e65e2",
                "symbol": "ec764462"
            }
        }
    },
    "fill.accommodation.loft": {
        "default": {
            "default": {
                "plain": "f29451d5",
                "symbol": "7c2bf48b"
            }
        },
        "v3": {
            "default": {
                "plain": "b2c43b51",
                "symbol": "b62320a2"
            }
        }
    },
    "fill.accommodation.love-hotel": {
        "default": {
            "default": {
                "plain": "b2ee6f34",
                "symbol": "d41eac1c"
            }
        },
        "v3": {
            "default": {
                "plain": "ed494dc2",
                "symbol": "bb5b4080"
            }
        }
    },
    "fill.accommodation.machiya": {
        "default": {
            "default": {
                "plain": "76179a9f",
                "symbol": "6488e721"
            }
        },
        "v3": {
            "default": {
                "plain": "d0e4f6ba",
                "symbol": "807c025a"
            }
        }
    },
    "fill.accommodation.minsu": {
        "default": {
            "default": {
                "plain": "67982e13",
                "symbol": "5c1c4eb7"
            }
        },
        "v3": {
            "default": {
                "plain": "c769f75e",
                "symbol": "bf5dbf37"
            }
        }
    },
    "fill.accommodation.pension": {
        "default": {
            "default": {
                "plain": "8abc2d55",
                "symbol": "b244ddbd"
            }
        },
        "v3": {
            "default": {
                "plain": "2e1d1652",
                "symbol": "7f1165f9"
            }
        }
    },
    "fill.accommodation.riad": {
        "default": {
            "default": {
                "plain": "84a2a752",
                "symbol": "a436a2c6"
            }
        },
        "v3": {
            "default": {
                "plain": "5d7bd539",
                "symbol": "85897eb6"
            }
        }
    },
    "fill.accommodation.ryokan": {
        "default": {
            "default": {
                "plain": "433b4546",
                "symbol": "da29671c"
            }
        },
        "v3": {
            "default": {
                "plain": "cc52a9a8",
                "symbol": "3a13a48c"
            }
        }
    },
    "fill.accommodation.tipi": {
        "default": {
            "default": {
                "plain": "03c2f3a4",
                "symbol": "2284b858"
            }
        },
        "v3": {
            "default": {
                "plain": "83b08eb5",
                "symbol": "f7bb1687"
            }
        }
    },
    "fill.accommodation.townhouse": {
        "default": {
            "default": {
                "plain": "1b9dbd2d",
                "symbol": "0f20da4d"
            }
        },
        "v3": {
            "default": {
                "plain": "78bdf840",
                "symbol": "c81e2920"
            }
        }
    },
    "fill.accommodation.treehouse": {
        "default": {
            "default": {
                "plain": "5edefe24",
                "symbol": "b3b25c33"
            }
        },
        "v3": {
            "default": {
                "plain": "968bcc96",
                "symbol": "bc9f5341"
            }
        }
    },
    "fill.accommodation.villa": {
        "default": {
            "default": {
                "plain": "3b73e108",
                "symbol": "ffc21020"
            }
        },
        "v3": {
            "default": {
                "plain": "b2c43b51",
                "symbol": "b62320a2"
            }
        }
    },
    "fill.accommodation.yurt": {
        "default": {
            "default": {
                "plain": "89b13296",
                "symbol": "c840d0ee"
            }
        },
        "v3": {
            "default": {
                "plain": "c9cfc13a",
                "symbol": "95af6631"
            }
        }
    },
    "fill.activity.activity-kits": {
        "default": {
            "default": {
                "plain": "aca1cca0",
                "symbol": "4fdfceec"
            }
        },
        "v3": {
            "default": {
                "plain": "1ed57f08",
                "symbol": "c6cc55cd"
            }
        }
    },
    "fill.activity.archery": {
        "default": {
            "default": {
                "plain": "94a53fda",
                "symbol": "9a257496"
            }
        },
        "v3": {
            "default": {
                "plain": "3ad58c32",
                "symbol": "9ea58a2e"
            }
        }
    },
    "fill.activity.baseball": {
        "default": {
            "default": {
                "plain": "e676c61a",
                "symbol": "aeda256a"
            }
        },
        "v3": {
            "default": {
                "plain": "82a98be7",
                "symbol": "cb8b7269"
            }
        }
    },
    "fill.activity.beach": {
        "default": {
            "default": {
                "plain": "dfbb0e89",
                "symbol": "ca45a941"
            }
        },
        "v3": {
            "default": {
                "plain": "68235b99",
                "symbol": "8d9b535a"
            }
        }
    },
    "fill.activity.billiards": {
        "default": {
            "default": {
                "plain": "9229581f",
                "symbol": "772e1a7e"
            }
        },
        "v3": {
            "default": {
                "plain": "35453ec6",
                "symbol": "1a22c1ee"
            }
        }
    },
    "fill.activity.bird": {
        "default": {
            "default": {
                "plain": "82f08b68",
                "symbol": "4e15f350"
            }
        },
        "v3": {
            "default": {
                "plain": "4bd1ba6d",
                "symbol": "9fa59735"
            }
        }
    },
    "fill.activity.bird-binocular": {
        "default": {
            "default": {
                "plain": "7ab613dc",
                "symbol": "e0a6810f"
            }
        },
        "v3": {
            "default": {
                "plain": "47f87dbf",
                "symbol": "cc7a4e82"
            }
        }
    },
    "fill.activity.boat-row": {
        "default": {
            "default": {
                "plain": "8d0781a2",
                "symbol": "8a1e1b09"
            }
        },
        "v3": {
            "default": {
                "plain": "3ca777e2",
                "symbol": "f5b0b10e"
            }
        }
    },
    "fill.activity.book": {
        "default": {
            "default": {
                "plain": "072dd112",
                "symbol": "0f232e95"
            }
        },
        "v3": {
            "default": {
                "plain": "55d1ac6c",
                "symbol": "d4ecff8d"
            }
        }
    },
    "fill.activity.bowling": {
        "default": {
            "default": {
                "plain": "cc880629",
                "symbol": "43779e50"
            }
        },
        "v3": {
            "default": {
                "plain": "e0430447",
                "symbol": "ca49914a"
            }
        }
    },
    "fill.activity.butterfly": {
        "default": {
            "default": {
                "plain": "982d7e6d",
                "symbol": "75d45031"
            }
        },
        "v3": {
            "default": {
                "plain": "1d8d9acc",
                "symbol": "e8ef5cba"
            }
        }
    },
    "fill.activity.camping": {
        "default": {
            "default": {
                "plain": "dc0050fe",
                "symbol": "445eeec3"
            }
        },
        "v3": {
            "default": {
                "plain": "53760e1e",
                "symbol": "b4a92824"
            }
        }
    },
    "fill.activity.clam": {
        "default": {
            "default": {
                "plain": "bbc00c24",
                "symbol": "a8bbedd0"
            }
        },
        "v3": {
            "default": {
                "plain": "bd06bff5",
                "symbol": "04e35b8d"
            }
        }
    },
    "fill.activity.cycle": {
        "default": {
            "default": {
                "plain": "b3f3f442",
                "symbol": "10cd3cfc"
            }
        },
        "v3": {
            "default": {
                "plain": "3fd604c1",
                "symbol": "82dd26f2"
            }
        }
    },
    "fill.activity.dance": {
        "default": {
            "default": {
                "plain": "fba10890",
                "symbol": "4934c7eb"
            }
        },
        "v3": {
            "default": {
                "plain": "7cae4a6a",
                "symbol": "1ad87a1d"
            }
        }
    },
    "fill.activity.dart": {
        "default": {
            "default": {
                "plain": "d9837f32",
                "symbol": "a6f72ee9"
            }
        },
        "v3": {
            "default": {
                "plain": "8a011e71",
                "symbol": "d9400a52"
            }
        }
    },
    "fill.activity.dumbbell": {
        "default": {
            "default": {
                "plain": "6eaec3b3",
                "symbol": "f949bba5"
            }
        },
        "v3": {
            "default": {
                "plain": "91376b9f",
                "symbol": "5aface5d"
            }
        }
    },
    "fill.activity.dumbbell-24": {
        "default": {
            "default": {
                "plain": "06e14b06",
                "symbol": "452b8376"
            }
        },
        "v3": {
            "default": {
                "plain": "91376b9f",
                "symbol": "5aface5d"
            }
        }
    },
    "fill.activity.dumbbell-pay": {
        "default": {
            "default": {
                "plain": "172564d1",
                "symbol": "5c1fd5b8"
            }
        },
        "v3": {
            "default": {
                "plain": "91376b9f",
                "symbol": "5aface5d"
            }
        }
    },
    "fill.activity.exposition": {
        "default": {
            "default": {
                "plain": "dba52b02",
                "symbol": "46b739b7"
            }
        },
        "v3": {
            "default": {
                "plain": "78bef0c5",
                "symbol": "91bdf1d8"
            }
        }
    },
    "fill.activity.ferris-wheel": {
        "default": {
            "default": {
                "plain": "ea92d299",
                "symbol": "06b033a0"
            }
        },
        "v3": {
            "default": {
                "plain": "affa53e7",
                "symbol": "9c8854aa"
            }
        }
    },
    "fill.activity.fish-water": {
        "default": {
            "default": {
                "plain": "e1badd7e",
                "symbol": "c14119ef"
            }
        },
        "v3": {
            "default": {
                "plain": "d7d4ac48",
                "symbol": "ca288469"
            }
        }
    },
    "fill.activity.fishing": {
        "default": {
            "default": {
                "plain": "7a8668a6",
                "symbol": "80421359"
            }
        },
        "v3": {
            "default": {
                "plain": "ad1a2559",
                "symbol": "99d13e12"
            }
        }
    },
    "fill.activity.fishing-bird": {
        "default": {
            "default": {
                "plain": "df265a4e",
                "symbol": "db11d8f9"
            }
        },
        "v3": {
            "default": {
                "plain": "d7d4ac48",
                "symbol": "ca288469"
            }
        }
    },
    "fill.activity.fishing-net": {
        "default": {
            "default": {
                "plain": "568bd7e5",
                "symbol": "019cb852"
            }
        },
        "v3": {
            "default": {
                "plain": "d52ab2fe",
                "symbol": "f6587ff8"
            }
        }
    },
    "fill.activity.fishing-pay": {
        "default": {
            "default": {
                "plain": "124e1c76",
                "symbol": "8d2969a2"
            }
        },
        "v3": {
            "default": {
                "plain": "ad1a2559",
                "symbol": "99d13e12"
            }
        }
    },
    "fill.activity.flower": {
        "default": {
            "default": {
                "plain": "a0501fd4",
                "symbol": "fa7b7872"
            }
        },
        "v3": {
            "default": {
                "plain": "c4bc8a20",
                "symbol": "8de5e2ed"
            }
        }
    },
    "fill.activity.forest": {
        "default": {
            "default": {
                "plain": "6def7e5b",
                "symbol": "b4f4f94a"
            }
        },
        "v3": {
            "default": {
                "plain": "c848cbca",
                "symbol": "2807b255"
            }
        }
    },
    "fill.activity.gallery": {
        "default": {
            "default": {
                "plain": "cf4ccdc2",
                "symbol": "dfd3939a"
            }
        },
        "v3": {
            "default": {
                "plain": "6d53a3ad",
                "symbol": "65725cc3"
            }
        }
    },
    "fill.activity.game": {
        "default": {
            "default": {
                "plain": "ac4586e6",
                "symbol": "5bdc9291"
            }
        },
        "v3": {
            "default": {
                "plain": "e12f23b1",
                "symbol": "f07d387e"
            }
        }
    },
    "fill.activity.game-share": {
        "default": {
            "default": {
                "plain": "ba21e542",
                "symbol": "692259cb"
            }
        },
        "v3": {
            "default": {
                "plain": "e12f23b1",
                "symbol": "f07d387e"
            }
        }
    },
    "fill.activity.gateball": {
        "default": {
            "default": {
                "plain": "555a8468",
                "symbol": "d6d0e30c"
            }
        },
        "v3": {
            "default": {
                "plain": "86175dee",
                "symbol": "af9e380f"
            }
        }
    },
    "fill.activity.go-game": {
        "default": {
            "default": {
                "plain": "38cb4549",
                "symbol": "5f5f1d14"
            }
        },
        "v3": {
            "default": {
                "plain": "421c17df",
                "symbol": "c3dd12e5"
            }
        }
    },
    "fill.activity.goggles": {
        "default": {
            "default": {
                "plain": "cde54a7a",
                "symbol": "08c3687f"
            }
        },
        "v3": {
            "default": {
                "plain": "23ea46f6",
                "symbol": "e9cb66fd"
            }
        }
    },
    "fill.activity.golf": {
        "default": {
            "default": {
                "plain": "bc24d013",
                "symbol": "ea63ed3f"
            }
        },
        "v3": {
            "default": {
                "plain": "fdad7849",
                "symbol": "21e84c0c"
            }
        }
    },
    "fill.activity.hang-gliding": {
        "default": {
            "default": {
                "plain": "93a0db0b",
                "symbol": "e40d3edc"
            }
        },
        "v3": {
            "default": {
                "plain": "e62759b8",
                "symbol": "1780b597"
            }
        }
    },
    "fill.activity.hike": {
        "default": {
            "default": {
                "plain": "40224a44",
                "symbol": "2fa90943"
            }
        },
        "v3": {
            "default": {
                "plain": "8e905a21",
                "symbol": "e61a4db1"
            }
        }
    },
    "fill.activity.horseride": {
        "default": {
            "default": {
                "plain": "d7f9d4da",
                "symbol": "dc6c23d5"
            }
        },
        "v3": {
            "default": {
                "plain": "dfaf359b",
                "symbol": "1554f650"
            }
        }
    },
    "fill.activity.joystick": {
        "default": {
            "default": {
                "plain": "b946ed08",
                "symbol": "91aae941"
            }
        },
        "v3": {
            "default": {
                "plain": "0c78ee7c",
                "symbol": "d59e28dd"
            }
        }
    },
    "fill.activity.karaoke": {
        "default": {
            "default": {
                "plain": "f9e93a18",
                "symbol": "4274129c"
            }
        },
        "v3": {
            "default": {
                "plain": "3ab530b6",
                "symbol": "6e7d1b57"
            }
        }
    },
    "fill.activity.kick": {
        "default": {
            "default": {
                "plain": "9c168b0c",
                "symbol": "a49ae24f"
            }
        },
        "v3": {
            "default": {
                "plain": "fe7b6373",
                "symbol": "2e886fd9"
            }
        }
    },
    "fill.activity.kids-club": {
        "default": {
            "default": {
                "plain": "fa2729eb",
                "symbol": "5ed794d4"
            }
        },
        "v3": {
            "default": {
                "plain": "5c1aeff2",
                "symbol": "558997cc"
            }
        }
    },
    "fill.activity.leaf": {
        "default": {
            "default": {
                "plain": "dd2b57ed",
                "symbol": "96c9e15c"
            }
        },
        "v3": {
            "default": {
                "plain": "69106c02",
                "symbol": "7b20db43"
            }
        }
    },
    "fill.activity.mahjong": {
        "default": {
            "default": {
                "plain": "8b127308",
                "symbol": "e3a767cf"
            }
        },
        "v3": {
            "default": {
                "plain": "c2928232",
                "symbol": "1c6dfb7f"
            }
        }
    },
    "fill.activity.mask": {
        "default": {
            "default": {
                "plain": "5e6333cf",
                "symbol": "5ba2114e"
            }
        },
        "v3": {
            "default": {
                "plain": "bbcbb707",
                "symbol": "07a28579"
            }
        }
    },
    "fill.activity.mat": {
        "default": {
            "default": {
                "plain": "05960c07",
                "symbol": "a0b3fb6a"
            }
        },
        "v3": {
            "default": {
                "plain": "4a7c5076",
                "symbol": "f7ab8f49"
            }
        }
    },
    "fill.activity.mat-pay": {
        "default": {
            "default": {
                "plain": "c089b5c1",
                "symbol": "32d78ade"
            }
        },
        "v3": {
            "default": {
                "plain": "4a7c5076",
                "symbol": "f7ab8f49"
            }
        }
    },
    "fill.activity.meeting": {
        "default": {
            "default": {
                "plain": "edc14e17",
                "symbol": "932c9d76"
            }
        },
        "v3": {
            "default": {
                "plain": "58e84b21",
                "symbol": "7ec8f699"
            }
        }
    },
    "fill.activity.mirrorball": {
        "default": {
            "default": {
                "plain": "2f8059a4",
                "symbol": "3f9003ea"
            }
        },
        "v3": {
            "default": {
                "plain": "a7365998",
                "symbol": "ec1565c7"
            }
        }
    },
    "fill.activity.museum": {
        "default": {
            "default": {
                "plain": "d8189f9c",
                "symbol": "828b87f0"
            }
        },
        "v3": {
            "default": {
                "plain": "18fc19e5",
                "symbol": "655e699b"
            }
        }
    },
    "fill.activity.newspaper": {
        "default": {
            "default": {
                "plain": "d1dc4a6d",
                "symbol": "9f961179"
            }
        },
        "v3": {
            "default": {
                "plain": "8d52e808",
                "symbol": "f26edd80"
            }
        }
    },
    "fill.activity.noh-stage": {
        "default": {
            "default": {
                "plain": "fa9e6e3e",
                "symbol": "0a15454b"
            }
        },
        "v3": {
            "default": {
                "plain": "5ed413a7",
                "symbol": "092caaf5"
            }
        }
    },
    "fill.activity.orienteer": {
        "default": {
            "default": {
                "plain": "d2206d14",
                "symbol": "6fade1d8"
            }
        },
        "v3": {
            "default": {
                "plain": "dcecc3e0",
                "symbol": "e35059f2"
            }
        }
    },
    "fill.activity.pillar": {
        "default": {
            "default": {
                "plain": "3e200e06",
                "symbol": "00f6e5f5"
            }
        },
        "v3": {
            "default": {
                "plain": "0e173f25",
                "symbol": "7b161c55"
            }
        }
    },
    "fill.activity.pingpong": {
        "default": {
            "default": {
                "plain": "3a8e0621",
                "symbol": "487e7810"
            }
        },
        "v3": {
            "default": {
                "plain": "f0a8fa6a",
                "symbol": "9c01d8e6"
            }
        }
    },
    "fill.activity.play": {
        "default": {
            "default": {
                "plain": "96cb2b6d",
                "symbol": "2b9f5dfb"
            }
        },
        "v3": {
            "default": {
                "plain": "40cf8d82",
                "symbol": "65d3d4c7"
            }
        }
    },
    "fill.activity.play-pay": {
        "default": {
            "default": {
                "plain": "234c42ea",
                "symbol": "144b63aa"
            }
        },
        "v3": {
            "default": {
                "plain": "e3445a4b",
                "symbol": "02740179"
            }
        }
    },
    "fill.activity.playground": {
        "default": {
            "default": {
                "plain": "034709e6",
                "symbol": "2d735bfb"
            }
        },
        "v3": {
            "default": {
                "plain": "ed3efe85",
                "symbol": "03c31b35"
            }
        }
    },
    "fill.activity.poker": {
        "default": {
            "default": {
                "plain": "08a76f53",
                "symbol": "a1a47a26"
            }
        },
        "v3": {
            "default": {
                "plain": "814f6155",
                "symbol": "c405f80a"
            }
        }
    },
    "fill.activity.ropes": {
        "default": {
            "default": {
                "plain": "db56bba7",
                "symbol": "56a8ff29"
            }
        },
        "v3": {
            "default": {
                "plain": "01b199b8",
                "symbol": "dce8d98c"
            }
        }
    },
    "fill.activity.rugby": {
        "default": {
            "default": {
                "plain": "fe731e57",
                "symbol": "c7ecf946"
            }
        },
        "v3": {
            "default": {
                "plain": "e3790403",
                "symbol": "c00edaf6"
            }
        }
    },
    "fill.activity.run": {
        "default": {
            "default": {
                "plain": "983e1e10",
                "symbol": "f3e08de7"
            }
        },
        "v3": {
            "default": {
                "plain": "3700d08a",
                "symbol": "87dfb9f6"
            }
        }
    },
    "fill.activity.scuba-dive": {
        "default": {
            "default": {
                "plain": "364642e9",
                "symbol": "ae494b3a"
            }
        },
        "v3": {
            "default": {
                "plain": "2b3fb25a",
                "symbol": "d4a9856e"
            }
        }
    },
    "fill.activity.shogi": {
        "default": {
            "default": {
                "plain": "761db2af",
                "symbol": "1d3fe760"
            }
        },
        "v3": {
            "default": {
                "plain": "5c8b5c9e",
                "symbol": "e0634630"
            }
        }
    },
    "fill.activity.shrine-jp": {
        "default": {
            "default": {
                "plain": "678a96df",
                "symbol": "3a88f5be"
            }
        },
        "v3": {
            "default": {
                "plain": "c424f7c8",
                "symbol": "be7ff3f0"
            }
        }
    },
    "fill.activity.skateboard": {
        "default": {
            "default": {
                "plain": "cee09d24",
                "symbol": "dcc6f251"
            }
        },
        "v3": {
            "default": {
                "plain": "096c36f7",
                "symbol": "962e598d"
            }
        }
    },
    "fill.activity.ski": {
        "default": {
            "default": {
                "plain": "45bfb4fe",
                "symbol": "1e8f2e7c"
            }
        },
        "v3": {
            "default": {
                "plain": "72ae0a7f",
                "symbol": "405d4a14"
            }
        }
    },
    "fill.activity.ski-cloth-pay": {
        "default": {
            "default": {
                "plain": "7f5e8820",
                "symbol": "5ca1a634"
            }
        },
        "v3": {
            "default": {
                "plain": "154f95d3",
                "symbol": "3af324ef"
            }
        }
    },
    "fill.activity.ski-pay": {
        "default": {
            "default": {
                "plain": "397c2f61",
                "symbol": "1164790a"
            }
        },
        "v3": {
            "default": {
                "plain": "9f059726",
                "symbol": "46bd1b22"
            }
        }
    },
    "fill.activity.ski-shoe-pay": {
        "default": {
            "default": {
                "plain": "54145a7d",
                "symbol": "8d563642"
            }
        },
        "v3": {
            "default": {
                "plain": "0bcc4237",
                "symbol": "c140ca74"
            }
        }
    },
    "fill.activity.sled-pay": {
        "default": {
            "default": {
                "plain": "51579705",
                "symbol": "55d90cf3"
            }
        },
        "v3": {
            "default": {
                "plain": "737ccb65",
                "symbol": "422b5351"
            }
        }
    },
    "fill.activity.snowboard-pay": {
        "default": {
            "default": {
                "plain": "e55c4ed4",
                "symbol": "6e60606b"
            }
        },
        "v3": {
            "default": {
                "plain": "bf006f57",
                "symbol": "0be35565"
            }
        }
    },
    "fill.activity.soccer": {
        "default": {
            "default": {
                "plain": "ce21ac8a",
                "symbol": "a2774b77"
            }
        }
    },
    "fill.activity.sports-ground": {
        "default": {
            "default": {
                "plain": "e88f9303",
                "symbol": "42ffc3bd"
            }
        },
        "v3": {
            "default": {
                "plain": "72386495",
                "symbol": "64848750"
            }
        }
    },
    "fill.activity.squash": {
        "default": {
            "default": {
                "plain": "413b3367",
                "symbol": "18c2b6bc"
            }
        },
        "v3": {
            "default": {
                "plain": "3c3ca5c5",
                "symbol": "e9292483"
            }
        }
    },
    "fill.activity.sunbath": {
        "default": {
            "default": {
                "plain": "2685e769",
                "symbol": "772ead98"
            }
        },
        "v3": {
            "default": {
                "plain": "02945a07",
                "symbol": "30ab47f4"
            }
        }
    },
    "fill.activity.surf": {
        "default": {
            "default": {
                "plain": "0943ac43",
                "symbol": "3e318526"
            }
        },
        "v3": {
            "default": {
                "plain": "f23b4efe",
                "symbol": "a897852f"
            }
        }
    },
    "fill.activity.swim-indoor": {
        "default": {
            "default": {
                "plain": "2a81d2c8",
                "symbol": "d697696c"
            }
        },
        "v3": {
            "default": {
                "plain": "e0077c36",
                "symbol": "26d9e5a5"
            }
        }
    },
    "fill.activity.swim-outdoor": {
        "default": {
            "default": {
                "plain": "03f6aa65",
                "symbol": "93b88c91"
            }
        },
        "v3": {
            "default": {
                "plain": "e0077c36",
                "symbol": "26d9e5a5"
            }
        }
    },
    "fill.activity.swimming-tube": {
        "default": {
            "default": {
                "plain": "b03b53bb",
                "symbol": "acdb1ed0"
            }
        }
    },
    "fill.activity.tennis": {
        "default": {
            "default": {
                "plain": "10f4c8b4",
                "symbol": "473a23ea"
            }
        },
        "v3": {
            "default": {
                "plain": "3c3ca5c5",
                "symbol": "e9292483"
            }
        }
    },
    "fill.activity.tennis-pay": {
        "default": {
            "default": {
                "plain": "dc24093f",
                "symbol": "f21b32c7"
            }
        },
        "v3": {
            "default": {
                "plain": "3c3ca5c5",
                "symbol": "e9292483"
            }
        }
    },
    "fill.activity.tent": {
        "default": {
            "default": {
                "plain": "294c0643",
                "symbol": "46a261ef"
            }
        },
        "v3": {
            "default": {
                "plain": "d53c74b8",
                "symbol": "ffbabfb2"
            }
        }
    },
    "fill.activity.ticket": {
        "default": {
            "default": {
                "plain": "5da918e8",
                "symbol": "916d9afb"
            }
        },
        "v3": {
            "default": {
                "plain": "7c59d62c",
                "symbol": "1e7ba61b"
            }
        }
    },
    "fill.activity.treadmill": {
        "default": {
            "default": {
                "plain": "6caa4322",
                "symbol": "443ae135"
            }
        },
        "v3": {
            "default": {
                "plain": "1431e127",
                "symbol": "8a1c5fba"
            }
        }
    },
    "fill.activity.treadmill-pay": {
        "default": {
            "default": {
                "plain": "b3f42ee4",
                "symbol": "7ee245b6"
            }
        },
        "v3": {
            "default": {
                "plain": "1431e127",
                "symbol": "8a1c5fba"
            }
        }
    },
    "fill.activity.volleyball": {
        "default": {
            "default": {
                "plain": "81157418",
                "symbol": "6b85e7da"
            }
        },
        "v3": {
            "default": {
                "plain": "6bd77bc4",
                "symbol": "b1fbb7a6"
            }
        }
    },
    "fill.activity.walk": {
        "default": {
            "default": {
                "plain": "ebffc605",
                "symbol": "97df6172"
            }
        },
        "v3": {
            "default": {
                "plain": "554f7c0b",
                "symbol": "9b76fa33"
            }
        }
    },
    "fill.activity.walk-no": {
        "default": {
            "default": {
                "plain": "b2daf6a9",
                "symbol": "1f046795"
            }
        },
        "v3": {
            "default": {
                "plain": "b8a55fe1",
                "symbol": "00b142d5"
            }
        }
    },
    "fill.activity.wind-surf": {
        "default": {
            "default": {
                "plain": "f2a5311d",
                "symbol": "ba96f28f"
            }
        },
        "v3": {
            "default": {
                "plain": "e8cb8d77",
                "symbol": "f8f70d22"
            }
        }
    },
    "fill.activity.yoga": {
        "default": {
            "default": {
                "plain": "cb3087ae",
                "symbol": "a5a7b77c"
            }
        },
        "v3": {
            "default": {
                "plain": "4905a0aa",
                "symbol": "d53b3228"
            }
        }
    },
    "fill.activity.yoga-pay": {
        "default": {
            "default": {
                "plain": "54ef786c",
                "symbol": "a5de2bc1"
            }
        },
        "v3": {
            "default": {
                "plain": "4905a0aa",
                "symbol": "d53b3228"
            }
        }
    },
    "fill.amenity.apron": {
        "default": {
            "default": {
                "plain": "f9540965",
                "symbol": "a1248161"
            }
        },
        "v3": {
            "default": {
                "plain": "ef82321d",
                "symbol": "b7fb4484"
            }
        }
    },
    "fill.amenity.baby-changing-room": {
        "default": {
            "default": {
                "plain": "13884bdf",
                "symbol": "74287262"
            }
        },
        "v3": {
            "default": {
                "plain": "0efe9fd0",
                "symbol": "1129413e"
            }
        }
    },
    "fill.amenity.baby-safety-gate": {
        "default": {
            "default": {
                "plain": "dce1dc40",
                "symbol": "0be00470"
            }
        },
        "v3": {
            "default": {
                "plain": "2b284eeb",
                "symbol": "5a626aa9"
            }
        }
    },
    "fill.amenity.backpack": {
        "default": {
            "default": {
                "plain": "f9cf8758",
                "symbol": "86eeb78c"
            }
        },
        "v3": {
            "default": {
                "plain": "d8b4e434",
                "symbol": "37700b5a"
            }
        }
    },
    "fill.amenity.backpack-check": {
        "default": {
            "default": {
                "plain": "c45a3c6e",
                "symbol": "23ceff8a"
            }
        },
        "v3": {
            "default": {
                "plain": "89b0480c",
                "symbol": "6de54ed4"
            }
        }
    },
    "fill.amenity.backpack-no": {
        "default": {
            "default": {
                "plain": "185b17b4",
                "symbol": "723c0ebf"
            }
        },
        "v3": {
            "default": {
                "plain": "a06e9022",
                "symbol": "17e9d60e"
            }
        }
    },
    "fill.amenity.backpack-pay": {
        "default": {
            "default": {
                "plain": "5cbb71ca",
                "symbol": "57751ca5"
            }
        },
        "v3": {
            "default": {
                "plain": "9a25ded5",
                "symbol": "2e4473cb"
            }
        }
    },
    "fill.amenity.bag-business": {
        "default": {
            "default": {
                "plain": "4bbaa5df",
                "symbol": "3c79888c"
            }
        },
        "v3": {
            "default": {
                "plain": "fff555b7",
                "symbol": "c0b0419d"
            }
        }
    },
    "fill.amenity.bag-key": {
        "default": {
            "default": {
                "plain": "0a881e73",
                "symbol": "313b0b25"
            }
        },
        "v3": {
            "default": {
                "plain": "cc51ab5a",
                "symbol": "88723219"
            }
        }
    },
    "fill.amenity.bag-safe": {
        "default": {
            "default": {
                "plain": "9fcb41da",
                "symbol": "f3d0d4da"
            }
        },
        "v3": {
            "default": {
                "plain": "1e540986",
                "symbol": "d28dc416"
            }
        }
    },
    "fill.amenity.bag-travel": {
        "default": {
            "default": {
                "plain": "0653e7d5",
                "symbol": "1759389e"
            }
        },
        "v3": {
            "default": {
                "plain": "bf018aac",
                "symbol": "c6887e49"
            }
        }
    },
    "fill.amenity.bag-travel-no": {
        "default": {
            "default": {
                "plain": "da88a9fa",
                "symbol": "27e99d4c"
            }
        },
        "v3": {
            "default": {
                "plain": "5718f147",
                "symbol": "09594262"
            }
        }
    },
    "fill.amenity.bathrobes": {
        "default": {
            "default": {
                "plain": "70a24615",
                "symbol": "cce1d934"
            }
        },
        "v3": {
            "default": {
                "plain": "42772f3f",
                "symbol": "0ad2a786"
            }
        }
    },
    "fill.amenity.cabin-bag": {
        "default": {
            "default": {
                "plain": "be9d1fff",
                "symbol": "4a6d7c37"
            }
        },
        "v3": {
            "default": {
                "plain": "176a0923",
                "symbol": "de33646b"
            }
        }
    },
    "fill.amenity.cabin-bag-check": {
        "default": {
            "default": {
                "plain": "f8cc2f73",
                "symbol": "9a939d33"
            }
        },
        "v3": {
            "default": {
                "plain": "90d3fdff",
                "symbol": "ce018389"
            }
        }
    },
    "fill.amenity.cabin-bag-no": {
        "default": {
            "default": {
                "plain": "823bb67f",
                "symbol": "6a0fade4"
            }
        },
        "v3": {
            "default": {
                "plain": "5e7132b9",
                "symbol": "850b5752"
            }
        }
    },
    "fill.amenity.cabin-bag-pay": {
        "default": {
            "default": {
                "plain": "6ac4e393",
                "symbol": "d3ec1850"
            }
        },
        "v3": {
            "default": {
                "plain": "8d824eb5",
                "symbol": "bf352cb9"
            }
        }
    },
    "fill.amenity.clock": {
        "default": {
            "default": {
                "plain": "c7b95448",
                "symbol": "c52155a6"
            }
        },
        "v3": {
            "default": {
                "plain": "70939048",
                "symbol": "55f94377"
            }
        }
    },
    "fill.amenity.comb-scissor": {
        "default": {
            "default": {
                "plain": "ead26ed6",
                "symbol": "adfc03d5"
            }
        },
        "v3": {
            "default": {
                "plain": "f8cdbb59",
                "symbol": "9a445a0c"
            }
        }
    },
    "fill.amenity.cosmetic": {
        "default": {
            "default": {
                "plain": "2f244cff",
                "symbol": "8c696565"
            }
        },
        "v3": {
            "default": {
                "plain": "61d985c0",
                "symbol": "e5760e4e"
            }
        }
    },
    "fill.amenity.donotuse-luggage": {
        "default": {
            "default": {
                "plain": "2c8b954b",
                "symbol": "58b2bcd2"
            }
        }
    },
    "fill.amenity.donotuse-luggage-check": {
        "default": {
            "default": {
                "plain": "11d0006b",
                "symbol": "345a7eb5"
            }
        }
    },
    "fill.amenity.donotuse-luggage-no": {
        "default": {
            "default": {
                "plain": "8bb503bd",
                "symbol": "0613d7cf"
            }
        }
    },
    "fill.amenity.donotuse-luggage-pay": {
        "default": {
            "default": {
                "plain": "c964dcda",
                "symbol": "137ccfad"
            }
        }
    },
    "fill.amenity.facemask": {
        "default": {
            "default": {
                "plain": "fcc5e44c",
                "symbol": "4aa8ae23"
            }
        },
        "v3": {
            "default": {
                "plain": "90a2f75a",
                "symbol": "8f5ce4a5"
            }
        }
    },
    "fill.amenity.facemask-cross": {
        "default": {
            "default": {
                "plain": "ef4f8ae1",
                "symbol": "d137e674"
            }
        },
        "v3": {
            "default": {
                "plain": "a94753c8",
                "symbol": "679878bd"
            }
        }
    },
    "fill.amenity.hanger": {
        "default": {
            "default": {
                "plain": "aa986062",
                "symbol": "3c036e8b"
            }
        },
        "v3": {
            "default": {
                "plain": "e86e6720",
                "symbol": "ab8274a2"
            }
        }
    },
    "fill.amenity.key": {
        "default": {
            "default": {
                "plain": "d648b010",
                "symbol": "61383a8e"
            }
        },
        "v3": {
            "default": {
                "plain": "cc51ab5a",
                "symbol": "88723219"
            }
        }
    },
    "fill.amenity.key-no": {
        "default": {
            "default": {
                "plain": "fd4e3f77",
                "symbol": "74a95957"
            }
        },
        "v3": {
            "default": {
                "plain": "57360972",
                "symbol": "2ecf8a3e"
            }
        }
    },
    "fill.amenity.kitchenware": {
        "default": {
            "default": {
                "plain": "eec1846a",
                "symbol": "682e515e"
            }
        },
        "v3": {
            "default": {
                "plain": "44c4ff50",
                "symbol": "677deae6"
            }
        }
    },
    "fill.amenity.linen": {
        "default": {
            "default": {
                "plain": "91c0e633",
                "symbol": "83079fa9"
            }
        },
        "v3": {
            "default": {
                "plain": "e97b1cae",
                "symbol": "7cfe91f7"
            }
        }
    },
    "fill.amenity.luggage": {
        "default": {
            "default": {
                "plain": "d71cd7b6",
                "symbol": "27f0a51f"
            }
        },
        "v3": {
            "default": {
                "plain": "10911a7e",
                "symbol": "4499da45"
            }
        }
    },
    "fill.amenity.luggage-check": {
        "default": {
            "default": {
                "plain": "ed456111",
                "symbol": "44254f2b"
            }
        },
        "v3": {
            "default": {
                "plain": "b0dba3a9",
                "symbol": "dfc12cf2"
            }
        }
    },
    "fill.amenity.luggage-heart": {
        "default": {
            "default": {
                "plain": "28b2428f",
                "symbol": "6c0c095f"
            }
        },
        "v3": {
            "default": {
                "plain": "a44a4d19",
                "symbol": "f96aadb2"
            }
        }
    },
    "fill.amenity.luggage-no": {
        "default": {
            "default": {
                "plain": "3a29e9ce",
                "symbol": "4f21f934"
            }
        },
        "v3": {
            "default": {
                "plain": "b0f69bd2",
                "symbol": "d76aa8a3"
            }
        }
    },
    "fill.amenity.luggage-pay": {
        "default": {
            "default": {
                "plain": "748d1767",
                "symbol": "24b575da"
            }
        },
        "v3": {
            "default": {
                "plain": "99a65693",
                "symbol": "b5ee8a15"
            }
        }
    },
    "fill.amenity.mirror": {
        "default": {
            "default": {
                "plain": "48bd7259",
                "symbol": "adae071e"
            }
        },
        "v3": {
            "default": {
                "plain": "5a00d5e2",
                "symbol": "8212c265"
            }
        }
    },
    "fill.amenity.razor": {
        "default": {
            "default": {
                "plain": "0d0a71a8",
                "symbol": "16fef8df"
            }
        },
        "v3": {
            "default": {
                "plain": "dac8c393",
                "symbol": "6cd7aec8"
            }
        }
    },
    "fill.amenity.ring": {
        "default": {
            "default": {
                "plain": "0ecf11a3",
                "symbol": "318b02e2"
            }
        },
        "v3": {
            "default": {
                "plain": "01419d39",
                "symbol": "7deeb8e0"
            }
        }
    },
    "fill.amenity.sanitizer": {
        "default": {
            "default": {
                "plain": "5facdf42",
                "symbol": "261d736f"
            }
        },
        "v3": {
            "default": {
                "plain": "5bfb9dce",
                "symbol": "70747dcf"
            }
        }
    },
    "fill.amenity.scissor": {
        "default": {
            "default": {
                "plain": "b2ccb1df",
                "symbol": "1bbdb2fb"
            }
        },
        "v3": {
            "default": {
                "plain": "d0ad0cce",
                "symbol": "b8a4fb8c"
            }
        }
    },
    "fill.amenity.sewing": {
        "default": {
            "default": {
                "plain": "b7b32e82",
                "symbol": "fd91ea54"
            }
        },
        "v3": {
            "default": {
                "plain": "07eddf70",
                "symbol": "5abe2315"
            }
        }
    },
    "fill.amenity.shoeshine": {
        "default": {
            "default": {
                "plain": "60c0bc68",
                "symbol": "b3466435"
            }
        },
        "v3": {
            "default": {
                "plain": "bd9aab66",
                "symbol": "2360f299"
            }
        }
    },
    "fill.amenity.shopping-bag": {
        "default": {
            "default": {
                "plain": "a6fa6567",
                "symbol": "a4976179"
            }
        },
        "v3": {
            "default": {
                "plain": "9d201e17",
                "symbol": "7082382d"
            }
        }
    },
    "fill.amenity.slipper": {
        "default": {
            "default": {
                "plain": "1751b713",
                "symbol": "448236a7"
            }
        },
        "v3": {
            "default": {
                "plain": "53460704",
                "symbol": "90191df9"
            }
        }
    },
    "fill.amenity.step-stool": {
        "default": {
            "default": {
                "plain": "e6d17df2",
                "symbol": "835a8571"
            }
        }
    },
    "fill.amenity.toiletries": {
        "default": {
            "default": {
                "plain": "43bb60e8",
                "symbol": "0fdc1d4e"
            }
        },
        "v3": {
            "default": {
                "plain": "62851c50",
                "symbol": "cc90f78a"
            }
        }
    },
    "fill.amenity.tool": {
        "default": {
            "default": {
                "plain": "be5b5c83",
                "symbol": "1012d2eb"
            }
        },
        "v3": {
            "default": {
                "plain": "0f9dc780",
                "symbol": "aaaad290"
            }
        }
    },
    "fill.amenity.toothbrush": {
        "default": {
            "default": {
                "plain": "83fa0efc",
                "symbol": "a25bf626"
            }
        },
        "v3": {
            "default": {
                "plain": "d5406272",
                "symbol": "247779b0"
            }
        }
    },
    "fill.amenity.towel": {
        "default": {
            "default": {
                "plain": "4c882b58",
                "symbol": "6cb6a145"
            }
        },
        "v3": {
            "default": {
                "plain": "a82668b3",
                "symbol": "3c1d6b8c"
            }
        }
    },
    "fill.amenity.toy": {
        "default": {
            "default": {
                "plain": "3598a4ba",
                "symbol": "14eab9a6"
            }
        },
        "v3": {
            "default": {
                "plain": "5c1aeff2",
                "symbol": "558997cc"
            }
        }
    },
    "fill.amenity.trouser": {
        "default": {
            "default": {
                "plain": "fc79a607",
                "symbol": "65a05998"
            }
        },
        "v3": {
            "default": {
                "plain": "215ece12",
                "symbol": "157ab26a"
            }
        }
    },
    "fill.amenity.umbrella": {
        "default": {
            "default": {
                "plain": "9c661c21",
                "symbol": "ca3e46e9"
            }
        },
        "v3": {
            "default": {
                "plain": "37a1bac9",
                "symbol": "345a962a"
            }
        }
    },
    "fill.amenity.waterbottle": {
        "default": {
            "default": {
                "plain": "3d04e53f",
                "symbol": "e550a4ff"
            }
        },
        "v3": {
            "default": {
                "plain": "e53448f1",
                "symbol": "bfb1763d"
            }
        }
    },
    "fill.amenity.yukata": {
        "default": {
            "default": {
                "plain": "24a058db",
                "symbol": "f89f5c45"
            }
        },
        "v3": {
            "default": {
                "plain": "72f8f68d",
                "symbol": "be8ab809"
            }
        }
    },
    "fill.arrow.back": {
        "default": {
            "android": {
                "plain": "f2437569",
                "symbol": "7327fb98"
            },
            "default": {
                "plain": "a25fe029",
                "symbol": "0d0c92f0"
            },
            "ios": {
                "plain": "8be3dd17",
                "symbol": "81acae3c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "android": {
                "plain": "a67556b3",
                "symbol": "878a71ba"
            },
            "default": {
                "plain": "d4c68c8c",
                "symbol": "6fcd207b"
            },
            "ios": {
                "plain": "5a193041",
                "symbol": "776b2224"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.bothway": {
        "default": {
            "default": {
                "plain": "b1c672e4",
                "symbol": "24fc3abb"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "50d213e8",
                "symbol": "ef91dbd2"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.channel": {
        "default": {
            "default": {
                "plain": "c0e54a4c",
                "symbol": "3003f288"
            }
        },
        "v3": {
            "default": {
                "plain": "a576787f",
                "symbol": "49a37b5c"
            }
        }
    },
    "fill.arrow.circle-down": {
        "default": {
            "default": {
                "plain": "5406cc92",
                "symbol": "10aab799"
            }
        },
        "v3": {
            "default": {
                "plain": "e42cdda8",
                "symbol": "921d3494"
            }
        }
    },
    "fill.arrow.circle-left": {
        "default": {
            "default": {
                "plain": "3d4151a5",
                "symbol": "acc32db4"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "35d836f3",
                "symbol": "53aa12fc"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.circle-right": {
        "default": {
            "default": {
                "plain": "d24177c6",
                "symbol": "aba0967d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "a72a5593",
                "symbol": "d7edd4f8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.circle-up": {
        "default": {
            "default": {
                "plain": "9d8181d8",
                "symbol": "c5cf53c6"
            }
        },
        "v3": {
            "default": {
                "plain": "dd03f7ff",
                "symbol": "2f81b1e0"
            }
        }
    },
    "fill.arrow.currency": {
        "default": {
            "default": {
                "plain": "58f17ba1",
                "symbol": "4c286fcf"
            }
        }
    },
    "fill.arrow.dbl-down": {
        "default": {
            "default": {
                "plain": "2b818714",
                "symbol": "50e40456"
            }
        },
        "v3": {
            "default": {
                "plain": "decd8b56",
                "symbol": "b87e1a5c"
            }
        }
    },
    "fill.arrow.dbl-left": {
        "default": {
            "default": {
                "plain": "f175d19f",
                "symbol": "e3afb10d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "b86c52ba",
                "symbol": "18e98678"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.dbl-right": {
        "default": {
            "default": {
                "plain": "9be585f4",
                "symbol": "4d660834"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "a94f9a38",
                "symbol": "505b288e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.dbl-up": {
        "default": {
            "default": {
                "plain": "b9fac67e",
                "symbol": "67fb2e1f"
            }
        },
        "v3": {
            "default": {
                "plain": "52518f2d",
                "symbol": "76194654"
            }
        }
    },
    "fill.arrow.download": {
        "default": {
            "default": {
                "plain": "233592d7",
                "symbol": "e9a79cd1"
            }
        },
        "v3": {
            "default": {
                "plain": "63b4a261",
                "symbol": "e242d77a"
            }
        }
    },
    "fill.arrow.exchange": {
        "default": {
            "default": {
                "plain": "10521ccd",
                "symbol": "1bb69499"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "006df89e",
                "symbol": "09af93b9"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.leftdown": {
        "default": {
            "default": {
                "plain": "fda94e35",
                "symbol": "de0983af"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "8bef1d9e",
                "symbol": "3b0cf48b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.loop": {
        "default": {
            "default": {
                "plain": "f90c46a1",
                "symbol": "56d25953"
            }
        },
        "v3": {
            "default": {
                "plain": "2b63679e",
                "symbol": "d9fb64a0"
            }
        }
    },
    "fill.arrow.newpage": {
        "default": {
            "default": {
                "plain": "4b0084d2",
                "symbol": "c935d3f4"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f61ef1cc",
                "symbol": "29d70d97"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.oneway": {
        "default": {
            "default": {
                "plain": "a338c269",
                "symbol": "697aa944"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "262133ca",
                "symbol": "e313c10d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.processing": {
        "default": {
            "default": {
                "plain": "aa30896f",
                "symbol": "182d25a4"
            }
        },
        "v3": {
            "default": {
                "plain": "21745828",
                "symbol": "b3352885"
            }
        }
    },
    "fill.arrow.rightdown": {
        "default": {
            "default": {
                "plain": "0c63fb1d",
                "symbol": "15a998eb"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "41faf29c",
                "symbol": "482574b1"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.rotate": {
        "default": {
            "default": {
                "plain": "becc2494",
                "symbol": "cbf3d4dd"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "a016e4e3",
                "symbol": "7ae6a21d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.rotate-360": {
        "default": {
            "default": {
                "plain": "5d1ae698",
                "symbol": "624e6bb4"
            }
        },
        "v3": {
            "default": {
                "plain": "51a92a40",
                "symbol": "bd9ff798"
            }
        }
    },
    "fill.arrow.rotate2": {
        "default": {
            "default": {
                "plain": "4ba84c71",
                "symbol": "0c7d754e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "2a196646",
                "symbol": "c33a2747"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.scroll-top": {
        "default": {
            "default": {
                "plain": "6859e7d6",
                "symbol": "4f9d0ff7"
            }
        },
        "v3": {
            "default": {
                "plain": "f9f1041f",
                "symbol": "67268f93"
            }
        }
    },
    "fill.arrow.share": {
        "default": {
            "default": {
                "plain": "0c4db9d9",
                "symbol": "19a63640"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "3467ffff",
                "symbol": "e3892360"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.sign-out": {
        "default": {
            "default": {
                "plain": "c70b0af1",
                "symbol": "1dcf2b54"
            }
        }
    },
    "fill.arrow.size": {
        "default": {
            "default": {
                "plain": "acda3010",
                "symbol": "bd40276c"
            }
        },
        "v3": {
            "default": {
                "plain": "bee35630",
                "symbol": "63848010"
            }
        }
    },
    "fill.arrow.sort": {
        "default": {
            "default": {
                "plain": "9ec30481",
                "symbol": "2f051860"
            }
        },
        "v3": {
            "default": {
                "plain": "0c3eac9d",
                "symbol": "be8090bd"
            }
        }
    },
    "fill.arrow.thick-back": {
        "default": {
            "default": {
                "plain": "99dc581a",
                "symbol": "a7b282b2"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "d86ddbdd",
                "symbol": "3a02c37d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thick-collapse": {
        "default": {
            "default": {
                "plain": "1be80611",
                "symbol": "37571b55"
            }
        },
        "v3": {
            "default": {
                "plain": "b4b35614",
                "symbol": "8ed996fe"
            }
        }
    },
    "fill.arrow.thick-down": {
        "default": {
            "default": {
                "plain": "dd249bae",
                "symbol": "e40f5f6f"
            }
        },
        "v3": {
            "default": {
                "plain": "273a5e4f",
                "symbol": "f11e472a"
            }
        }
    },
    "fill.arrow.thick-dropdown": {
        "default": {
            "default": {
                "plain": "94f4aa43",
                "symbol": "db2e94af"
            }
        },
        "v3": {
            "default": {
                "plain": "5f337a66",
                "symbol": "c038f4d2"
            }
        }
    },
    "fill.arrow.thick-forward": {
        "default": {
            "default": {
                "plain": "a40a90a4",
                "symbol": "0540af06"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "81c51713",
                "symbol": "2fd11403"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thick-left": {
        "default": {
            "default": {
                "plain": "1f52ad03",
                "symbol": "2f74cdb5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "90994ab3",
                "symbol": "fe45ea3b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thick-leftright": {
        "default": {
            "default": {
                "plain": "408459a8",
                "symbol": "7446b106"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "2591b184",
                "symbol": "23d7266a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thick-leftup": {
        "default": {
            "default": {
                "plain": "ddba50bd",
                "symbol": "9789ef9b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "d2b5728f",
                "symbol": "ade29af5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thick-right": {
        "default": {
            "default": {
                "plain": "b8c24ffb",
                "symbol": "e298706f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "a2724d04",
                "symbol": "5cc0827d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thick-rightdown": {
        "default": {
            "default": {
                "plain": "3e0b5b97",
                "symbol": "920af7d5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "771f6336",
                "symbol": "1160c8ab"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thick-up": {
        "default": {
            "default": {
                "plain": "f50b94e7",
                "symbol": "9067eb2d"
            }
        },
        "v3": {
            "default": {
                "plain": "7ae350ca",
                "symbol": "b2aacb10"
            }
        }
    },
    "fill.arrow.thick-updown": {
        "default": {
            "default": {
                "plain": "81602fed",
                "symbol": "d4008ba8"
            }
        },
        "v3": {
            "default": {
                "plain": "9763da1f",
                "symbol": "2b6e4a34"
            }
        }
    },
    "fill.arrow.thin-back": {
        "default": {
            "default": {
                "plain": "b9f00ee8",
                "symbol": "702e9b3a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "9117dc86",
                "symbol": "bb5d1743"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thin-collapse": {
        "default": {
            "default": {
                "plain": "916adddc",
                "symbol": "700bfea9"
            }
        },
        "v3": {
            "default": {
                "plain": "2d6c92e5",
                "symbol": "391fffd0"
            }
        }
    },
    "fill.arrow.thin-down": {
        "default": {
            "default": {
                "plain": "403dc5e6",
                "symbol": "18e7c339"
            }
        },
        "v3": {
            "default": {
                "plain": "a6199daf",
                "symbol": "e2d1c860"
            }
        }
    },
    "fill.arrow.thin-dropdown": {
        "default": {
            "default": {
                "plain": "1a7dba98",
                "symbol": "43f45643"
            }
        },
        "v3": {
            "default": {
                "plain": "bfb633dd",
                "symbol": "9afdcd7b"
            }
        }
    },
    "fill.arrow.thin-forward": {
        "default": {
            "default": {
                "plain": "ee554d00",
                "symbol": "5ee083f8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "961038e0",
                "symbol": "e43f2e3e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thin-left": {
        "default": {
            "default": {
                "plain": "233c1793",
                "symbol": "4b7ef023"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "e9ec53fa",
                "symbol": "abcb08b4"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thin-leftright": {
        "default": {
            "default": {
                "plain": "9bf0aaf8",
                "symbol": "9fc7d3ed"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "c9f197cf",
                "symbol": "fd2671a1"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thin-right": {
        "default": {
            "default": {
                "plain": "80578f21",
                "symbol": "0cd97a91"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "6cfb7e0c",
                "symbol": "c666feb3"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.thin-up": {
        "default": {
            "default": {
                "plain": "04a9ebc2",
                "symbol": "565d679e"
            }
        },
        "v3": {
            "default": {
                "plain": "14220c56",
                "symbol": "b3ac6b87"
            }
        }
    },
    "fill.arrow.thin-updown": {
        "default": {
            "default": {
                "plain": "d13c0561",
                "symbol": "a01944ac"
            }
        },
        "v3": {
            "default": {
                "plain": "f2fb2468",
                "symbol": "8de426bf"
            }
        }
    },
    "fill.arrow.todown": {
        "default": {
            "default": {
                "plain": "953dfcdf",
                "symbol": "957077ec"
            }
        },
        "v3": {
            "default": {
                "plain": "f7b70d0f",
                "symbol": "d679eb63"
            }
        }
    },
    "fill.arrow.totop": {
        "default": {
            "default": {
                "plain": "6e7cdb76",
                "symbol": "8df77ff8"
            }
        },
        "v3": {
            "default": {
                "plain": "bd5f1a92",
                "symbol": "f3bfee5d"
            }
        }
    },
    "fill.arrow.turn": {
        "default": {
            "default": {
                "plain": "a003cea4",
                "symbol": "e5cce652"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.turn-down-left": {
        "default": {
            "default": {
                "plain": "2403224b",
                "symbol": "a16f1121"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "de492ebd",
                "symbol": "14ca9684"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.turn-down-right": {
        "default": {
            "default": {
                "plain": "735d4926",
                "symbol": "a98ed2bb"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "53e4e6b8",
                "symbol": "f7420333"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.turn-left": {
        "default": {
            "default": {
                "plain": "d43ffde7",
                "symbol": "92641f01"
            }
        }
    },
    "fill.arrow.turn-right": {
        "default": {
            "default": {
                "plain": "b1a12cc9",
                "symbol": "ebbc441c"
            }
        }
    },
    "fill.arrow.turn-up-left": {
        "default": {
            "default": {
                "plain": "09fdac22",
                "symbol": "54490d2f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "4840c64a",
                "symbol": "ba845502"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.turn-up-right": {
        "default": {
            "default": {
                "plain": "e6b0b384",
                "symbol": "a60820e9"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "0d6ca5f6",
                "symbol": "48192d71"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.upleft": {
        "default": {
            "default": {
                "plain": "25da6bf5",
                "symbol": "c432e94d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "a1e7ae37",
                "symbol": "2b36bfae"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.upload": {
        "default": {
            "default": {
                "plain": "97eb673e",
                "symbol": "11affc92"
            }
        },
        "v3": {
            "default": {
                "plain": "c777d002",
                "symbol": "ada28c36"
            }
        }
    },
    "fill.arrow.upright": {
        "default": {
            "default": {
                "plain": "da479e41",
                "symbol": "81c84682"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "967cb514",
                "symbol": "30a67536"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.arrow.zoom-in": {
        "default": {
            "default": {
                "plain": "fd928ed2",
                "symbol": "855a9723"
            }
        },
        "v3": {
            "default": {
                "plain": "1a137018",
                "symbol": "9935cfbc"
            }
        }
    },
    "fill.arrow.zoom-out": {
        "default": {
            "default": {
                "plain": "5b86e4f1",
                "symbol": "4683680e"
            }
        },
        "v3": {
            "default": {
                "plain": "c31bc69c",
                "symbol": "038b9aff"
            }
        }
    },
    "fill.brand.bundle-save": {
        "default": {
            "default": {
                "plain": "93a99f42",
                "symbol": "d1aa8137"
            }
        },
        "v3": {
            "default": {
                "plain": "8e7a6feb",
                "symbol": "a38e43e1"
            }
        }
    },
    "fill.brand.circle-ecodeal": {
        "default": {
            "default": {
                "plain": "035cc4cc",
                "symbol": "71282df4"
            }
        }
    },
    "fill.brand.circle-ecodeals": {
        "default": {
            "default": {
                "plain": "46b9dd2b",
                "symbol": "16526b6f"
            }
        }
    },
    "fill.brand.circle-loyaltycash": {
        "default": {
            "default": {
                "plain": "b2c744ce",
                "symbol": "4f2eebff"
            }
        },
        "v3": {
            "default": {
                "plain": "459a36a0",
                "symbol": "eb90d667"
            }
        }
    },
    "fill.brand.circle-mixsave": {
        "default": {
            "default": {
                "plain": "2efb1a8c",
                "symbol": "904206a0"
            }
        },
        "v3": {
            "default": {
                "plain": "cf9c833a",
                "symbol": "ff940933"
            }
        }
    },
    "fill.brand.easycancel": {
        "default": {
            "default": {
                "plain": "1eaf2cb4",
                "symbol": "580ed7b3"
            }
        },
        "v3": {
            "default": {
                "plain": "503a38d9",
                "symbol": "f422730a"
            }
        }
    },
    "fill.brand.ecodeal": {
        "default": {
            "default": {
                "plain": "51104230",
                "symbol": "6024755e"
            }
        }
    },
    "fill.brand.ecodeals": {
        "default": {
            "default": {
                "plain": "46b9dd2b",
                "symbol": "a83151e4"
            }
        }
    },
    "fill.brand.golocal": {
        "default": {
            "default": {
                "plain": "2578dd22",
                "symbol": "553a26e8"
            }
        },
        "v3": {
            "default": {
                "plain": "aa705b8b",
                "symbol": "65ec40ce"
            }
        }
    },
    "fill.brand.homes": {
        "default": {
            "default": {
                "plain": "726e0ed4",
                "symbol": "8d761527"
            }
        },
        "v3": {
            "default": {
                "plain": "86834360",
                "symbol": "8d2bc2a4"
            }
        }
    },
    "fill.brand.homes2": {
        "default": {
            "default": {
                "plain": "d060b701",
                "symbol": "eaf196c9"
            }
        }
    },
    "fill.brand.logo": {
        "default": {
            "default": {
                "plain": "6c20b4db",
                "symbol": "c178414a"
            }
        }
    },
    "fill.brand.logo2": {
        "default": {
            "default": {
                "plain": "6c20b4db",
                "symbol": "c178414a"
            }
        }
    },
    "fill.brand.loyaltycash": {
        "default": {
            "default": {
                "plain": "4a274a7f",
                "symbol": "f255e662"
            }
        },
        "v3": {
            "default": {
                "plain": "b90cc901",
                "symbol": "37f26a37"
            }
        }
    },
    "fill.brand.loyaltypoints": {
        "default": {
            "default": {
                "plain": "a41c7384",
                "symbol": "05f4de0f"
            }
        },
        "v3": {
            "default": {
                "plain": "b430d57a",
                "symbol": "c399bd5e"
            }
        }
    },
    "fill.brand.luxe": {
        "default": {
            "default": {
                "plain": "5d279a00",
                "symbol": "ee09d880"
            }
        },
        "v3": {
            "default": {
                "plain": "5d279a00",
                "symbol": "47cc6c52"
            }
        }
    },
    "fill.brand.mixsave": {
        "default": {
            "default": {
                "plain": "e27e9ed3",
                "symbol": "4d9577c3"
            }
        },
        "v3": {
            "default": {
                "plain": "4a791b3e",
                "symbol": "e30db9f3"
            }
        }
    },
    "fill.brand.specialoffers": {
        "default": {
            "default": {
                "plain": "06d8941f",
                "symbol": "312201a6"
            }
        },
        "v3": {
            "default": {
                "plain": "d4dd52cd",
                "symbol": "7c3fc2ae"
            }
        }
    },
    "fill.brand.tripsavings": {
        "default": {
            "default": {
                "plain": "b0a9ce92",
                "symbol": "b885ab41"
            }
        },
        "v3": {
            "default": {
                "plain": "af1ff920",
                "symbol": "0d67ec59"
            }
        }
    },
    "fill.brand.vipstar": {
        "default": {
            "default": {
                "plain": "5bfa3e72",
                "symbol": "137caed7"
            }
        },
        "v3": {
            "default": {
                "plain": "c25051d0",
                "symbol": "74309f43"
            }
        }
    },
    "fill.electrics.air-purifier": {
        "default": {
            "default": {
                "plain": "ff8e057e",
                "symbol": "8b7f4240"
            }
        },
        "v3": {
            "default": {
                "plain": "7c650d0a",
                "symbol": "92adfded"
            }
        }
    },
    "fill.electrics.camera": {
        "default": {
            "default": {
                "plain": "40a42384",
                "symbol": "2b8b39f0"
            }
        },
        "v3": {
            "default": {
                "plain": "4cec83fa",
                "symbol": "c7552082"
            }
        }
    },
    "fill.electrics.camera-no": {
        "default": {
            "default": {
                "plain": "c233ee8e",
                "symbol": "c7810b49"
            }
        },
        "v3": {
            "default": {
                "plain": "4b73d8c8",
                "symbol": "e8d2ed19"
            }
        }
    },
    "fill.electrics.cd": {
        "default": {
            "default": {
                "plain": "f3ec4a76",
                "symbol": "193c221d"
            }
        },
        "v3": {
            "default": {
                "plain": "0191ce7f",
                "symbol": "4ea8732b"
            }
        }
    },
    "fill.electrics.cellphone": {
        "default": {
            "default": {
                "plain": "7580de3b",
                "symbol": "e4c84bb0"
            }
        },
        "v3": {
            "default": {
                "plain": "7b073668",
                "symbol": "7b3ad50b"
            }
        }
    },
    "fill.electrics.coffee-maker": {
        "default": {
            "default": {
                "plain": "02f7702d",
                "symbol": "9be11231"
            }
        },
        "v3": {
            "default": {
                "plain": "cc3ae44c",
                "symbol": "910c201a"
            }
        }
    },
    "fill.electrics.desktop": {
        "default": {
            "default": {
                "plain": "0cc0b08c",
                "symbol": "9df80742"
            }
        },
        "v3": {
            "default": {
                "plain": "7b0b501c",
                "symbol": "a037cb8f"
            }
        }
    },
    "fill.electrics.dial-pad": {
        "default": {
            "default": {
                "plain": "8bbdde64",
                "symbol": "13d1cbad"
            }
        },
        "v3": {
            "default": {
                "plain": "908134a9",
                "symbol": "cbb906f8"
            }
        }
    },
    "fill.electrics.dishwasher": {
        "default": {
            "default": {
                "plain": "b4fa6b48",
                "symbol": "161a507b"
            }
        },
        "v3": {
            "default": {
                "plain": "35c658cb",
                "symbol": "935f9cb3"
            }
        }
    },
    "fill.electrics.dryer": {
        "default": {
            "default": {
                "plain": "becf5842",
                "symbol": "95a809b9"
            }
        },
        "v3": {
            "default": {
                "plain": "282335ef",
                "symbol": "ece043cf"
            }
        }
    },
    "fill.electrics.electric-blanket": {
        "default": {
            "default": {
                "plain": "4d8694b4",
                "symbol": "fe28bb8e"
            }
        },
        "v3": {
            "default": {
                "plain": "e97b1cae",
                "symbol": "7cfe91f7"
            }
        }
    },
    "fill.electrics.fan": {
        "default": {
            "default": {
                "plain": "8c4e4636",
                "symbol": "4606393b"
            }
        },
        "v3": {
            "default": {
                "plain": "cc9adafb",
                "symbol": "5850c825"
            }
        }
    },
    "fill.electrics.fax": {
        "default": {
            "default": {
                "plain": "f0bf8efb",
                "symbol": "839593ea"
            }
        },
        "v3": {
            "default": {
                "plain": "f70ee66c",
                "symbol": "09282d09"
            }
        }
    },
    "fill.electrics.gauge": {
        "default": {
            "default": {
                "plain": "50ebf070",
                "symbol": "afe42600"
            }
        },
        "v3": {
            "default": {
                "plain": "b5ff37c3",
                "symbol": "cf735671"
            }
        }
    },
    "fill.electrics.heater": {
        "default": {
            "default": {
                "plain": "774cfcb8",
                "symbol": "e2bcf4ac"
            }
        },
        "v3": {
            "default": {
                "plain": "a31bdabc",
                "symbol": "ef26e415"
            }
        }
    },
    "fill.electrics.humidifier": {
        "default": {
            "default": {
                "plain": "5a05f8d7",
                "symbol": "a043bc4c"
            }
        },
        "v3": {
            "default": {
                "plain": "7c650d0a",
                "symbol": "92adfded"
            }
        }
    },
    "fill.electrics.intercome": {
        "default": {
            "default": {
                "plain": "efbb093e",
                "symbol": "3c0573fa"
            }
        },
        "v3": {
            "default": {
                "plain": "7a37feb6",
                "symbol": "605bd5f3"
            }
        }
    },
    "fill.electrics.internet": {
        "default": {
            "default": {
                "plain": "39a23286",
                "symbol": "7daf7e6f"
            }
        },
        "v3": {
            "default": {
                "plain": "db48865f",
                "symbol": "3d340bd7"
            }
        }
    },
    "fill.electrics.internet-wire": {
        "default": {
            "default": {
                "plain": "4a62e93e",
                "symbol": "036cf480"
            }
        },
        "v3": {
            "default": {
                "plain": "788cf6fe",
                "symbol": "e902c126"
            }
        }
    },
    "fill.electrics.internet-wire-pay": {
        "default": {
            "default": {
                "plain": "1cc3ef00",
                "symbol": "b67f42cc"
            }
        },
        "v3": {
            "default": {
                "plain": "788cf6fe",
                "symbol": "e902c126"
            }
        }
    },
    "fill.electrics.iron": {
        "default": {
            "default": {
                "plain": "d95e75a6",
                "symbol": "119683f6"
            }
        },
        "v3": {
            "default": {
                "plain": "cba428a9",
                "symbol": "f1819b1c"
            }
        }
    },
    "fill.electrics.kotatsu": {
        "default": {
            "default": {
                "plain": "b2dccbbe",
                "symbol": "408ca913"
            }
        },
        "v3": {
            "default": {
                "plain": "6c4e6a2a",
                "symbol": "3eab5502"
            }
        }
    },
    "fill.electrics.laptop": {
        "default": {
            "default": {
                "plain": "a140b835",
                "symbol": "9d603b99"
            }
        },
        "v3": {
            "default": {
                "plain": "6d4b72e4",
                "symbol": "c7831490"
            }
        }
    },
    "fill.electrics.laundry-dry": {
        "default": {
            "default": {
                "plain": "243fd39d",
                "symbol": "2ecc7820"
            }
        },
        "v3": {
            "default": {
                "plain": "8e4afde1",
                "symbol": "68520204"
            }
        }
    },
    "fill.electrics.laundry-wash": {
        "default": {
            "default": {
                "plain": "30a4565d",
                "symbol": "5e92c951"
            }
        },
        "v3": {
            "default": {
                "plain": "8e4afde1",
                "symbol": "68520204"
            }
        }
    },
    "fill.electrics.microwave": {
        "default": {
            "default": {
                "plain": "95810903",
                "symbol": "21a98d34"
            }
        },
        "v3": {
            "default": {
                "plain": "5305b4c6",
                "symbol": "f205db9d"
            }
        }
    },
    "fill.electrics.phone-rotate": {
        "default": {
            "default": {
                "plain": "365b4db1",
                "symbol": "3fc8dbab"
            }
        },
        "v3": {
            "default": {
                "plain": "a0796639",
                "symbol": "72a4cfa9"
            }
        }
    },
    "fill.electrics.plug": {
        "default": {
            "default": {
                "plain": "313ab0d7",
                "symbol": "ecce7ec5"
            }
        },
        "v3": {
            "default": {
                "plain": "97b2267c",
                "symbol": "a8e125a1"
            }
        }
    },
    "fill.electrics.plug-no": {
        "default": {
            "default": {
                "plain": "13b58463",
                "symbol": "2cdf6e24"
            }
        },
        "v3": {
            "default": {
                "plain": "76881901",
                "symbol": "be3f54fe"
            }
        }
    },
    "fill.electrics.printer": {
        "default": {
            "default": {
                "plain": "13bbcc98",
                "symbol": "980cc2e8"
            }
        },
        "v3": {
            "default": {
                "plain": "c5878d5e",
                "symbol": "dc273e2f"
            }
        }
    },
    "fill.electrics.radio": {
        "default": {
            "default": {
                "plain": "c4109313",
                "symbol": "be80750d"
            }
        },
        "v3": {
            "default": {
                "plain": "dc22aed7",
                "symbol": "4b126885"
            }
        }
    },
    "fill.electrics.refrigerator": {
        "default": {
            "default": {
                "plain": "a28d43b6",
                "symbol": "9c383808"
            }
        },
        "v3": {
            "default": {
                "plain": "0bf9bdb0",
                "symbol": "f1b27ef6"
            }
        }
    },
    "fill.electrics.safety-box": {
        "default": {
            "default": {
                "plain": "9657e666",
                "symbol": "f751879f"
            }
        },
        "v3": {
            "default": {
                "plain": "eb3a8694",
                "symbol": "308f8ffb"
            }
        }
    },
    "fill.electrics.scale": {
        "default": {
            "default": {
                "plain": "1b225053",
                "symbol": "34a9f7be"
            }
        },
        "v3": {
            "default": {
                "plain": "bf169911",
                "symbol": "cb8307cc"
            }
        }
    },
    "fill.electrics.signal-full": {
        "default": {
            "default": {
                "plain": "58205c4a",
                "symbol": "520ce91d"
            }
        },
        "v3": {
            "default": {
                "plain": "5d8349e4",
                "symbol": "9a5b70cf"
            }
        }
    },
    "fill.electrics.signal-high": {
        "default": {
            "default": {
                "plain": "fbdf82b6",
                "symbol": "53af2aaa"
            }
        },
        "v3": {
            "default": {
                "plain": "7a0a33b0",
                "symbol": "a933db74"
            }
        }
    },
    "fill.electrics.signal-low": {
        "default": {
            "default": {
                "plain": "38c34bd7",
                "symbol": "9cd03635"
            }
        },
        "v3": {
            "default": {
                "plain": "f404defd",
                "symbol": "5c947cb9"
            }
        }
    },
    "fill.electrics.signal-medium": {
        "default": {
            "default": {
                "plain": "4c0d4391",
                "symbol": "82bc0e6f"
            }
        },
        "v3": {
            "default": {
                "plain": "895e3806",
                "symbol": "fdde2041"
            }
        }
    },
    "fill.electrics.signal-none": {
        "default": {
            "default": {
                "plain": "bfa00e22",
                "symbol": "a2c187bf"
            }
        },
        "v3": {
            "default": {
                "plain": "c3849440",
                "symbol": "82d55dc2"
            }
        }
    },
    "fill.electrics.signal-very-low": {
        "default": {
            "default": {
                "plain": "e580b901",
                "symbol": "76f258a1"
            }
        },
        "v3": {
            "default": {
                "plain": "530295e9",
                "symbol": "f5f9ea80"
            }
        }
    },
    "fill.electrics.smoke-detector": {
        "default": {
            "default": {
                "plain": "2adb486b",
                "symbol": "8fa1ce84"
            }
        },
        "v3": {
            "default": {
                "plain": "5d21c78b",
                "symbol": "577dc139"
            }
        }
    },
    "fill.electrics.table-dock": {
        "default": {
            "default": {
                "plain": "c3702397",
                "symbol": "64256f7e"
            }
        }
    },
    "fill.electrics.tablet": {
        "default": {
            "default": {
                "plain": "35205ad3",
                "symbol": "7ea99bd4"
            }
        },
        "v3": {
            "default": {
                "plain": "f06d475f",
                "symbol": "92e60e47"
            }
        }
    },
    "fill.electrics.tablet-dock": {
        "default": {
            "default": {
                "plain": "5eceb459",
                "symbol": "0a5704b4"
            }
        }
    },
    "fill.electrics.tv": {
        "default": {
            "default": {
                "plain": "c4dbde51",
                "symbol": "58f1564c"
            }
        },
        "v3": {
            "default": {
                "plain": "fc4c0705",
                "symbol": "3bdccdfc"
            }
        }
    },
    "fill.electrics.tv-cable": {
        "default": {
            "default": {
                "plain": "4a55a1a9",
                "symbol": "6f773d43"
            }
        },
        "v3": {
            "default": {
                "plain": "fc4c0705",
                "symbol": "3bdccdfc"
            }
        }
    },
    "fill.electrics.tv-hd": {
        "default": {
            "default": {
                "plain": "08f5748d",
                "symbol": "7087c5ec"
            }
        },
        "v3": {
            "default": {
                "plain": "fc4c0705",
                "symbol": "3bdccdfc"
            }
        }
    },
    "fill.electrics.vendingmachine": {
        "default": {
            "default": {
                "plain": "1d12b3e7",
                "symbol": "b459abe1"
            }
        },
        "v3": {
            "default": {
                "plain": "838d0d97",
                "symbol": "d5bd5bd8"
            }
        }
    },
    "fill.electrics.video-vod": {
        "default": {
            "default": {
                "plain": "1d78c4b9",
                "symbol": "165106ce"
            }
        },
        "v3": {
            "default": {
                "plain": "e88cd3d9",
                "symbol": "358488c4"
            }
        }
    },
    "fill.electrics.video-vod-no": {
        "default": {
            "default": {
                "plain": "81a109dc",
                "symbol": "06444033"
            }
        },
        "v3": {
            "default": {
                "plain": "6e404a39",
                "symbol": "e3d422bb"
            }
        }
    },
    "fill.electrics.water-pot": {
        "default": {
            "default": {
                "plain": "a4de85a9",
                "symbol": "546a7110"
            }
        },
        "v3": {
            "default": {
                "plain": "72f7780e",
                "symbol": "f62e955b"
            }
        }
    },
    "fill.electrics.wifi": {
        "default": {
            "default": {
                "plain": "24f15133",
                "symbol": "70d1bd86"
            }
        },
        "v3": {
            "default": {
                "plain": "788cf6fe",
                "symbol": "e902c126"
            }
        }
    },
    "fill.electrics.wifi-no": {
        "default": {
            "default": {
                "plain": "70914789",
                "symbol": "143b1f64"
            }
        },
        "v3": {
            "default": {
                "plain": "1ed02956",
                "symbol": "2eae8f35"
            }
        }
    },
    "fill.electrics.wifi-pay": {
        "default": {
            "default": {
                "plain": "b71d3e83",
                "symbol": "04de8025"
            }
        },
        "v3": {
            "default": {
                "plain": "788cf6fe",
                "symbol": "e902c126"
            }
        }
    },
    "fill.facility.air-conditioner": {
        "default": {
            "default": {
                "plain": "fcd936dc",
                "symbol": "488e3aa0"
            }
        },
        "v3": {
            "default": {
                "plain": "f102abe1",
                "symbol": "0cfaaf34"
            }
        }
    },
    "fill.facility.atm": {
        "default": {
            "default": {
                "plain": "74c75dfd",
                "symbol": "450441d4"
            }
        },
        "v3": {
            "default": {
                "plain": "ea3f2f6c",
                "symbol": "c755fa82"
            }
        }
    },
    "fill.facility.baby-cot": {
        "default": {
            "default": {
                "plain": "e0f438b4",
                "symbol": "2e556e61"
            }
        },
        "v3": {
            "default": {
                "plain": "6db2f816",
                "symbol": "882374a6"
            }
        }
    },
    "fill.facility.balcony": {
        "default": {
            "default": {
                "plain": "0979df16",
                "symbol": "a86179f2"
            }
        },
        "v3": {
            "default": {
                "plain": "c312081e",
                "symbol": "4da5c1c8"
            }
        }
    },
    "fill.facility.bath-family": {
        "default": {
            "default": {
                "plain": "acb39dad",
                "symbol": "c3d77382"
            }
        },
        "v3": {
            "default": {
                "plain": "e645d440",
                "symbol": "6031addd"
            }
        }
    },
    "fill.facility.bath-open": {
        "default": {
            "default": {
                "plain": "49075caf",
                "symbol": "dc215c2b"
            }
        },
        "v3": {
            "default": {
                "plain": "e645d440",
                "symbol": "6031addd"
            }
        }
    },
    "fill.facility.bath-separate": {
        "default": {
            "default": {
                "plain": "8403db02",
                "symbol": "f67f74c7"
            }
        },
        "v3": {
            "default": {
                "plain": "e645d440",
                "symbol": "6031addd"
            }
        }
    },
    "fill.facility.bathtub": {
        "default": {
            "default": {
                "plain": "b6ee0f19",
                "symbol": "00300145"
            }
        },
        "v3": {
            "default": {
                "plain": "9d6ccbc8",
                "symbol": "08943b52"
            }
        }
    },
    "fill.facility.bathtub-air": {
        "default": {
            "default": {
                "plain": "1a5f68e2",
                "symbol": "7185d203"
            }
        },
        "v3": {
            "default": {
                "plain": "9d6ccbc8",
                "symbol": "08943b52"
            }
        }
    },
    "fill.facility.bathtub-shower": {
        "default": {
            "default": {
                "plain": "4c5dc5c0",
                "symbol": "67918971"
            }
        },
        "v3": {
            "default": {
                "plain": "9d6ccbc8",
                "symbol": "08943b52"
            }
        }
    },
    "fill.facility.bed": {
        "default": {
            "default": {
                "plain": "af743a6b",
                "symbol": "7d64cace"
            }
        },
        "v3": {
            "default": {
                "plain": "c6bb0a23",
                "symbol": "5fdccf6e"
            }
        }
    },
    "fill.facility.bed-add": {
        "default": {
            "default": {
                "plain": "4b5699eb",
                "symbol": "9b81e82b"
            }
        },
        "v3": {
            "default": {
                "plain": "de1d3d54",
                "symbol": "79ca00a2"
            }
        }
    },
    "fill.facility.bed-change": {
        "default": {
            "default": {
                "plain": "a5f5bc81",
                "symbol": "9e2fa253"
            }
        },
        "v3": {
            "default": {
                "plain": "2b63679e",
                "symbol": "d9fb64a0"
            }
        }
    },
    "fill.facility.bed-door": {
        "default": {
            "default": {
                "plain": "0031cd87",
                "symbol": "1793a595"
            }
        },
        "v3": {
            "default": {
                "plain": "35903fd8",
                "symbol": "b5f9f3fc"
            }
        }
    },
    "fill.facility.bed-double": {
        "default": {
            "default": {
                "plain": "c92ea654",
                "symbol": "186ccf95"
            }
        },
        "v3": {
            "default": {
                "plain": "83b4a3f1",
                "symbol": "987e78bb"
            }
        }
    },
    "fill.facility.bed-king": {
        "default": {
            "default": {
                "plain": "d40972c3",
                "symbol": "a3337f27"
            }
        },
        "v3": {
            "default": {
                "plain": "a3384fa7",
                "symbol": "2d9e77e4"
            }
        }
    },
    "fill.facility.bed-queen": {
        "default": {
            "default": {
                "plain": "8605e989",
                "symbol": "dc235c59"
            }
        },
        "v3": {
            "default": {
                "plain": "83b4a3f1",
                "symbol": "987e78bb"
            }
        }
    },
    "fill.facility.bed-single": {
        "default": {
            "default": {
                "plain": "aecf3241",
                "symbol": "40a18583"
            }
        },
        "v3": {
            "default": {
                "plain": "b23affa3",
                "symbol": "c8712a77"
            }
        }
    },
    "fill.facility.bed-twin": {
        "default": {
            "default": {
                "plain": "0f9140c5",
                "symbol": "d8fc7397"
            }
        },
        "v3": {
            "default": {
                "plain": "e099eaf6",
                "symbol": "9b93bb2d"
            }
        }
    },
    "fill.facility.bunkbed": {
        "default": {
            "default": {
                "plain": "066f7701",
                "symbol": "58d747f9"
            }
        },
        "v3": {
            "default": {
                "plain": "401729ca",
                "symbol": "8e565bdd"
            }
        }
    },
    "fill.facility.cabinet": {
        "default": {
            "default": {
                "plain": "6d2eb82e",
                "symbol": "7dd129db"
            }
        },
        "v3": {
            "default": {
                "plain": "ed3ade26",
                "symbol": "df8aa38d"
            }
        }
    },
    "fill.facility.carpet": {
        "default": {
            "default": {
                "plain": "f020f92f",
                "symbol": "942050b7"
            }
        },
        "v3": {
            "default": {
                "plain": "a693ab9a",
                "symbol": "7cade8b0"
            }
        }
    },
    "fill.facility.cctv": {
        "default": {
            "default": {
                "plain": "b8930132",
                "symbol": "29dbb03a"
            }
        },
        "v3": {
            "default": {
                "plain": "063cba6b",
                "symbol": "89ca3b85"
            }
        }
    },
    "fill.facility.chair-kid": {
        "default": {
            "default": {
                "plain": "19c4b247",
                "symbol": "690f6ca6"
            }
        },
        "v3": {
            "default": {
                "plain": "67e98cff",
                "symbol": "533df479"
            }
        }
    },
    "fill.facility.desk": {
        "default": {
            "default": {
                "plain": "377b4e1c",
                "symbol": "50bc96ef"
            }
        },
        "v3": {
            "default": {
                "plain": "ad4a7db5",
                "symbol": "ac822933"
            }
        }
    },
    "fill.facility.drawer": {
        "default": {
            "default": {
                "plain": "53bf2bde",
                "symbol": "3220afb8"
            }
        },
        "v3": {
            "default": {
                "plain": "70711dd4",
                "symbol": "859d2439"
            }
        }
    },
    "fill.facility.drugstore": {
        "default": {
            "default": {
                "plain": "dd7bb648",
                "symbol": "e14f6937"
            }
        },
        "v3": {
            "default": {
                "plain": "91dda2b9",
                "symbol": "e876f0c8"
            }
        }
    },
    "fill.facility.elevator": {
        "default": {
            "default": {
                "plain": "54299a5e",
                "symbol": "a5c593fa"
            }
        },
        "v3": {
            "default": {
                "plain": "83221379",
                "symbol": "12d116df"
            }
        }
    },
    "fill.facility.fire-extinguisher": {
        "default": {
            "default": {
                "plain": "74d4fc33",
                "symbol": "5fe6bb29"
            }
        },
        "v3": {
            "default": {
                "plain": "111cdf7b",
                "symbol": "ca8e0ebf"
            }
        }
    },
    "fill.facility.fireplace": {
        "default": {
            "default": {
                "plain": "69222312",
                "symbol": "66f1d1ca"
            }
        },
        "v3": {
            "default": {
                "plain": "47019f6d",
                "symbol": "83332993"
            }
        }
    },
    "fill.facility.firstaid": {
        "default": {
            "default": {
                "plain": "c75d7e0f",
                "symbol": "1254fc57"
            }
        },
        "v3": {
            "default": {
                "plain": "a6f531e0",
                "symbol": "824bff71"
            }
        }
    },
    "fill.facility.gravel": {
        "default": {
            "default": {
                "plain": "afa77f9d",
                "symbol": "03a758a9"
            }
        },
        "v3": {
            "default": {
                "plain": "c1d2c1c8",
                "symbol": "5510e109"
            }
        }
    },
    "fill.facility.grill": {
        "default": {
            "default": {
                "plain": "4657fce3",
                "symbol": "7f164859"
            }
        },
        "v3": {
            "default": {
                "plain": "743f36bc",
                "symbol": "1f19adfb"
            }
        }
    },
    "fill.facility.hospital": {
        "default": {
            "default": {
                "plain": "837bf3d6",
                "symbol": "bcf82a6e"
            }
        },
        "v3": {
            "default": {
                "plain": "4635ac77",
                "symbol": "0e17958b"
            }
        }
    },
    "fill.facility.hot-spring": {
        "default": {
            "default": {
                "plain": "faf40d9d",
                "symbol": "dcf1c64b"
            }
        },
        "v3": {
            "default": {
                "plain": "8371db20",
                "symbol": "2092a856"
            }
        }
    },
    "fill.facility.lounge": {
        "default": {
            "default": {
                "plain": "a2f9211b",
                "symbol": "e5c8f5bc"
            }
        },
        "v3": {
            "default": {
                "plain": "c00bb02e",
                "symbol": "14aa7119"
            }
        }
    },
    "fill.facility.mosquitonet": {
        "default": {
            "default": {
                "plain": "5ac9bb2f",
                "symbol": "f4cba257"
            }
        },
        "v3": {
            "default": {
                "plain": "d52ab2fe",
                "symbol": "f6587ff8"
            }
        }
    },
    "fill.facility.motel": {
        "default": {
            "default": {
                "plain": "b78d1819",
                "symbol": "34501ec9"
            }
        },
        "v3": {
            "default": {
                "plain": "20bcd7d9",
                "symbol": "cbca261b"
            }
        }
    },
    "fill.facility.pet": {
        "default": {
            "default": {
                "plain": "c24cd889",
                "symbol": "c1239457"
            }
        },
        "v3": {
            "default": {
                "plain": "72c8fd33",
                "symbol": "534b917e"
            }
        }
    },
    "fill.facility.pet-bath": {
        "default": {
            "default": {
                "plain": "72d691f6",
                "symbol": "5e9d2e3c"
            }
        },
        "v3": {
            "default": {
                "plain": "72c8fd33",
                "symbol": "534b917e"
            }
        }
    },
    "fill.facility.pet-no": {
        "default": {
            "default": {
                "plain": "b9a59647",
                "symbol": "5270d3fc"
            }
        },
        "v3": {
            "default": {
                "plain": "8ffd1a95",
                "symbol": "5fcf8228"
            }
        }
    },
    "fill.facility.pet-pay": {
        "default": {
            "default": {
                "plain": "9f1ecb9f",
                "symbol": "80c8c246"
            }
        },
        "v3": {
            "default": {
                "plain": "72c8fd33",
                "symbol": "534b917e"
            }
        }
    },
    "fill.facility.pool-indoor": {
        "default": {
            "default": {
                "plain": "e785106d",
                "symbol": "26b603d1"
            }
        },
        "v3": {
            "default": {
                "plain": "a4c40260",
                "symbol": "7b28c39e"
            }
        }
    },
    "fill.facility.pool-kid": {
        "default": {
            "default": {
                "plain": "2088247c",
                "symbol": "6bc11211"
            }
        },
        "v3": {
            "default": {
                "plain": "a565cb3e",
                "symbol": "4af1d788"
            }
        }
    },
    "fill.facility.pool-outdoor": {
        "default": {
            "default": {
                "plain": "0917a13b",
                "symbol": "1832ecd5"
            }
        },
        "v3": {
            "default": {
                "plain": "a4c40260",
                "symbol": "7b28c39e"
            }
        }
    },
    "fill.facility.pray": {
        "default": {
            "default": {
                "plain": "9d0a1d71",
                "symbol": "69d91ab3"
            }
        },
        "v3": {
            "default": {
                "plain": "8c15cdfe",
                "symbol": "a85b19b1"
            }
        }
    },
    "fill.facility.pray-separate": {
        "default": {
            "default": {
                "plain": "cb8f618b",
                "symbol": "d38600c4"
            }
        },
        "v3": {
            "default": {
                "plain": "8c15cdfe",
                "symbol": "a85b19b1"
            }
        }
    },
    "fill.facility.projector": {
        "default": {
            "default": {
                "plain": "3a37feb2",
                "symbol": "c52e9527"
            }
        },
        "v3": {
            "default": {
                "plain": "10162e97",
                "symbol": "1f823dfb"
            }
        }
    },
    "fill.facility.room-size": {
        "default": {
            "default": {
                "plain": "c7f6c4a1",
                "symbol": "efcec035"
            }
        },
        "v3": {
            "default": {
                "plain": "827fef2f",
                "symbol": "c4e1bb3e"
            }
        }
    },
    "fill.facility.roomplan": {
        "default": {
            "default": {
                "plain": "1947a7a7",
                "symbol": "d432f068"
            }
        },
        "v3": {
            "default": {
                "plain": "def161c6",
                "symbol": "0d0d407e"
            }
        }
    },
    "fill.facility.sauna": {
        "default": {
            "default": {
                "plain": "c853fe98",
                "symbol": "48187695"
            }
        },
        "v3": {
            "default": {
                "plain": "b7888e9d",
                "symbol": "98ffeeeb"
            }
        }
    },
    "fill.facility.shop": {
        "default": {
            "default": {
                "plain": "f8f11a05",
                "symbol": "a3f2ed15"
            }
        },
        "v3": {
            "default": {
                "plain": "5f1cd6c7",
                "symbol": "56ec04e8"
            }
        }
    },
    "fill.facility.shower": {
        "default": {
            "default": {
                "plain": "992d2fd0",
                "symbol": "e41f85b7"
            }
        },
        "v3": {
            "default": {
                "plain": "e645d440",
                "symbol": "6031addd"
            }
        }
    },
    "fill.facility.shower-share": {
        "default": {
            "default": {
                "plain": "6effccb4",
                "symbol": "276f6b6e"
            }
        },
        "v3": {
            "default": {
                "plain": "e645d440",
                "symbol": "6031addd"
            }
        }
    },
    "fill.facility.slope": {
        "default": {
            "default": {
                "plain": "6a3111f5",
                "symbol": "c0a6a845"
            }
        },
        "v3": {
            "default": {
                "plain": "2f456f50",
                "symbol": "f4e7655a"
            }
        }
    },
    "fill.facility.smoke": {
        "default": {
            "default": {
                "plain": "c17651df",
                "symbol": "31cbd07e"
            }
        },
        "v3": {
            "default": {
                "plain": "13045a20",
                "symbol": "2a80db88"
            }
        }
    },
    "fill.facility.smoke-no": {
        "default": {
            "default": {
                "plain": "0dec24bd",
                "symbol": "c8060a83"
            }
        },
        "v3": {
            "default": {
                "plain": "460de3e5",
                "symbol": "a8b2cd15"
            }
        }
    },
    "fill.facility.sofa": {
        "default": {
            "default": {
                "plain": "0fd1351f",
                "symbol": "3a7fcc06"
            }
        },
        "v3": {
            "default": {
                "plain": "d64f857a",
                "symbol": "c9d56fbf"
            }
        }
    },
    "fill.facility.sofa-stool": {
        "default": {
            "default": {
                "plain": "a8186f1c",
                "symbol": "031602d2"
            }
        },
        "v3": {
            "default": {
                "plain": "c00bb02e",
                "symbol": "14aa7119"
            }
        }
    },
    "fill.facility.sofa2": {
        "default": {
            "default": {
                "plain": "cf9eb933",
                "symbol": "22893176"
            }
        },
        "v3": {
            "default": {
                "plain": "c00bb02e",
                "symbol": "14aa7119"
            }
        }
    },
    "fill.facility.soundproof": {
        "default": {
            "default": {
                "plain": "f0fff434",
                "symbol": "2728bb0b"
            }
        },
        "v3": {
            "default": {
                "plain": "4cd30d63",
                "symbol": "71fdf349"
            }
        }
    },
    "fill.facility.spa": {
        "default": {
            "default": {
                "plain": "6e8526bb",
                "symbol": "22ac109f"
            }
        },
        "v3": {
            "default": {
                "plain": "2990a8d0",
                "symbol": "734034a9"
            }
        }
    },
    "fill.facility.stair-ground": {
        "default": {
            "default": {
                "plain": "f3028f5c",
                "symbol": "46cdbbb5"
            }
        },
        "v3": {
            "default": {
                "plain": "f780d726",
                "symbol": "023b9c4a"
            }
        }
    },
    "fill.facility.stair-handrail": {
        "default": {
            "default": {
                "plain": "ddc08642",
                "symbol": "a1446a74"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f780d726",
                "symbol": "023b9c4a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.stair-high": {
        "default": {
            "default": {
                "plain": "5cf9aaff",
                "symbol": "374c84e0"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f780d726",
                "symbol": "023b9c4a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.stair-lock": {
        "default": {
            "default": {
                "plain": "9b62b0a4",
                "symbol": "fc38daf1"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f780d726",
                "symbol": "023b9c4a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.stair-low": {
        "default": {
            "default": {
                "plain": "d836d9b1",
                "symbol": "22841517"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f780d726",
                "symbol": "023b9c4a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.stair-no": {
        "default": {
            "default": {
                "plain": "9984505a",
                "symbol": "70750843"
            }
        },
        "v3": {
            "default": {
                "plain": "9437f9aa",
                "symbol": "a5a404e7"
            }
        }
    },
    "fill.facility.stair-number": {
        "default": {
            "default": {
                "plain": "90690748",
                "symbol": "e4546167"
            }
        },
        "v3": {
            "default": {
                "plain": "f780d726",
                "symbol": "023b9c4a"
            }
        }
    },
    "fill.facility.stove": {
        "default": {
            "default": {
                "plain": "3914abf9",
                "symbol": "901378fd"
            }
        },
        "v3": {
            "default": {
                "plain": "525c50dc",
                "symbol": "138b802b"
            }
        }
    },
    "fill.facility.stove-share": {
        "default": {
            "default": {
                "plain": "865134e6",
                "symbol": "6687c2e6"
            }
        },
        "v3": {
            "default": {
                "plain": "525c50dc",
                "symbol": "138b802b"
            }
        }
    },
    "fill.facility.table": {
        "default": {
            "default": {
                "plain": "9c63825e",
                "symbol": "8052b6bf"
            }
        },
        "v3": {
            "default": {
                "plain": "ceeaa9db",
                "symbol": "81368dcc"
            }
        }
    },
    "fill.facility.tatami": {
        "default": {
            "default": {
                "plain": "1c528946",
                "symbol": "505690ce"
            }
        },
        "v3": {
            "default": {
                "plain": "5d0d270c",
                "symbol": "fdd9395c"
            }
        }
    },
    "fill.facility.tatami-mix": {
        "default": {
            "default": {
                "plain": "30c5ec3f",
                "symbol": "423a8297"
            }
        },
        "v3": {
            "default": {
                "plain": "fefd2382",
                "symbol": "46c4552a"
            }
        }
    },
    "fill.facility.temperature": {
        "default": {
            "default": {
                "plain": "119b21d1",
                "symbol": "73dca493"
            }
        },
        "v3": {
            "default": {
                "plain": "b505c9b4",
                "symbol": "94cd5c91"
            }
        }
    },
    "fill.facility.toilet": {
        "default": {
            "default": {
                "plain": "710857f5",
                "symbol": "a3c5f2a6"
            }
        },
        "v3": {
            "default": {
                "plain": "c9c2499b",
                "symbol": "722aad2a"
            }
        }
    },
    "fill.facility.toilet-add": {
        "default": {
            "default": {
                "plain": "ddf20a74",
                "symbol": "e04dfb85"
            }
        },
        "v3": {
            "default": {
                "plain": "2560a0dc",
                "symbol": "77bd2322"
            }
        }
    },
    "fill.facility.toilet-bidet": {
        "default": {
            "default": {
                "plain": "660cd93f",
                "symbol": "87dd8d41"
            }
        },
        "v3": {
            "default": {
                "plain": "3c87380d",
                "symbol": "aeb14776"
            }
        }
    },
    "fill.facility.toilet-handrail": {
        "default": {
            "default": {
                "plain": "0de30ae4",
                "symbol": "12dfcee1"
            }
        },
        "v3": {
            "default": {
                "plain": "5a8ade01",
                "symbol": "1b16963d"
            }
        }
    },
    "fill.facility.toilet-phone": {
        "default": {
            "default": {
                "plain": "0aecdcf7",
                "symbol": "9a0d0abf"
            }
        },
        "v3": {
            "default": {
                "plain": "acba4592",
                "symbol": "e9ac00da"
            }
        }
    },
    "fill.facility.toilet-share": {
        "default": {
            "default": {
                "plain": "55a7307a",
                "symbol": "33073caf"
            }
        },
        "v3": {
            "default": {
                "plain": "c9c2499b",
                "symbol": "722aad2a"
            }
        }
    },
    "fill.facility.toilet-squat": {
        "default": {
            "default": {
                "plain": "2758018c",
                "symbol": "75aa5546"
            }
        },
        "v3": {
            "default": {
                "plain": "5f9ff828",
                "symbol": "08e5565c"
            }
        }
    },
    "fill.facility.tv-area": {
        "default": {
            "default": {
                "plain": "dcc76bb6",
                "symbol": "d295be9c"
            }
        },
        "v3": {
            "default": {
                "plain": "bca6f8de",
                "symbol": "5a9bd905"
            }
        }
    },
    "fill.facility.tv-area-share": {
        "default": {
            "default": {
                "plain": "66a14e00",
                "symbol": "cbdad25b"
            }
        },
        "v3": {
            "default": {
                "plain": "bca6f8de",
                "symbol": "5a9bd905"
            }
        }
    },
    "fill.facility.wheelchair": {
        "default": {
            "default": {
                "plain": "7e06fef2",
                "symbol": "f7df0d30"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "540d9b07",
                "symbol": "1aac2249"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.wheelchair-arrow": {
        "default": {
            "default": {
                "plain": "2acec202",
                "symbol": "7a3b3d28"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "540d9b07",
                "symbol": "1aac2249"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.wheelchair-bath": {
        "default": {
            "default": {
                "plain": "432f373f",
                "symbol": "384596b2"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "540d9b07",
                "symbol": "1aac2249"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.wheelchair-elevator": {
        "default": {
            "default": {
                "plain": "e13070ba",
                "symbol": "2d969bad"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "2f7489f4",
                "symbol": "da11f702"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.wheelchair-park": {
        "default": {
            "default": {
                "plain": "b6a7e194",
                "symbol": "94233944"
            }
        },
        "v3": {
            "default": {
                "plain": "e10cf20e",
                "symbol": "ef192e77"
            }
        }
    },
    "fill.facility.wheelchair-stair": {
        "default": {
            "default": {
                "plain": "dc7ca7e2",
                "symbol": "0bf30180"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "540d9b07",
                "symbol": "1aac2249"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.facility.window": {
        "default": {
            "default": {
                "plain": "aa820d11",
                "symbol": "45516a6f"
            }
        },
        "v3": {
            "default": {
                "plain": "34b21e05",
                "symbol": "57821e60"
            }
        }
    },
    "fill.facility.wood": {
        "default": {
            "default": {
                "plain": "c1bba1c5",
                "symbol": "fb272f51"
            }
        },
        "v3": {
            "default": {
                "plain": "c1d2c1c8",
                "symbol": "5510e109"
            }
        }
    },
    "fill.food.babybottle": {
        "default": {
            "default": {
                "plain": "53396cc8",
                "symbol": "e0b56ba2"
            }
        },
        "v3": {
            "default": {
                "plain": "1cf5d070",
                "symbol": "d591f994"
            }
        }
    },
    "fill.food.buffet": {
        "default": {
            "default": {
                "plain": "ff718c58",
                "symbol": "155b926c"
            }
        },
        "v3": {
            "default": {
                "plain": "f127672b",
                "symbol": "82b05572"
            }
        }
    },
    "fill.food.circle-fork-knife": {
        "default": {
            "default": {
                "plain": "f67dad01",
                "symbol": "fd9add69"
            }
        },
        "v3": {
            "default": {
                "plain": "a9d13b68",
                "symbol": "d69dca5a"
            }
        }
    },
    "fill.food.cocktail": {
        "default": {
            "default": {
                "plain": "5d44dd31",
                "symbol": "49bbf893"
            }
        },
        "v3": {
            "default": {
                "plain": "a65464b3",
                "symbol": "ebc76429"
            }
        }
    },
    "fill.food.cocktail-pool": {
        "default": {
            "default": {
                "plain": "bf824934",
                "symbol": "604477d6"
            }
        },
        "v3": {
            "default": {
                "plain": "a65464b3",
                "symbol": "ebc76429"
            }
        }
    },
    "fill.food.coffee": {
        "default": {
            "default": {
                "plain": "b1df003b",
                "symbol": "f47138c3"
            }
        },
        "v3": {
            "default": {
                "plain": "83c9506f",
                "symbol": "c302a40d"
            }
        }
    },
    "fill.food.cookie": {
        "default": {
            "default": {
                "plain": "c5e46b0d",
                "symbol": "f34bf60d"
            }
        },
        "v3": {
            "default": {
                "plain": "d09a0a1b",
                "symbol": "7bc29194"
            }
        }
    },
    "fill.food.croissant": {
        "default": {
            "default": {
                "plain": "3f53355a",
                "symbol": "059c9131"
            }
        },
        "v3": {
            "default": {
                "plain": "084fc246",
                "symbol": "2984554c"
            }
        }
    },
    "fill.food.fork-knife": {
        "default": {
            "default": {
                "plain": "fc8b8524",
                "symbol": "716661db"
            }
        },
        "v3": {
            "default": {
                "plain": "a9d13b68",
                "symbol": "d69dca5a"
            }
        }
    },
    "fill.food.fork-knife-no": {
        "default": {
            "default": {
                "plain": "752bb4ff",
                "symbol": "547ad8e3"
            }
        },
        "v3": {
            "default": {
                "plain": "d86f6341",
                "symbol": "d35eb32c"
            }
        }
    },
    "fill.food.fork-knife-pay": {
        "default": {
            "default": {
                "plain": "5d480f22",
                "symbol": "22de32fb"
            }
        },
        "v3": {
            "default": {
                "plain": "a9d13b68",
                "symbol": "d69dca5a"
            }
        }
    },
    "fill.food.fork-spoon": {
        "default": {
            "default": {
                "plain": "a2fe2f87",
                "symbol": "826f0029"
            }
        },
        "v3": {
            "default": {
                "plain": "1f759d38",
                "symbol": "11c4b82a"
            }
        }
    },
    "fill.food.juice": {
        "default": {
            "default": {
                "plain": "d003b8be",
                "symbol": "58990d72"
            }
        },
        "v3": {
            "default": {
                "plain": "280151bd",
                "symbol": "104c8e5b"
            }
        }
    },
    "fill.food.noodle": {
        "default": {
            "default": {
                "plain": "9b6586fd",
                "symbol": "e6d09039"
            }
        },
        "v3": {
            "default": {
                "plain": "607dd479",
                "symbol": "feed87a4"
            }
        }
    },
    "fill.food.salt": {
        "default": {
            "default": {
                "plain": "35ae84af",
                "symbol": "c6e517aa"
            }
        },
        "v3": {
            "default": {
                "plain": "5488071c",
                "symbol": "36a40f30"
            }
        }
    },
    "fill.food.sushi": {
        "default": {
            "default": {
                "plain": "b0ac63b0",
                "symbol": "0b586e27"
            }
        },
        "v3": {
            "default": {
                "plain": "52a25e90",
                "symbol": "9dfed79c"
            }
        }
    },
    "fill.food.tea": {
        "default": {
            "default": {
                "plain": "e36a31fc",
                "symbol": "3d317308"
            }
        },
        "v3": {
            "default": {
                "plain": "ec42d73c",
                "symbol": "a45ab1b1"
            }
        }
    },
    "fill.food.tea-ceremony": {
        "default": {
            "default": {
                "plain": "bf4b6859",
                "symbol": "4f8ebce5"
            }
        },
        "v3": {
            "default": {
                "plain": "eb898264",
                "symbol": "5dd3cbe9"
            }
        }
    },
    "fill.food.teapot": {
        "default": {
            "default": {
                "plain": "335a4da2",
                "symbol": "c525fa42"
            }
        },
        "v3": {
            "default": {
                "plain": "eb898264",
                "symbol": "5dd3cbe9"
            }
        }
    },
    "fill.food.wine": {
        "default": {
            "default": {
                "plain": "24e1e0ff",
                "symbol": "c1e2a287"
            }
        },
        "v3": {
            "default": {
                "plain": "304ca8f7",
                "symbol": "faca146f"
            }
        }
    },
    "fill.food.wine-bottle": {
        "default": {
            "default": {
                "plain": "129c6655",
                "symbol": "7b1c0f61"
            }
        },
        "v3": {
            "default": {
                "plain": "56c560ac",
                "symbol": "1cece251"
            }
        }
    },
    "fill.logo.alipay": {
        "default": {
            "default": {
                "plain": "becb4081",
                "symbol": "316c68bf"
            }
        },
        "v3": {
            "default": {
                "plain": "becb4081",
                "symbol": "a7132843"
            }
        }
    },
    "fill.logo.amex": {
        "default": {
            "default": {
                "plain": "385687a6",
                "symbol": "e0221dc5"
            }
        },
        "v3": {
            "default": {
                "plain": "91e99123",
                "symbol": "b256f2ed"
            }
        }
    },
    "fill.logo.android": {
        "default": {
            "default": {
                "plain": "153089b0",
                "symbol": "e49de05f"
            }
        },
        "v3": {
            "default": {
                "plain": "153089b0",
                "symbol": "e49de05f"
            }
        }
    },
    "fill.logo.apple": {
        "default": {
            "default": {
                "plain": "a0698398",
                "symbol": "4b1506f8"
            }
        },
        "v3": {
            "default": {
                "plain": "a0698398",
                "symbol": "4b1506f8"
            }
        }
    },
    "fill.logo.bc": {
        "default": {
            "default": {
                "plain": "e80baae2",
                "symbol": "e4fc7227"
            }
        },
        "v3": {
            "default": {
                "plain": "e80baae2",
                "symbol": "e4fc7227"
            }
        }
    },
    "fill.logo.dinersclub": {
        "default": {
            "default": {
                "plain": "5fbc6f51",
                "symbol": "ccc3c6c9"
            }
        },
        "v3": {
            "default": {
                "plain": "5fbc6f51",
                "symbol": "ccc3c6c9"
            }
        }
    },
    "fill.logo.discover": {
        "default": {
            "default": {
                "plain": "bed7796b",
                "symbol": "ac0bd6f6"
            }
        },
        "v3": {
            "default": {
                "plain": "bed7796b",
                "symbol": "ac0bd6f6"
            }
        }
    },
    "fill.logo.facebook": {
        "default": {
            "default": {
                "plain": "e028154f",
                "symbol": "ead0cff5"
            }
        },
        "v3": {
            "default": {
                "plain": "e028154f",
                "symbol": "ead0cff5"
            }
        }
    },
    "fill.logo.facebook-messenger": {
        "default": {
            "default": {
                "plain": "411e2f41",
                "symbol": "cb1be91d"
            }
        },
        "v3": {
            "default": {
                "plain": "2cb330d1",
                "symbol": "dda32300"
            }
        }
    },
    "fill.logo.instagram": {
        "default": {
            "default": {
                "plain": "1be94c3d",
                "symbol": "8a375355"
            }
        },
        "v3": {
            "default": {
                "plain": "1be94c3d",
                "symbol": "8a375355"
            }
        }
    },
    "fill.logo.jcb": {
        "default": {
            "default": {
                "plain": "2553e13f",
                "symbol": "84cf2a4f"
            }
        },
        "v3": {
            "default": {
                "plain": "2553e13f",
                "symbol": "84cf2a4f"
            }
        }
    },
    "fill.logo.linechat": {
        "default": {
            "default": {
                "plain": "6ecb6cac",
                "symbol": "70be98d2"
            }
        },
        "v3": {
            "default": {
                "plain": "6ecb6cac",
                "symbol": "70be98d2"
            }
        }
    },
    "fill.logo.masterard": {
        "default": {
            "default": {
                "plain": "d4996234",
                "symbol": "d66e76d6"
            }
        }
    },
    "fill.logo.mastercard": {
        "default": {
            "default": {
                "plain": "d4996234",
                "symbol": "d66e76d6"
            }
        }
    },
    "fill.logo.pinterest": {
        "default": {
            "default": {
                "plain": "edcfed13",
                "symbol": "a11acc8d"
            }
        },
        "v3": {
            "default": {
                "plain": "edcfed13",
                "symbol": "a11acc8d"
            }
        }
    },
    "fill.logo.twitter": {
        "default": {
            "default": {
                "plain": "72c4e122",
                "symbol": "50a9c42f"
            }
        },
        "v3": {
            "default": {
                "plain": "72c4e122",
                "symbol": "50a9c42f"
            }
        }
    },
    "fill.logo.unionpay": {
        "default": {
            "default": {
                "plain": "201e4e3a",
                "symbol": "6deb81d1"
            }
        },
        "v3": {
            "default": {
                "plain": "df74a30e",
                "symbol": "25f2f5fe"
            }
        }
    },
    "fill.logo.visa": {
        "default": {
            "default": {
                "plain": "c828c621",
                "symbol": "7f3483ee"
            }
        },
        "v3": {
            "default": {
                "plain": "c828c621",
                "symbol": "7f3483ee"
            }
        }
    },
    "fill.logo.wechat": {
        "default": {
            "default": {
                "plain": "384b34d4",
                "symbol": "37baf92d"
            }
        },
        "v3": {
            "default": {
                "plain": "384b34d4",
                "symbol": "42928d17"
            }
        }
    },
    "fill.logo.wechat-pay": {
        "default": {
            "default": {
                "plain": "7557b1fb",
                "symbol": "c787a1ad"
            }
        },
        "v3": {
            "default": {
                "plain": "97b9cb19",
                "symbol": "4040c8a0"
            }
        }
    },
    "fill.logo.whatsapp": {
        "default": {
            "default": {
                "plain": "6447247a",
                "symbol": "c5500d62"
            }
        },
        "v3": {
            "default": {
                "plain": "6447247a",
                "symbol": "c5500d62"
            }
        }
    },
    "fill.logo.windows": {
        "default": {
            "default": {
                "plain": "94399c87",
                "symbol": "4b0a61a1"
            }
        },
        "v3": {
            "default": {
                "plain": "94399c87",
                "symbol": "7b564c56"
            }
        }
    },
    "fill.people.adult1": {
        "default": {
            "default": {
                "plain": "6bc89a00",
                "symbol": "29442c50"
            }
        },
        "v3": {
            "default": {
                "plain": "c59356d1",
                "symbol": "e5b1da63"
            }
        }
    },
    "fill.people.adult2": {
        "default": {
            "default": {
                "plain": "ee425f25",
                "symbol": "65784fae"
            }
        },
        "v3": {
            "default": {
                "plain": "c59356d1",
                "symbol": "e5b1da63"
            }
        }
    },
    "fill.people.baby": {
        "default": {
            "default": {
                "plain": "84a6914d",
                "symbol": "2d4fa291"
            }
        },
        "v3": {
            "default": {
                "plain": "84931654",
                "symbol": "8436d5ae"
            }
        }
    },
    "fill.people.baby-no": {
        "default": {
            "default": {
                "plain": "5db714b6",
                "symbol": "167d81ff"
            }
        },
        "v3": {
            "default": {
                "plain": "556afe8d",
                "symbol": "64d06a8f"
            }
        }
    },
    "fill.people.child": {
        "default": {
            "default": {
                "plain": "e6fff560",
                "symbol": "9b0b3f49"
            }
        },
        "v3": {
            "default": {
                "plain": "6d14e4e2",
                "symbol": "fd4342be"
            }
        }
    },
    "fill.people.circle-user": {
        "default": {
            "default": {
                "plain": "53121b1d",
                "symbol": "270c397e"
            }
        },
        "v3": {
            "default": {
                "plain": "57129bb6",
                "symbol": "b2a2db5d"
            }
        }
    },
    "fill.people.emoji-angry": {
        "default": {
            "default": {
                "plain": "0b090f78",
                "symbol": "ca8a4dd2"
            }
        },
        "v3": {
            "default": {
                "plain": "4a8e326a",
                "symbol": "470e11e4"
            }
        }
    },
    "fill.people.emoji-dislike": {
        "default": {
            "default": {
                "plain": "9202b203",
                "symbol": "b7cab5a2"
            }
        },
        "v3": {
            "default": {
                "plain": "eb84a125",
                "symbol": "52059d64"
            }
        }
    },
    "fill.people.emoji-heart": {
        "default": {
            "default": {
                "plain": "3c041422",
                "symbol": "c64ba6d5"
            }
        },
        "v3": {
            "default": {
                "plain": "42ce38bb",
                "symbol": "77933006"
            }
        }
    },
    "fill.people.emoji-like": {
        "default": {
            "default": {
                "plain": "51ceb9ad",
                "symbol": "df586dbc"
            }
        },
        "v3": {
            "default": {
                "plain": "79b0554c",
                "symbol": "c9ef983e"
            }
        }
    },
    "fill.people.emoji-meh": {
        "default": {
            "default": {
                "plain": "2ac4d960",
                "symbol": "49cd6311"
            }
        },
        "v3": {
            "default": {
                "plain": "dd2a2b57",
                "symbol": "fbabc41c"
            }
        }
    },
    "fill.people.emoji-normal": {
        "default": {
            "default": {
                "plain": "414eb93c",
                "symbol": "8b53de12"
            }
        },
        "v3": {
            "default": {
                "plain": "84d900cb",
                "symbol": "4f5f1129"
            }
        }
    },
    "fill.people.family": {
        "default": {
            "default": {
                "plain": "ebc43fe6",
                "symbol": "f0584cc3"
            }
        },
        "v3": {
            "default": {
                "plain": "7576e6ba",
                "symbol": "d5cd458e"
            }
        }
    },
    "fill.people.family2": {
        "default": {
            "default": {
                "plain": "5a6ea64b",
                "symbol": "acdafdfc"
            }
        },
        "v3": {
            "default": {
                "plain": "7576e6ba",
                "symbol": "d5cd458e"
            }
        }
    },
    "fill.people.gender": {
        "default": {
            "default": {
                "plain": "8fa92730",
                "symbol": "57aafb9f"
            }
        },
        "v3": {
            "default": {
                "plain": "d47508ec",
                "symbol": "65d0a5a2"
            }
        }
    },
    "fill.people.group-people": {
        "default": {
            "default": {
                "plain": "d2b8b8d2",
                "symbol": "623f80dc"
            }
        },
        "v3": {
            "default": {
                "plain": "b58b11f0",
                "symbol": "3b05cd1a"
            }
        }
    },
    "fill.people.group-star": {
        "default": {
            "default": {
                "plain": "6a1992f8",
                "symbol": "22a1a486"
            }
        },
        "v3": {
            "default": {
                "plain": "b58b11f0",
                "symbol": "3b05cd1a"
            }
        }
    },
    "fill.people.infant": {
        "default": {
            "default": {
                "plain": "2ae98fc9",
                "symbol": "dee2ba7a"
            }
        },
        "v3": {
            "default": {
                "plain": "d3173c6f",
                "symbol": "9a99a210"
            }
        }
    },
    "fill.people.kid": {
        "default": {
            "default": {
                "plain": "beff3208",
                "symbol": "0807955a"
            }
        },
        "v3": {
            "default": {
                "plain": "2ec76bcf",
                "symbol": "355db50e"
            }
        }
    },
    "fill.people.people": {
        "default": {
            "default": {
                "plain": "f1040388",
                "symbol": "1a508b74"
            }
        },
        "v3": {
            "default": {
                "plain": "b58b11f0",
                "symbol": "3b05cd1a"
            }
        }
    },
    "fill.people.sit": {
        "default": {
            "default": {
                "plain": "5e73d153",
                "symbol": "4cd4426e"
            }
        },
        "v3": {
            "default": {
                "plain": "8cdf40cd",
                "symbol": "628cd837"
            }
        }
    },
    "fill.people.traveler": {
        "default": {
            "default": {
                "plain": "e40676c5",
                "symbol": "07a49b06"
            }
        },
        "v3": {
            "default": {
                "plain": "5d165edc",
                "symbol": "fbe03d3e"
            }
        }
    },
    "fill.people.user": {
        "default": {
            "default": {
                "plain": "b7339e3c",
                "symbol": "7f5d4ac0"
            }
        },
        "v3": {
            "default": {
                "plain": "92d8260e",
                "symbol": "98433010"
            }
        }
    },
    "fill.people.user-add": {
        "default": {
            "default": {
                "plain": "8cfa3263",
                "symbol": "e3e8d1b1"
            }
        },
        "v3": {
            "default": {
                "plain": "3e050722",
                "symbol": "15c1ea51"
            }
        }
    },
    "fill.people.user-address": {
        "default": {
            "default": {
                "plain": "b835057a",
                "symbol": "f13ab36f"
            }
        },
        "v3": {
            "default": {
                "plain": "8c4e50be",
                "symbol": "2e80da89"
            }
        }
    },
    "fill.people.user-detail": {
        "default": {
            "default": {
                "plain": "6944b081",
                "symbol": "c448e593"
            }
        },
        "v3": {
            "default": {
                "plain": "be553faf",
                "symbol": "6e0923db"
            }
        }
    },
    "fill.people.user-question": {
        "default": {
            "default": {
                "plain": "8f2c97fe",
                "symbol": "8aa666b4"
            }
        },
        "v3": {
            "default": {
                "plain": "efe734f9",
                "symbol": "c044744c"
            }
        }
    },
    "fill.people.user-setting": {
        "default": {
            "default": {
                "plain": "ef5dafb6",
                "symbol": "e077c386"
            }
        },
        "v3": {
            "default": {
                "plain": "b3bde733",
                "symbol": "bd09c391"
            }
        }
    },
    "fill.people.user-star": {
        "default": {
            "default": {
                "plain": "338ff24d",
                "symbol": "1002380e"
            }
        },
        "v3": {
            "default": {
                "plain": "f79ef164",
                "symbol": "188072d4"
            }
        }
    },
    "fill.people.users": {
        "default": {
            "default": {
                "plain": "636810b3",
                "symbol": "8e8f63b3"
            }
        },
        "v3": {
            "default": {
                "plain": "a9325c6e",
                "symbol": "09dfb020"
            }
        }
    },
    "fill.service.alarm": {
        "default": {
            "default": {
                "plain": "a9f5c584",
                "symbol": "9e95a326"
            }
        },
        "v3": {
            "default": {
                "plain": "5b079103",
                "symbol": "ae464570"
            }
        }
    },
    "fill.service.babysitter": {
        "default": {
            "default": {
                "plain": "bf9f2e03",
                "symbol": "df33547c"
            }
        },
        "v3": {
            "default": {
                "plain": "9add84bf",
                "symbol": "fda79a14"
            }
        }
    },
    "fill.service.braille": {
        "default": {
            "default": {
                "plain": "cf3a85bd",
                "symbol": "47e4fd4b"
            }
        },
        "v3": {
            "default": {
                "plain": "6fc609d9",
                "symbol": "53790efd"
            }
        }
    },
    "fill.service.call": {
        "default": {
            "default": {
                "plain": "2ea1d35b",
                "symbol": "1ed5bbb6"
            }
        },
        "v3": {
            "default": {
                "plain": "250dcc5d",
                "symbol": "d44e8e47"
            }
        }
    },
    "fill.service.call-fast": {
        "default": {
            "default": {
                "plain": "b1f21b5a",
                "symbol": "9eedd8f2"
            }
        }
    },
    "fill.service.call-morning": {
        "default": {
            "default": {
                "plain": "f917b843",
                "symbol": "d101ee83"
            }
        },
        "v3": {
            "default": {
                "plain": "acba4592",
                "symbol": "e9ac00da"
            }
        }
    },
    "fill.service.call-no": {
        "default": {
            "default": {
                "plain": "4fbba6cc",
                "symbol": "30c4e4f9"
            }
        },
        "v3": {
            "default": {
                "plain": "6a5715fc",
                "symbol": "475d1945"
            }
        }
    },
    "fill.service.call-time": {
        "default": {
            "default": {
                "plain": "8bc832e6",
                "symbol": "af37e3a0"
            }
        }
    },
    "fill.service.call2": {
        "default": {
            "default": {
                "plain": "6a3ceb2e",
                "symbol": "23d28847"
            }
        },
        "v3": {
            "default": {
                "plain": "acba4592",
                "symbol": "e9ac00da"
            }
        }
    },
    "fill.service.clean": {
        "default": {
            "default": {
                "plain": "6dcfa31c",
                "symbol": "411d8cb8"
            }
        },
        "v3": {
            "default": {
                "plain": "14b2f509",
                "symbol": "ba8642a2"
            }
        }
    },
    "fill.service.cs": {
        "default": {
            "default": {
                "plain": "a1ba82ff",
                "symbol": "1035d506"
            }
        },
        "v3": {
            "default": {
                "plain": "ca29caa1",
                "symbol": "3ccb8df1"
            }
        }
    },
    "fill.service.cs-24": {
        "default": {
            "default": {
                "plain": "bb140fb2",
                "symbol": "61e48ac0"
            }
        },
        "v3": {
            "default": {
                "plain": "a69ddd00",
                "symbol": "eb9bf8ad"
            }
        }
    },
    "fill.service.delivery": {
        "default": {
            "default": {
                "plain": "d9b9736a",
                "symbol": "4d823183"
            }
        },
        "v3": {
            "default": {
                "plain": "a164f1ac",
                "symbol": "b798fe5a"
            }
        }
    },
    "fill.service.doorman": {
        "default": {
            "default": {
                "plain": "7eb12878",
                "symbol": "307f75dc"
            }
        },
        "v3": {
            "default": {
                "plain": "7e01cb1f",
                "symbol": "f3d9ac25"
            }
        }
    },
    "fill.service.guide": {
        "default": {
            "default": {
                "plain": "6d59856f",
                "symbol": "5ff3c70f"
            }
        },
        "v3": {
            "default": {
                "plain": "659cd627",
                "symbol": "c7825d44"
            }
        }
    },
    "fill.service.guidedog": {
        "default": {
            "default": {
                "plain": "67c4829e",
                "symbol": "3bb85dd7"
            }
        },
        "v3": {
            "default": {
                "plain": "c06c0d34",
                "symbol": "f30928ac"
            }
        }
    },
    "fill.service.hand-cash": {
        "default": {
            "default": {
                "plain": "de1f03cb",
                "symbol": "7f225f73"
            }
        },
        "v3": {
            "default": {
                "plain": "ac9be886",
                "symbol": "f41b9f4b"
            }
        }
    },
    "fill.service.laundry": {
        "default": {
            "default": {
                "plain": "17c4727d",
                "symbol": "6e4c990c"
            }
        },
        "v3": {
            "default": {
                "plain": "f674401d",
                "symbol": "f89a8be7"
            }
        }
    },
    "fill.service.massage": {
        "default": {
            "default": {
                "plain": "05760a5a",
                "symbol": "57b5d110"
            }
        },
        "v3": {
            "default": {
                "plain": "e70c2fd0",
                "symbol": "72c823d4"
            }
        }
    },
    "fill.service.massage-foot": {
        "default": {
            "default": {
                "plain": "45ed7d01",
                "symbol": "61c2d92e"
            }
        },
        "v3": {
            "default": {
                "plain": "e10112bd",
                "symbol": "12f1bc9a"
            }
        }
    },
    "fill.service.postal": {
        "default": {
            "default": {
                "plain": "05b3d882",
                "symbol": "3617dd23"
            }
        },
        "v3": {
            "default": {
                "plain": "d3b8264c",
                "symbol": "44ebec53"
            }
        }
    },
    "fill.service.reception": {
        "default": {
            "default": {
                "plain": "950bd3be",
                "symbol": "683b0a43"
            }
        },
        "v3": {
            "default": {
                "plain": "c9965440",
                "symbol": "26d05bdb"
            }
        }
    },
    "fill.service.reception-24": {
        "default": {
            "default": {
                "plain": "4c4ecc61",
                "symbol": "dbd720d2"
            }
        },
        "v3": {
            "default": {
                "plain": "792f1b4a",
                "symbol": "3295274a"
            }
        }
    },
    "fill.service.reception-am": {
        "default": {
            "default": {
                "plain": "484fef1a",
                "symbol": "ff83deb1"
            }
        },
        "v3": {
            "default": {
                "plain": "c9965440",
                "symbol": "26d05bdb"
            }
        }
    },
    "fill.service.reception-check": {
        "default": {
            "default": {
                "plain": "e98b6df0",
                "symbol": "e45d47e3"
            }
        },
        "v3": {
            "default": {
                "plain": "106a19d3",
                "symbol": "1750ba94"
            }
        }
    },
    "fill.service.reception-flight": {
        "default": {
            "default": {
                "plain": "9f394252",
                "symbol": "7002ace6"
            }
        },
        "v3": {
            "default": {
                "plain": "0b40d7ce",
                "symbol": "0aff102c"
            }
        }
    },
    "fill.service.reception-globe": {
        "default": {
            "default": {
                "plain": "4bee78c3",
                "symbol": "5f5527c6"
            }
        },
        "v3": {
            "default": {
                "plain": "c9965440",
                "symbol": "26d05bdb"
            }
        }
    },
    "fill.service.reception-pm": {
        "default": {
            "default": {
                "plain": "2c190a74",
                "symbol": "fd54fe64"
            }
        },
        "v3": {
            "default": {
                "plain": "c9965440",
                "symbol": "26d05bdb"
            }
        }
    },
    "fill.service.reception-vip": {
        "default": {
            "default": {
                "plain": "7a4ee375",
                "symbol": "6a5cb812"
            }
        },
        "v3": {
            "default": {
                "plain": "c9965440",
                "symbol": "26d05bdb"
            }
        }
    },
    "fill.service.roomservice": {
        "default": {
            "default": {
                "plain": "673a9314",
                "symbol": "4cfe2b4e"
            }
        },
        "v3": {
            "default": {
                "plain": "865bfcb1",
                "symbol": "0926698e"
            }
        }
    },
    "fill.service.roomservice-24": {
        "default": {
            "default": {
                "plain": "82d110a3",
                "symbol": "b1b67a59"
            }
        },
        "v3": {
            "default": {
                "plain": "865bfcb1",
                "symbol": "0926698e"
            }
        }
    },
    "fill.service.security": {
        "default": {
            "default": {
                "plain": "ff9624f0",
                "symbol": "d940c9b8"
            }
        },
        "v3": {
            "default": {
                "plain": "10e50236",
                "symbol": "343e695a"
            }
        }
    },
    "fill.service.signlanguage": {
        "default": {
            "default": {
                "plain": "d033fad0",
                "symbol": "98170325"
            }
        },
        "v3": {
            "default": {
                "plain": "49b5ade1",
                "symbol": "af0c8dd4"
            }
        }
    },
    "fill.service.theraphy": {
        "default": {
            "default": {
                "plain": "1d202cb9",
                "symbol": "93bde86b"
            }
        },
        "v3": {
            "default": {
                "plain": "6da326ab",
                "symbol": "0aebfcd7"
            }
        }
    },
    "fill.service.valet": {
        "default": {
            "default": {
                "plain": "ea9d6c54",
                "symbol": "d7ed1cf1"
            }
        },
        "v3": {
            "default": {
                "plain": "28395ff7",
                "symbol": "148b9ee2"
            }
        }
    },
    "fill.symbol.24hours": {
        "default": {
            "default": {
                "plain": "56926906",
                "symbol": "a826c652"
            }
        },
        "v3": {
            "default": {
                "plain": "792f1b4a",
                "symbol": "3295274a"
            }
        }
    },
    "fill.symbol.a11y": {
        "default": {
            "default": {
                "plain": "646850e8",
                "symbol": "8daf2f1a"
            }
        },
        "v3": {
            "default": {
                "plain": "f737018c",
                "symbol": "e377ee66"
            }
        }
    },
    "fill.symbol.ai-generated": {
        "default": {
            "default": {
                "plain": "a3827867",
                "symbol": "5fcbba7e"
            }
        },
        "v3": {
            "default": {
                "plain": "05eb4e81",
                "symbol": "cdeaf495"
            }
        }
    },
    "fill.symbol.bank": {
        "default": {
            "default": {
                "plain": "fbc90bb2",
                "symbol": "366bc72a"
            }
        },
        "v3": {
            "default": {
                "plain": "55d90f9f",
                "symbol": "c9bcc536"
            }
        }
    },
    "fill.symbol.bell": {
        "default": {
            "default": {
                "plain": "4fe43e56",
                "symbol": "803eb9a3"
            }
        },
        "v3": {
            "default": {
                "plain": "922e2f8f",
                "symbol": "d4060fcd"
            }
        }
    },
    "fill.symbol.bell-no": {
        "default": {
            "default": {
                "plain": "72e85d99",
                "symbol": "96573ae3"
            }
        },
        "v3": {
            "default": {
                "plain": "8108ca82",
                "symbol": "c03cccac"
            }
        }
    },
    "fill.symbol.bin": {
        "default": {
            "default": {
                "plain": "e14a31fc",
                "symbol": "20a71481"
            }
        },
        "v3": {
            "default": {
                "plain": "96ffbe62",
                "symbol": "094fcb3f"
            }
        }
    },
    "fill.symbol.bookmark": {
        "default": {
            "default": {
                "plain": "16f03427",
                "symbol": "8ea80555"
            }
        },
        "v3": {
            "default": {
                "plain": "ff792509",
                "symbol": "f471a971"
            }
        }
    },
    "fill.symbol.box-star": {
        "default": {
            "default": {
                "plain": "06c1d1ef",
                "symbol": "7b76f3fc"
            }
        },
        "v3": {
            "default": {
                "plain": "5d355b96",
                "symbol": "2eff8d93"
            }
        }
    },
    "fill.symbol.box-star-half": {
        "default": {
            "default": {
                "plain": "3904cea6",
                "symbol": "386f9c2c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "37c8fed4",
                "symbol": "c70071ee"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.bubble-chat": {
        "default": {
            "default": {
                "plain": "8355fe1c",
                "symbol": "87297501"
            }
        },
        "v3": {
            "default": {
                "plain": "191037c8",
                "symbol": "8bfbcd96"
            }
        }
    },
    "fill.symbol.bubble-chat-fast": {
        "default": {
            "default": {
                "plain": "7f3e6510",
                "symbol": "cef27d1a"
            }
        }
    },
    "fill.symbol.bubble-language": {
        "default": {
            "default": {
                "plain": "ff0b6dc9",
                "symbol": "7247e08b"
            }
        },
        "v3": {
            "default": {
                "plain": "edba44e2",
                "symbol": "07ee65ca"
            }
        }
    },
    "fill.symbol.bubble-language-no": {
        "default": {
            "default": {
                "plain": "2a63689d",
                "symbol": "e3d18d16"
            }
        },
        "v3": {
            "default": {
                "plain": "2d988d8d",
                "symbol": "49780320"
            }
        }
    },
    "fill.symbol.bubble-sparkle": {
        "default": {
            "default": {
                "plain": "0f60b5bc",
                "symbol": "28727a36"
            }
        },
        "v3": {
            "default": {
                "plain": "1e06f195",
                "symbol": "3ba87026"
            }
        }
    },
    "fill.symbol.bubble-text": {
        "default": {
            "default": {
                "plain": "0e2930e1",
                "symbol": "ad62eb99"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "6459b9a5",
                "symbol": "169c0e1a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.bubble-write": {
        "default": {
            "default": {
                "plain": "8d14264a",
                "symbol": "fedea2f7"
            }
        },
        "v3": {
            "default": {
                "plain": "ca91aa20",
                "symbol": "b66f4cb6"
            }
        }
    },
    "fill.symbol.bubbles": {
        "default": {
            "default": {
                "plain": "acfa511c",
                "symbol": "cfba55ba"
            }
        },
        "v3": {
            "default": {
                "plain": "1b3123a0",
                "symbol": "c0b3ce97"
            }
        }
    },
    "fill.symbol.bug": {
        "default": {
            "default": {
                "plain": "7c36ff64",
                "symbol": "fa68d67e"
            }
        },
        "v3": {
            "default": {
                "plain": "04bc4155",
                "symbol": "5231bc13"
            }
        }
    },
    "fill.symbol.bulk-action": {
        "default": {
            "default": {
                "plain": "385f22e8",
                "symbol": "c4dc8613"
            }
        },
        "v3": {
            "default": {
                "plain": "6e7cd6b1",
                "symbol": "da265b0b"
            }
        }
    },
    "fill.symbol.calendar": {
        "default": {
            "default": {
                "plain": "03311b1f",
                "symbol": "92111b0e"
            }
        },
        "v3": {
            "default": {
                "plain": "6cb33ba7",
                "symbol": "4c5ea39d"
            }
        }
    },
    "fill.symbol.calendar-30": {
        "default": {
            "default": {
                "plain": "c69e2a33",
                "symbol": "173788f3"
            }
        },
        "v3": {
            "default": {
                "plain": "6e54b20d",
                "symbol": "5c3cef13"
            }
        }
    },
    "fill.symbol.calendar-7": {
        "default": {
            "default": {
                "plain": "295dbee2",
                "symbol": "ecc9ecd3"
            }
        },
        "v3": {
            "default": {
                "plain": "f09339b1",
                "symbol": "e7cb1929"
            }
        }
    },
    "fill.symbol.calendar-cancel": {
        "default": {
            "default": {
                "plain": "6c132842",
                "symbol": "cab46eb6"
            }
        },
        "v3": {
            "default": {
                "plain": "75b1e778",
                "symbol": "034b8356"
            }
        }
    },
    "fill.symbol.calendar-cancel-check": {
        "default": {
            "default": {
                "plain": "5b91bb10",
                "symbol": "28ed7a35"
            }
        },
        "v3": {
            "default": {
                "plain": "c920ff97",
                "symbol": "f64204fd"
            }
        }
    },
    "fill.symbol.calendar-cancel-no": {
        "default": {
            "default": {
                "plain": "ff78dfb2",
                "symbol": "4b6bbb8f"
            }
        },
        "v3": {
            "default": {
                "plain": "5125b34f",
                "symbol": "a9246fd4"
            }
        }
    },
    "fill.symbol.calendar-cancel-pay": {
        "default": {
            "default": {
                "plain": "0f6ef4fa",
                "symbol": "e749569d"
            }
        },
        "v3": {
            "default": {
                "plain": "e7bc5a8c",
                "symbol": "2f15898b"
            }
        }
    },
    "fill.symbol.calendar-change": {
        "default": {
            "default": {
                "plain": "ea114146",
                "symbol": "e135cfce"
            }
        },
        "v3": {
            "default": {
                "plain": "11dee9d4",
                "symbol": "da593ce4"
            }
        }
    },
    "fill.symbol.calendar-change-check": {
        "default": {
            "default": {
                "plain": "829cad97",
                "symbol": "65805767"
            }
        },
        "v3": {
            "default": {
                "plain": "05d0d8f7",
                "symbol": "67d6428c"
            }
        }
    },
    "fill.symbol.calendar-change-no": {
        "default": {
            "default": {
                "plain": "83cf6476",
                "symbol": "56d786c3"
            }
        },
        "v3": {
            "default": {
                "plain": "c1842d4f",
                "symbol": "63d41d01"
            }
        }
    },
    "fill.symbol.calendar-change-pay": {
        "default": {
            "default": {
                "plain": "accb104a",
                "symbol": "61f0ac3d"
            }
        },
        "v3": {
            "default": {
                "plain": "145cf757",
                "symbol": "a222ad32"
            }
        }
    },
    "fill.symbol.calendar-check": {
        "default": {
            "default": {
                "plain": "5869052b",
                "symbol": "b05daf44"
            }
        },
        "v3": {
            "default": {
                "plain": "dd0f0043",
                "symbol": "370337bc"
            }
        }
    },
    "fill.symbol.calendar-in": {
        "default": {
            "default": {
                "plain": "3ee5be78",
                "symbol": "7545f892"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "6fdcc20e",
                "symbol": "eea4a646"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.calendar-out": {
        "default": {
            "default": {
                "plain": "c2689b7d",
                "symbol": "01de3df2"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "b8578370",
                "symbol": "418fc397"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.calendar-pay": {
        "default": {
            "default": {
                "plain": "4bb59dd6",
                "symbol": "e222edbe"
            }
        },
        "v3": {
            "default": {
                "plain": "fe265975",
                "symbol": "b784689d"
            }
        }
    },
    "fill.symbol.card": {
        "default": {
            "default": {
                "plain": "a51eaf8a",
                "symbol": "cc11cc21"
            }
        },
        "v3": {
            "default": {
                "plain": "ebdba579",
                "symbol": "3df2199a"
            }
        }
    },
    "fill.symbol.card-no": {
        "default": {
            "default": {
                "plain": "46fb002c",
                "symbol": "5b3309d1"
            }
        },
        "v3": {
            "default": {
                "plain": "0839c048",
                "symbol": "31e9bc27"
            }
        }
    },
    "fill.symbol.cart": {
        "default": {
            "default": {
                "plain": "53576722",
                "symbol": "6ba8d68c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "da8c48ec",
                "symbol": "19b2cf28"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.cart-add": {
        "default": {
            "default": {
                "plain": "11c38cdb",
                "symbol": "76613661"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f67a3aae",
                "symbol": "0527ce10"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.cart-check": {
        "default": {
            "default": {
                "plain": "a8a8541a",
                "symbol": "d1aee47a"
            },
            "rtl": {
                "plain": "1195e705",
                "symbol": "471d5585"
            }
        },
        "v3": {
            "default": {
                "plain": "0975b0ba",
                "symbol": "6765d444"
            },
            "rtl": {
                "plain": "62a009b0",
                "symbol": "8e93073e"
            }
        }
    },
    "fill.symbol.cart-empty": {
        "default": {
            "default": {
                "plain": "2cc3d2e2",
                "symbol": "70008833"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "cc5f06cc",
                "symbol": "28a81b4a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.cfar": {
        "default": {
            "default": {
                "plain": "e9c9fc0a",
                "symbol": "994b8d5e"
            }
        },
        "v3": {
            "default": {
                "plain": "e4781aab",
                "symbol": "ff51b60b"
            }
        }
    },
    "fill.symbol.check": {
        "default": {
            "default": {
                "plain": "1c3d2bc6",
                "symbol": "4d1e0b07"
            }
        },
        "v3": {
            "default": {
                "plain": "7db6cf82",
                "symbol": "be0ccff3"
            }
        }
    },
    "fill.symbol.church": {
        "default": {
            "default": {
                "plain": "d76eb475",
                "symbol": "68af87e4"
            }
        },
        "v3": {
            "default": {
                "plain": "d6e3e49b",
                "symbol": "2ece206f"
            }
        }
    },
    "fill.symbol.circle": {
        "default": {
            "default": {
                "plain": "01ae4a0f",
                "symbol": "4273402f"
            }
        },
        "v3": {
            "default": {
                "plain": "03858931",
                "symbol": "e3ed991b"
            }
        }
    },
    "fill.symbol.circle-card": {
        "default": {
            "default": {
                "plain": "f987a22e",
                "symbol": "1cee0191"
            }
        },
        "v3": {
            "default": {
                "plain": "dd98260f",
                "symbol": "83b46742"
            }
        }
    },
    "fill.symbol.circle-card-no": {
        "default": {
            "default": {
                "plain": "6b09d84f",
                "symbol": "2c65f876"
            }
        },
        "v3": {
            "default": {
                "plain": "e8fe84db",
                "symbol": "1ed4cc4a"
            }
        }
    },
    "fill.symbol.circle-check": {
        "default": {
            "default": {
                "plain": "21657cda",
                "symbol": "d086d833"
            }
        },
        "v3": {
            "default": {
                "plain": "6df1e704",
                "symbol": "559b226f"
            }
        }
    },
    "fill.symbol.circle-close": {
        "default": {
            "default": {
                "plain": "ae7e5857",
                "symbol": "60ed9e0a"
            }
        },
        "v3": {
            "default": {
                "plain": "422f4913",
                "symbol": "24e65611"
            }
        }
    },
    "fill.symbol.circle-exclamation": {
        "default": {
            "default": {
                "plain": "2950defa",
                "symbol": "3c6587d8"
            }
        },
        "v3": {
            "default": {
                "plain": "5cfaeebf",
                "symbol": "be27f58d"
            }
        }
    },
    "fill.symbol.circle-flight": {
        "default": {
            "default": {
                "plain": "9d977352",
                "symbol": "f829e8c1"
            }
        },
        "v3": {
            "default": {
                "plain": "8d93f9e3",
                "symbol": "e39f0aed"
            }
        }
    },
    "fill.symbol.circle-gift": {
        "default": {
            "default": {
                "plain": "cd93ae87",
                "symbol": "5a88c601"
            }
        },
        "v3": {
            "default": {
                "plain": "4a87bafd",
                "symbol": "ec9563a6"
            }
        }
    },
    "fill.symbol.circle-half": {
        "default": {
            "default": {
                "plain": "4b0dd5e1",
                "symbol": "05d14d01"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "1998369d",
                "symbol": "76596064"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.circle-home": {
        "default": {
            "default": {
                "plain": "534a7b1d",
                "symbol": "d5c5dc18"
            }
        },
        "v3": {
            "default": {
                "plain": "f86203de",
                "symbol": "dacb5ed5"
            }
        }
    },
    "fill.symbol.circle-home-check": {
        "default": {
            "default": {
                "plain": "03dc4b6a",
                "symbol": "e14be8a7"
            }
        },
        "v3": {
            "default": {
                "plain": "4ddcacc2",
                "symbol": "a066db27"
            }
        }
    },
    "fill.symbol.circle-info": {
        "default": {
            "default": {
                "plain": "d4e08ff5",
                "symbol": "6d6a8f1d"
            }
        },
        "v3": {
            "default": {
                "plain": "544e93ff",
                "symbol": "f3b91897"
            }
        }
    },
    "fill.symbol.circle-lightbulb": {
        "default": {
            "default": {
                "plain": "dcc50f59",
                "symbol": "790e2c33"
            }
        },
        "v3": {
            "default": {
                "plain": "88bb1cd3",
                "symbol": "883346e2"
            }
        }
    },
    "fill.symbol.circle-lightning1": {
        "default": {
            "default": {
                "plain": "02ce1d71",
                "symbol": "d34c4524"
            }
        },
        "v3": {
            "default": {
                "plain": "a8341537",
                "symbol": "9a8f4382"
            }
        }
    },
    "fill.symbol.circle-mandarin": {
        "default": {
            "default": {
                "plain": "5b81d73a",
                "symbol": "745a1103"
            }
        },
        "v3": {
            "default": {
                "plain": "da5cd582",
                "symbol": "66ea1a49"
            }
        }
    },
    "fill.symbol.circle-minus": {
        "default": {
            "default": {
                "plain": "647a1771",
                "symbol": "ba9aeba9"
            }
        },
        "v3": {
            "default": {
                "plain": "bc01fe76",
                "symbol": "4e059529"
            }
        }
    },
    "fill.symbol.circle-pin": {
        "default": {
            "default": {
                "plain": "ffd8fed1",
                "symbol": "585c12be"
            }
        },
        "v3": {
            "default": {
                "plain": "d0f0cded",
                "symbol": "2066d2a1"
            }
        }
    },
    "fill.symbol.circle-plus": {
        "default": {
            "default": {
                "plain": "50acfed4",
                "symbol": "fe6954f7"
            }
        },
        "v3": {
            "default": {
                "plain": "4397a4ab",
                "symbol": "be3dace1"
            }
        }
    },
    "fill.symbol.circle-question": {
        "default": {
            "default": {
                "plain": "4d68b31e",
                "symbol": "d77ba9dd"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "5cef2d4d",
                "symbol": "278c82fa"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.circle-ribbon": {
        "default": {
            "default": {
                "plain": "3aa7ab93",
                "symbol": "42c86462"
            }
        },
        "v3": {
            "default": {
                "plain": "0992505b",
                "symbol": "9f2f17f5"
            }
        }
    },
    "fill.symbol.circle-star": {
        "default": {
            "default": {
                "plain": "f9bd2b66",
                "symbol": "d34bd4de"
            }
        },
        "v3": {
            "default": {
                "plain": "178255a4",
                "symbol": "ec03371f"
            }
        }
    },
    "fill.symbol.circle-start": {
        "default": {
            "default": {
                "plain": "73eae626",
                "symbol": "1c153a17"
            }
        },
        "v3": {
            "default": {
                "plain": "6cd616b6",
                "symbol": "04ed008d"
            }
        }
    },
    "fill.symbol.circle-stop": {
        "default": {
            "default": {
                "plain": "85578e9d",
                "symbol": "2971cebc"
            }
        },
        "v3": {
            "default": {
                "plain": "005726ec",
                "symbol": "6153dea5"
            }
        }
    },
    "fill.symbol.circle-tag": {
        "default": {
            "default": {
                "plain": "bd4c3d5b",
                "symbol": "f1bd9b56"
            }
        },
        "v3": {
            "default": {
                "plain": "29ae27c8",
                "symbol": "b1699e7b"
            }
        }
    },
    "fill.symbol.circle-ticket": {
        "default": {
            "default": {
                "plain": "1689db3c",
                "symbol": "9189d5ad"
            }
        },
        "v3": {
            "default": {
                "plain": "320ea971",
                "symbol": "7f0437ac"
            }
        }
    },
    "fill.symbol.city": {
        "default": {
            "default": {
                "plain": "aaccdffa",
                "symbol": "864c8b13"
            }
        },
        "v3": {
            "default": {
                "plain": "8fab9359",
                "symbol": "f3c4a301"
            }
        }
    },
    "fill.symbol.city-pin": {
        "default": {
            "default": {
                "plain": "dd7280bf",
                "symbol": "b78fcc58"
            }
        },
        "v3": {
            "default": {
                "plain": "1be24fe9",
                "symbol": "f8c150d4"
            }
        }
    },
    "fill.symbol.clip": {
        "default": {
            "default": {
                "plain": "ede82a47",
                "symbol": "1dbf4764"
            }
        },
        "v3": {
            "default": {
                "plain": "dfe01bb2",
                "symbol": "280507c3"
            }
        }
    },
    "fill.symbol.close": {
        "default": {
            "default": {
                "plain": "e68e5d6e",
                "symbol": "6c03f3aa"
            }
        },
        "v3": {
            "default": {
                "plain": "2feef050",
                "symbol": "a5f5300e"
            }
        }
    },
    "fill.symbol.closed-caption": {
        "default": {
            "default": {
                "plain": "3d793167",
                "symbol": "c236fd99"
            }
        },
        "v3": {
            "default": {
                "plain": "e553fd3d",
                "symbol": "f1f07df1"
            }
        }
    },
    "fill.symbol.coordinate": {
        "default": {
            "default": {
                "plain": "bbb1c200",
                "symbol": "c4bd3baa"
            }
        },
        "v3": {
            "default": {
                "plain": "470ed45a",
                "symbol": "ce73bfc1"
            }
        }
    },
    "fill.symbol.copy": {
        "default": {
            "default": {
                "plain": "420d0788",
                "symbol": "3bc6b0f6"
            }
        }
    },
    "fill.symbol.currency": {
        "default": {
            "default": {
                "plain": "eca7aa37",
                "symbol": "be7d4d2c"
            }
        }
    },
    "fill.symbol.currency-baht": {
        "default": {
            "default": {
                "plain": "5f33c753",
                "symbol": "157ca770"
            }
        },
        "v3": {
            "default": {
                "plain": "063393ea",
                "symbol": "24eab3f5"
            }
        }
    },
    "fill.symbol.deal-percent": {
        "default": {
            "default": {
                "plain": "c209abea",
                "symbol": "e7098ea4"
            }
        },
        "v3": {
            "default": {
                "plain": "d79a652e",
                "symbol": "182f63a5"
            }
        }
    },
    "fill.symbol.diamond": {
        "default": {
            "default": {
                "plain": "36338205",
                "symbol": "405bd424"
            }
        },
        "v3": {
            "default": {
                "plain": "acf7b384",
                "symbol": "8ead3d88"
            }
        }
    },
    "fill.symbol.diamond-half": {
        "default": {
            "default": {
                "plain": "3f46a4ea",
                "symbol": "a29612bd"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "b20ff3ba",
                "symbol": "0c1573a5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.doc-check": {
        "default": {
            "default": {
                "plain": "da9dd741",
                "symbol": "5fd3c34b"
            }
        },
        "v3": {
            "default": {
                "plain": "6df1e704",
                "symbol": "559b226f"
            }
        }
    },
    "fill.symbol.doc-checklist": {
        "default": {
            "default": {
                "plain": "8ca3aaba",
                "symbol": "bc015f35"
            }
        },
        "v3": {
            "default": {
                "plain": "28551d38",
                "symbol": "fc482455"
            }
        }
    },
    "fill.symbol.doc-clip": {
        "default": {
            "default": {
                "plain": "c64fcde9",
                "symbol": "0214c3f5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f580383f",
                "symbol": "f3cad8fc"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.doc-close": {
        "default": {
            "default": {
                "plain": "6a534c40",
                "symbol": "35537c84"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f0f4af76",
                "symbol": "5f1ce22c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.doc-csv": {
        "default": {
            "default": {
                "plain": "12489ec2",
                "symbol": "11f4775b"
            }
        },
        "v3": {
            "default": {
                "plain": "63b4a261",
                "symbol": "e242d77a"
            }
        }
    },
    "fill.symbol.doc-download": {
        "default": {
            "default": {
                "plain": "f3f1c6d2",
                "symbol": "6f53a58f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "63b4a261",
                "symbol": "e242d77a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.doc-exclamation": {
        "default": {
            "default": {
                "plain": "2b058160",
                "symbol": "381d0f7a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "5cfaeebf",
                "symbol": "be27f58d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.doc-info": {
        "default": {
            "default": {
                "plain": "dbe55650",
                "symbol": "31598b8f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "19986387",
                "symbol": "05350dc8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.doc-pay": {
        "default": {
            "default": {
                "plain": "77cabb24",
                "symbol": "533ae6a7"
            }
        },
        "v3": {
            "default": {
                "plain": "850a468a",
                "symbol": "8ca53486"
            }
        }
    },
    "fill.symbol.doc-pdf": {
        "default": {
            "default": {
                "plain": "21ddc596",
                "symbol": "04246cb8"
            }
        },
        "v3": {
            "default": {
                "plain": "63b4a261",
                "symbol": "e242d77a"
            }
        }
    },
    "fill.symbol.doc-write": {
        "default": {
            "default": {
                "plain": "77645961",
                "symbol": "213ba698"
            }
        },
        "v3": {
            "default": {
                "plain": "47838b47",
                "symbol": "d7963bac"
            }
        }
    },
    "fill.symbol.doc-xls": {
        "default": {
            "default": {
                "plain": "f4e8afb6",
                "symbol": "5a12c94a"
            }
        },
        "v3": {
            "default": {
                "plain": "63b4a261",
                "symbol": "e242d77a"
            }
        }
    },
    "fill.symbol.document": {
        "default": {
            "default": {
                "plain": "afa19c62",
                "symbol": "fd365ace"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "eedb334d",
                "symbol": "e9d6b65d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.dollar": {
        "default": {
            "default": {
                "plain": "bd358159",
                "symbol": "7530b00c"
            }
        },
        "v3": {
            "default": {
                "plain": "91e99f43",
                "symbol": "c7035bb3"
            }
        }
    },
    "fill.symbol.door": {
        "default": {
            "default": {
                "plain": "b91c3969",
                "symbol": "0e3d1a97"
            }
        },
        "v3": {
            "default": {
                "plain": "98632810",
                "symbol": "347d6e1e"
            }
        }
    },
    "fill.symbol.door-check": {
        "default": {
            "default": {
                "plain": "a4484ed6",
                "symbol": "50f32fb2"
            }
        },
        "v3": {
            "default": {
                "plain": "1c4a1e30",
                "symbol": "985d5680"
            }
        }
    },
    "fill.symbol.doortag": {
        "default": {
            "default": {
                "plain": "526ac52c",
                "symbol": "b111d5b7"
            }
        },
        "v3": {
            "default": {
                "plain": "89104ebf",
                "symbol": "6967649c"
            }
        }
    },
    "fill.symbol.edit": {
        "default": {
            "default": {
                "plain": "46103358",
                "symbol": "465da806"
            }
        },
        "v3": {
            "default": {
                "plain": "47838b47",
                "symbol": "d7963bac"
            }
        }
    },
    "fill.symbol.envelope": {
        "default": {
            "default": {
                "plain": "139f2fcb",
                "symbol": "c6bead34"
            }
        },
        "v3": {
            "default": {
                "plain": "f885ae06",
                "symbol": "68b69d04"
            }
        }
    },
    "fill.symbol.envelope-arrow": {
        "default": {
            "default": {
                "plain": "2d619a72",
                "symbol": "aa7ea72b"
            }
        },
        "v3": {
            "default": {
                "plain": "8018e9d4",
                "symbol": "b29a2d63"
            }
        }
    },
    "fill.symbol.external-link": {
        "default": {
            "default": {
                "plain": "694c10f0",
                "symbol": "f3d71b53"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "449f2080",
                "symbol": "be204349"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.eye": {
        "default": {
            "default": {
                "plain": "a10ae31d",
                "symbol": "2449c907"
            }
        },
        "v3": {
            "default": {
                "plain": "7e06dbc5",
                "symbol": "26243e8e"
            }
        }
    },
    "fill.symbol.eye-no": {
        "default": {
            "default": {
                "plain": "e731e41e",
                "symbol": "93b2200d"
            }
        },
        "v3": {
            "default": {
                "plain": "8bb4bd37",
                "symbol": "2be9e207"
            }
        }
    },
    "fill.symbol.female": {
        "default": {
            "default": {
                "plain": "06d88e62",
                "symbol": "476f6020"
            }
        },
        "v3": {
            "default": {
                "plain": "cb1cd93f",
                "symbol": "bdfe1ea6"
            }
        }
    },
    "fill.symbol.filter": {
        "default": {
            "default": {
                "plain": "4436903d",
                "symbol": "6dd2d26e"
            }
        },
        "v3": {
            "default": {
                "plain": "5128abb4",
                "symbol": "13fc7eb2"
            }
        }
    },
    "fill.symbol.filter2": {
        "default": {
            "default": {
                "plain": "3f3983a9",
                "symbol": "df92b940"
            }
        },
        "v3": {
            "default": {
                "plain": "16e485aa",
                "symbol": "b4e9f531"
            }
        }
    },
    "fill.symbol.flag": {
        "default": {
            "default": {
                "plain": "e913135f",
                "symbol": "d08f30b3"
            }
        },
        "v3": {
            "default": {
                "plain": "6dd73f9c",
                "symbol": "fdf3f717"
            }
        }
    },
    "fill.symbol.gift": {
        "default": {
            "default": {
                "plain": "03f04bee",
                "symbol": "71a02f92"
            }
        },
        "v3": {
            "default": {
                "plain": "9007949f",
                "symbol": "0c95bee0"
            }
        }
    },
    "fill.symbol.globe": {
        "default": {
            "default": {
                "plain": "13771c20",
                "symbol": "0c0b0053"
            }
        },
        "v3": {
            "default": {
                "plain": "0ac6b10f",
                "symbol": "a94e3a0e"
            }
        }
    },
    "fill.symbol.graph-ascend": {
        "default": {
            "default": {
                "plain": "a49fa896",
                "symbol": "460f9cb7"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "c647f414",
                "symbol": "7cf53b8c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.graph-descend": {
        "default": {
            "default": {
                "plain": "f09cbbbc",
                "symbol": "253a2111"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "7c9792cf",
                "symbol": "b39c5d46"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.halal": {
        "default": {
            "default": {
                "plain": "15b09105",
                "symbol": "4e5e9496"
            }
        },
        "v3": {
            "default": {
                "plain": "62c988b2",
                "symbol": "daae76f8"
            }
        }
    },
    "fill.symbol.hearing": {
        "default": {
            "default": {
                "plain": "d0750680",
                "symbol": "0402941a"
            }
        },
        "v3": {
            "default": {
                "plain": "ad8396f8",
                "symbol": "27cce76a"
            }
        }
    },
    "fill.symbol.heart": {
        "default": {
            "default": {
                "plain": "fccb20f8",
                "symbol": "1c4d93ad"
            }
        },
        "v3": {
            "default": {
                "plain": "47332174",
                "symbol": "6bb62df3"
            }
        }
    },
    "fill.symbol.heart-beat": {
        "default": {
            "default": {
                "plain": "d0e93bce",
                "symbol": "85412d02"
            }
        },
        "v3": {
            "default": {
                "plain": "d4287c7d",
                "symbol": "ad299305"
            }
        }
    },
    "fill.symbol.heart-empty": {
        "default": {
            "default": {
                "plain": "752aeba6",
                "symbol": "0dbe6efb"
            }
        },
        "v3": {
            "default": {
                "plain": "72463b93",
                "symbol": "4df1d37c"
            }
        }
    },
    "fill.symbol.hearts": {
        "default": {
            "default": {
                "plain": "ec5c5d22",
                "symbol": "fe79a147"
            }
        },
        "v3": {
            "default": {
                "plain": "e233d446",
                "symbol": "0cd5101d"
            }
        }
    },
    "fill.symbol.home": {
        "default": {
            "default": {
                "plain": "24795ac0",
                "symbol": "6aa78475"
            }
        },
        "v3": {
            "default": {
                "plain": "283db69b",
                "symbol": "0ea888ea"
            }
        }
    },
    "fill.symbol.home-check": {
        "default": {
            "default": {
                "plain": "8ae3d88c",
                "symbol": "611155b7"
            }
        },
        "v3": {
            "default": {
                "plain": "e5d670e9",
                "symbol": "b3c0f76b"
            }
        }
    },
    "fill.symbol.hygiene": {
        "default": {
            "default": {
                "plain": "5ac040f1",
                "symbol": "2b7895df"
            }
        },
        "v3": {
            "default": {
                "plain": "8aa27c96",
                "symbol": "e3ca3e77"
            }
        }
    },
    "fill.symbol.inbox": {
        "default": {
            "default": {
                "plain": "9dcb1c79",
                "symbol": "bc2e609f"
            }
        },
        "v3": {
            "default": {
                "plain": "a5d24fb1",
                "symbol": "10307ce9"
            }
        }
    },
    "fill.symbol.jewish": {
        "default": {
            "default": {
                "plain": "64885b04",
                "symbol": "a50313d0"
            }
        },
        "v3": {
            "default": {
                "plain": "e03ac714",
                "symbol": "242cb443"
            }
        }
    },
    "fill.symbol.lightbulb": {
        "default": {
            "default": {
                "plain": "50421857",
                "symbol": "6b27114c"
            }
        },
        "v3": {
            "default": {
                "plain": "688a34c1",
                "symbol": "8613a1b9"
            }
        }
    },
    "fill.symbol.lightning1": {
        "default": {
            "default": {
                "plain": "ea1c4a43",
                "symbol": "5061be66"
            }
        },
        "v3": {
            "default": {
                "plain": "ecc29113",
                "symbol": "f752ed50"
            }
        }
    },
    "fill.symbol.lightning2": {
        "default": {
            "default": {
                "plain": "93fea065",
                "symbol": "e3ae0efb"
            }
        },
        "v3": {
            "default": {
                "plain": "e11a2cfa",
                "symbol": "ecaffc0e"
            }
        }
    },
    "fill.symbol.link": {
        "default": {
            "default": {
                "plain": "8f56ff99",
                "symbol": "99546631"
            }
        },
        "v3": {
            "default": {
                "plain": "1a779bff",
                "symbol": "58b70d55"
            }
        }
    },
    "fill.symbol.list": {
        "default": {
            "default": {
                "plain": "0f8f2df2",
                "symbol": "45cfa1f7"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "b2f8a6a2",
                "symbol": "ccf5f430"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.location": {
        "default": {
            "default": {
                "plain": "1a56b2aa",
                "symbol": "a2e25dbb"
            }
        },
        "v3": {
            "default": {
                "plain": "e7be30cb",
                "symbol": "83541e87"
            }
        }
    },
    "fill.symbol.location-review": {
        "default": {
            "default": {
                "plain": "21d33425",
                "symbol": "028b70c7"
            }
        }
    },
    "fill.symbol.lock-locked": {
        "default": {
            "default": {
                "plain": "2df2b57f",
                "symbol": "32e8b035"
            }
        },
        "v3": {
            "default": {
                "plain": "34e9c1ce",
                "symbol": "79a6c9e6"
            }
        }
    },
    "fill.symbol.lock-unlocked": {
        "default": {
            "default": {
                "plain": "ff7bfe14",
                "symbol": "4efa8a93"
            }
        },
        "v3": {
            "default": {
                "plain": "eb9bd307",
                "symbol": "e75272d4"
            }
        }
    },
    "fill.symbol.loudspeaker": {
        "default": {
            "default": {
                "plain": "b6dcb00a",
                "symbol": "e36e0521"
            }
        },
        "v3": {
            "default": {
                "plain": "72032c6d",
                "symbol": "9feedea8"
            }
        }
    },
    "fill.symbol.male": {
        "default": {
            "default": {
                "plain": "b6bd389c",
                "symbol": "345d9379"
            }
        },
        "v3": {
            "default": {
                "plain": "b3d22174",
                "symbol": "e6beacc6"
            }
        }
    },
    "fill.symbol.mandarin": {
        "default": {
            "default": {
                "plain": "ed0f3f59",
                "symbol": "f045fac7"
            }
        },
        "v3": {
            "default": {
                "plain": "80262c76",
                "symbol": "e4da38d3"
            }
        }
    },
    "fill.symbol.medal-check": {
        "default": {
            "default": {
                "plain": "c4ed3249",
                "symbol": "6726aadb"
            }
        },
        "v3": {
            "default": {
                "plain": "c2436f7a",
                "symbol": "d73d9d76"
            }
        }
    },
    "fill.symbol.medal-one": {
        "default": {
            "default": {
                "plain": "eda5bbeb",
                "symbol": "5a785577"
            }
        },
        "v3": {
            "default": {
                "plain": "2e41948e",
                "symbol": "d8203338"
            }
        }
    },
    "fill.symbol.medal1": {
        "default": {
            "default": {
                "plain": "a2ce6770",
                "symbol": "2cc6b7ed"
            }
        },
        "v3": {
            "default": {
                "plain": "6da709b4",
                "symbol": "15a0cd2d"
            }
        }
    },
    "fill.symbol.medal2": {
        "default": {
            "default": {
                "plain": "22ee046d",
                "symbol": "b72e2f34"
            }
        },
        "v3": {
            "default": {
                "plain": "5fb26bb8",
                "symbol": "100c9ed4"
            }
        }
    },
    "fill.symbol.menu": {
        "default": {
            "default": {
                "plain": "019f9694",
                "symbol": "24a68037"
            }
        },
        "v3": {
            "default": {
                "plain": "0a05564b",
                "symbol": "f808a7df"
            }
        }
    },
    "fill.symbol.microphone": {
        "default": {
            "default": {
                "plain": "26c2fcd0",
                "symbol": "5fd0585d"
            }
        },
        "v3": {
            "default": {
                "plain": "73ddddef",
                "symbol": "65c51ed7"
            }
        }
    },
    "fill.symbol.microphone-no": {
        "default": {
            "default": {
                "plain": "c578aa1c",
                "symbol": "002f1ec4"
            }
        },
        "v3": {
            "default": {
                "plain": "9070267c",
                "symbol": "2ab4e0bb"
            }
        }
    },
    "fill.symbol.minus": {
        "default": {
            "default": {
                "plain": "db5f12fe",
                "symbol": "ffda4df3"
            }
        },
        "v3": {
            "default": {
                "plain": "a4ab4f27",
                "symbol": "b2a1ddf1"
            }
        }
    },
    "fill.symbol.moon": {
        "default": {
            "default": {
                "plain": "a248daa0",
                "symbol": "f06d8492"
            }
        },
        "v3": {
            "default": {
                "plain": "1e2b6bdd",
                "symbol": "759b96f5"
            }
        }
    },
    "fill.symbol.more": {
        "default": {
            "default": {
                "plain": "d8ae68cc",
                "symbol": "942ab52c"
            }
        },
        "v3": {
            "default": {
                "plain": "6714c51c",
                "symbol": "50476d59"
            }
        }
    },
    "fill.symbol.more2": {
        "default": {
            "default": {
                "plain": "596552aa",
                "symbol": "8a28fce0"
            }
        },
        "v3": {
            "default": {
                "plain": "cb307db5",
                "symbol": "5510ccdc"
            }
        }
    },
    "fill.symbol.multi-ticket": {
        "default": {
            "default": {
                "plain": "e409eac2",
                "symbol": "be5eb07f"
            }
        }
    },
    "fill.symbol.navigate": {
        "default": {
            "default": {
                "plain": "e1ba2627",
                "symbol": "6a95d5e1"
            }
        },
        "v3": {
            "default": {
                "plain": "81ee3603",
                "symbol": "6210686b"
            }
        }
    },
    "fill.symbol.paragraph": {
        "default": {
            "default": {
                "plain": "a6a4b16a",
                "symbol": "9aeb1774"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "9fbaf729",
                "symbol": "1f917551"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.passport": {
        "default": {
            "default": {
                "plain": "db6cc8be",
                "symbol": "eca09631"
            }
        },
        "v3": {
            "default": {
                "plain": "848a437b",
                "symbol": "38fc721b"
            }
        }
    },
    "fill.symbol.photo": {
        "default": {
            "default": {
                "plain": "eb2959eb",
                "symbol": "d96f78f7"
            }
        },
        "v3": {
            "default": {
                "plain": "6af445b6",
                "symbol": "694679c6"
            }
        }
    },
    "fill.symbol.pin": {
        "default": {
            "default": {
                "plain": "f505ce67",
                "symbol": "2b524853"
            }
        },
        "v3": {
            "default": {
                "plain": "481ee2a3",
                "symbol": "334a2127"
            }
        }
    },
    "fill.symbol.pin-board": {
        "default": {
            "default": {
                "plain": "d592a925",
                "symbol": "501f1080"
            }
        },
        "v3": {
            "default": {
                "plain": "2bcf5843",
                "symbol": "8ebeac05"
            }
        }
    },
    "fill.symbol.pin-location": {
        "default": {
            "default": {
                "plain": "d9132b47",
                "symbol": "f57c9bfb"
            }
        },
        "v3": {
            "default": {
                "plain": "13ec9b0c",
                "symbol": "f0d8cb53"
            }
        }
    },
    "fill.symbol.pin-map": {
        "default": {
            "default": {
                "plain": "861fdcce",
                "symbol": "97e00886"
            }
        },
        "v3": {
            "default": {
                "plain": "a1b7313f",
                "symbol": "eae92c02"
            }
        }
    },
    "fill.symbol.pin-route": {
        "default": {
            "default": {
                "plain": "283a23ed",
                "symbol": "11775463"
            }
        },
        "v3": {
            "default": {
                "plain": "d7a6178d",
                "symbol": "e5db4aed"
            }
        }
    },
    "fill.symbol.pin-star": {
        "default": {
            "default": {
                "plain": "37585c14",
                "symbol": "f9316655"
            }
        },
        "v3": {
            "default": {
                "plain": "75768cdf",
                "symbol": "617a1ca6"
            }
        }
    },
    "fill.symbol.pin-streetview": {
        "default": {
            "default": {
                "plain": "9fde0343",
                "symbol": "67874486"
            }
        },
        "v3": {
            "default": {
                "plain": "50afee12",
                "symbol": "045a4639"
            }
        }
    },
    "fill.symbol.plus": {
        "default": {
            "default": {
                "plain": "b3d272a1",
                "symbol": "0257c99b"
            }
        },
        "v3": {
            "default": {
                "plain": "662f5a14",
                "symbol": "f1ed1a63"
            }
        }
    },
    "fill.symbol.qr-code": {
        "default": {
            "default": {
                "plain": "71be57fe",
                "symbol": "e56767bd"
            }
        },
        "v3": {
            "default": {
                "plain": "7de2529f",
                "symbol": "2d4e21a0"
            }
        }
    },
    "fill.symbol.quotes-left": {
        "default": {
            "default": {
                "plain": "40a20bc6",
                "symbol": "d2496d89"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "1111063e",
                "symbol": "9c92b308"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.quotes-right": {
        "default": {
            "default": {
                "plain": "2d21db39",
                "symbol": "5ac3bf13"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "33fb92c0",
                "symbol": "a760f149"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.receipt-rmb": {
        "default": {
            "default": {
                "plain": "145d4892",
                "symbol": "375a68a7"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "1a416faf",
                "symbol": "de266aac"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.receipt1": {
        "default": {
            "default": {
                "plain": "ad2810ba",
                "symbol": "af462056"
            }
        },
        "v3": {
            "default": {
                "plain": "1a416faf",
                "symbol": "de266aac"
            }
        }
    },
    "fill.symbol.receipt2": {
        "default": {
            "default": {
                "plain": "39bb6d9c",
                "symbol": "5696aaf5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "1a416faf",
                "symbol": "de266aac"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.restricted": {
        "default": {
            "default": {
                "plain": "d50dc3cf",
                "symbol": "46d07fdb"
            }
        },
        "v3": {
            "default": {
                "plain": "1f5f204e",
                "symbol": "cc607693"
            }
        }
    },
    "fill.symbol.ribbon": {
        "default": {
            "default": {
                "plain": "c5c40462",
                "symbol": "48164376"
            }
        },
        "v3": {
            "default": {
                "plain": "f75837cb",
                "symbol": "91e58063"
            }
        }
    },
    "fill.symbol.ribbon-card": {
        "default": {
            "default": {
                "plain": "828a92bb",
                "symbol": "049eda3f"
            }
        },
        "v3": {
            "default": {
                "plain": "60a53f79",
                "symbol": "b8cd5e95"
            }
        }
    },
    "fill.symbol.safe": {
        "default": {
            "default": {
                "plain": "0c3722f8",
                "symbol": "908dd3dd"
            }
        },
        "v3": {
            "default": {
                "plain": "fa5d72ff",
                "symbol": "d42f9e73"
            }
        }
    },
    "fill.symbol.sandglass": {
        "default": {
            "default": {
                "plain": "164c3ab7",
                "symbol": "5c838482"
            }
        },
        "v3": {
            "default": {
                "plain": "3f255a22",
                "symbol": "f171e9db"
            }
        }
    },
    "fill.symbol.search": {
        "default": {
            "default": {
                "plain": "e5947039",
                "symbol": "53f98c2a"
            }
        },
        "v3": {
            "default": {
                "plain": "4c9f843e",
                "symbol": "af8fcef1"
            }
        }
    },
    "fill.symbol.search-ai": {
        "default": {
            "default": {
                "plain": "b39b3e9e",
                "symbol": "a9d5f26e"
            }
        },
        "v3": {
            "default": {
                "plain": "78791eea",
                "symbol": "d24a09f2"
            }
        }
    },
    "fill.symbol.send": {
        "default": {
            "default": {
                "plain": "16795e5c",
                "symbol": "0524b759"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f3ee17d6",
                "symbol": "82166483"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.setting": {
        "default": {
            "default": {
                "plain": "f038ef12",
                "symbol": "b54ae4e9"
            }
        },
        "v3": {
            "default": {
                "plain": "772a85a6",
                "symbol": "5561b54c"
            }
        }
    },
    "fill.symbol.share": {
        "default": {
            "default": {
                "plain": "540bbff9",
                "symbol": "4058acd7"
            },
            "ios": {
                "plain": "462ae8b7",
                "symbol": "de28e65f"
            }
        },
        "v3": {
            "default": {
                "plain": "51fa8a70",
                "symbol": "06698e6c"
            },
            "ios": {
                "plain": "7fdc5d66",
                "symbol": "19faa1ed"
            }
        }
    },
    "fill.symbol.shield-locker": {
        "default": {
            "default": {
                "plain": "62272fff",
                "symbol": "e47b6e93"
            }
        },
        "v3": {
            "default": {
                "plain": "558f585a",
                "symbol": "13095a2c"
            }
        }
    },
    "fill.symbol.shield-user": {
        "default": {
            "default": {
                "plain": "e381e28c",
                "symbol": "b4027c9d"
            }
        },
        "v3": {
            "default": {
                "plain": "cb68641f",
                "symbol": "db783c0c"
            }
        }
    },
    "fill.symbol.sim": {
        "default": {
            "default": {
                "plain": "76532759",
                "symbol": "22512a58"
            }
        },
        "v3": {
            "default": {
                "plain": "8ad7537f",
                "symbol": "1bd5fd00"
            }
        }
    },
    "fill.symbol.snowflake": {
        "default": {
            "default": {
                "plain": "fe1c074b",
                "symbol": "cf1468e0"
            }
        },
        "v3": {
            "default": {
                "plain": "dfa6b79f",
                "symbol": "7acbacb3"
            }
        }
    },
    "fill.symbol.sort1": {
        "default": {
            "default": {
                "plain": "66681eab",
                "symbol": "0f9fe67e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f1b233d2",
                "symbol": "04185eab"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.sort2": {
        "default": {
            "default": {
                "plain": "58eac51d",
                "symbol": "7ee80c5d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "112c12bb",
                "symbol": "4bf05b66"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.square-2": {
        "default": {
            "default": {
                "plain": "534fa161",
                "symbol": "542072c4"
            }
        },
        "v3": {
            "default": {
                "plain": "9e4b6fc2",
                "symbol": "044f9be8"
            }
        }
    },
    "fill.symbol.square-4": {
        "default": {
            "default": {
                "plain": "be157d64",
                "symbol": "0ca37ae2"
            }
        },
        "v3": {
            "default": {
                "plain": "0cc0758e",
                "symbol": "74da7f01"
            }
        }
    },
    "fill.symbol.stack": {
        "default": {
            "default": {
                "plain": "0e6f87d7",
                "symbol": "bcf7dac3"
            }
        },
        "v3": {
            "default": {
                "plain": "b4f72ca3",
                "symbol": "f225b223"
            }
        }
    },
    "fill.symbol.stack-base": {
        "default": {
            "default": {
                "plain": "5f403639",
                "symbol": "1912ea05"
            }
        },
        "v3": {
            "default": {
                "plain": "0d2d1770",
                "symbol": "66ace64a"
            }
        }
    },
    "fill.symbol.stack-no": {
        "default": {
            "default": {
                "plain": "4a5fc42a",
                "symbol": "77afbb31"
            }
        },
        "v3": {
            "default": {
                "plain": "5c082ad2",
                "symbol": "a5254f3c"
            }
        }
    },
    "fill.symbol.star": {
        "default": {
            "default": {
                "plain": "fed896b3",
                "symbol": "0d2b5ddf"
            }
        },
        "v3": {
            "default": {
                "plain": "d473e92d",
                "symbol": "5174965b"
            }
        }
    },
    "fill.symbol.star-half": {
        "default": {
            "default": {
                "plain": "18542d7e",
                "symbol": "c00bc073"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "bf8b86b4",
                "symbol": "85b4595f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.streetview": {
        "default": {
            "default": {
                "plain": "4fff1171",
                "symbol": "f91e467e"
            }
        },
        "v3": {
            "default": {
                "plain": "b57e9d06",
                "symbol": "00a26581"
            }
        }
    },
    "fill.symbol.sun": {
        "default": {
            "default": {
                "plain": "7bed56e8",
                "symbol": "101c5a0e"
            }
        },
        "v3": {
            "default": {
                "plain": "52ab15b2",
                "symbol": "14a1f930"
            }
        }
    },
    "fill.symbol.sun-cloud": {
        "default": {
            "default": {
                "plain": "7baeff61",
                "symbol": "25aa8ed7"
            }
        },
        "v3": {
            "default": {
                "plain": "f0a634b0",
                "symbol": "fb4f1729"
            }
        }
    },
    "fill.symbol.sun-half": {
        "default": {
            "default": {
                "plain": "0a1d9603",
                "symbol": "8dd8ff9d"
            }
        },
        "v3": {
            "default": {
                "plain": "8e80f375",
                "symbol": "11837337"
            }
        }
    },
    "fill.symbol.tag": {
        "default": {
            "default": {
                "plain": "108a8a97",
                "symbol": "2ac0ebe9"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "aac5e040",
                "symbol": "ced41e53"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.tags": {
        "default": {
            "default": {
                "plain": "0cc13c80",
                "symbol": "1f139464"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "5e0ae070",
                "symbol": "cfab13c8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.symbol.tamil": {
        "default": {
            "default": {
                "plain": "55b8ed51",
                "symbol": "8b2f75e2"
            }
        },
        "v3": {
            "default": {
                "plain": "231f1024",
                "symbol": "1df9eeeb"
            }
        }
    },
    "fill.symbol.text-size": {
        "default": {
            "default": {
                "plain": "fec25d0b",
                "symbol": "b37ffaa9"
            }
        }
    },
    "fill.symbol.thumbs-down": {
        "default": {
            "default": {
                "plain": "b904a7e4",
                "symbol": "af8f0b1e"
            }
        },
        "v3": {
            "default": {
                "plain": "7d5b5b79",
                "symbol": "9a538461"
            }
        }
    },
    "fill.symbol.thumbs-up": {
        "default": {
            "default": {
                "plain": "891d885d",
                "symbol": "9a4e1356"
            }
        },
        "v3": {
            "default": {
                "plain": "2560fab9",
                "symbol": "9cbab397"
            }
        }
    },
    "fill.symbol.time": {
        "default": {
            "default": {
                "plain": "cf7aa633",
                "symbol": "984c9153"
            }
        },
        "v3": {
            "default": {
                "plain": "a0e5ba0b",
                "symbol": "ec1243f1"
            }
        }
    },
    "fill.symbol.time-arrow": {
        "default": {
            "default": {
                "plain": "a8583672",
                "symbol": "61426ae9"
            }
        },
        "v3": {
            "default": {
                "plain": "96469701",
                "symbol": "25916eb0"
            }
        }
    },
    "fill.symbol.triangle-exclamation": {
        "default": {
            "default": {
                "plain": "c1785c9b",
                "symbol": "05965fb9"
            }
        },
        "v3": {
            "default": {
                "plain": "185d7f6d",
                "symbol": "c44755e2"
            }
        }
    },
    "fill.symbol.trophy": {
        "default": {
            "default": {
                "plain": "f4194e70",
                "symbol": "077748b1"
            }
        },
        "v3": {
            "default": {
                "plain": "0319ef41",
                "symbol": "b1dc1ef4"
            }
        }
    },
    "fill.symbol.trophy-star": {
        "default": {
            "default": {
                "plain": "bde687ae",
                "symbol": "79aa2162"
            }
        },
        "v3": {
            "default": {
                "plain": "88838a95",
                "symbol": "f3ea9460"
            }
        }
    },
    "fill.symbol.unicorn": {
        "default": {
            "default": {
                "plain": "416d8da2",
                "symbol": "6f00ab8a"
            }
        },
        "v3": {
            "default": {
                "plain": "18ccd79c",
                "symbol": "fba56697"
            }
        }
    },
    "fill.symbol.unsave": {
        "default": {
            "default": {
                "plain": "0dddeb9b",
                "symbol": "f4ae5b45"
            }
        },
        "v3": {
            "default": {
                "plain": "a1b226ab",
                "symbol": "2274d5c7"
            }
        }
    },
    "fill.symbol.vaccine": {
        "default": {
            "default": {
                "plain": "833a3ef7",
                "symbol": "f9c93e04"
            }
        },
        "v3": {
            "default": {
                "plain": "66219971",
                "symbol": "05e53042"
            }
        }
    },
    "fill.symbol.vaccine2": {
        "default": {
            "default": {
                "plain": "26170158",
                "symbol": "5abac249"
            }
        },
        "v3": {
            "default": {
                "plain": "83b7864c",
                "symbol": "168a445b"
            }
        }
    },
    "fill.symbol.volume": {
        "default": {
            "default": {
                "plain": "6dbbfa39",
                "symbol": "7530c823"
            }
        },
        "v3": {
            "default": {
                "plain": "5b94b3ee",
                "symbol": "b0f50c59"
            }
        }
    },
    "fill.symbol.volume-no": {
        "default": {
            "default": {
                "plain": "94527f36",
                "symbol": "4ac1456b"
            }
        },
        "v3": {
            "default": {
                "plain": "aaa258f7",
                "symbol": "dd50882b"
            }
        }
    },
    "fill.symbol.wallet": {
        "default": {
            "default": {
                "plain": "dcceeb12",
                "symbol": "1ff4eca1"
            }
        }
    },
    "fill.transportation.airbag": {
        "default": {
            "default": {
                "plain": "247df1ba",
                "symbol": "0624a118"
            }
        }
    },
    "fill.transportation.airport": {
        "default": {
            "default": {
                "plain": "bb79304a",
                "symbol": "c326e836"
            }
        },
        "v3": {
            "default": {
                "plain": "f5343bc7",
                "symbol": "4cfd5793"
            }
        }
    },
    "fill.transportation.airport-check": {
        "default": {
            "default": {
                "plain": "4c422076",
                "symbol": "19e50c61"
            }
        },
        "v3": {
            "default": {
                "plain": "2873195a",
                "symbol": "90624ce3"
            }
        }
    },
    "fill.transportation.airport-park": {
        "default": {
            "default": {
                "plain": "6043b7bd",
                "symbol": "20d66433"
            }
        },
        "v3": {
            "default": {
                "plain": "47a49e06",
                "symbol": "f5e02da1"
            }
        }
    },
    "fill.transportation.airport-pin": {
        "default": {
            "default": {
                "plain": "5b1fdc08",
                "symbol": "3a509a19"
            }
        },
        "v3": {
            "default": {
                "plain": "360a7516",
                "symbol": "b2edb5d1"
            }
        }
    },
    "fill.transportation.airport-time": {
        "default": {
            "default": {
                "plain": "cb2e2c70",
                "symbol": "3bacde72"
            }
        },
        "v3": {
            "default": {
                "plain": "54be3538",
                "symbol": "3937c8e4"
            }
        }
    },
    "fill.transportation.arrival": {
        "default": {
            "default": {
                "plain": "089c9d01",
                "symbol": "201fea91"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "8ea019bb",
                "symbol": "a57f04e6"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.transportation.bike": {
        "default": {
            "default": {
                "plain": "18150ea3",
                "symbol": "f8073276"
            }
        },
        "v3": {
            "default": {
                "plain": "603448b1",
                "symbol": "9749c8f7"
            }
        }
    },
    "fill.transportation.bike-key": {
        "default": {
            "default": {
                "plain": "3ef89470",
                "symbol": "fa2e210d"
            }
        },
        "v3": {
            "default": {
                "plain": "cc51ab5a",
                "symbol": "88723219"
            }
        }
    },
    "fill.transportation.bike-pay": {
        "default": {
            "default": {
                "plain": "dc0e772a",
                "symbol": "f53b5029"
            }
        },
        "v3": {
            "default": {
                "plain": "603448b1",
                "symbol": "9749c8f7"
            }
        }
    },
    "fill.transportation.bus": {
        "default": {
            "default": {
                "plain": "3d68efa6",
                "symbol": "88adbbbf"
            }
        },
        "v3": {
            "default": {
                "plain": "535cd3a5",
                "symbol": "ad9bb658"
            }
        }
    },
    "fill.transportation.bus-metro": {
        "default": {
            "default": {
                "plain": "2f15817a",
                "symbol": "812e598c"
            }
        },
        "v3": {
            "default": {
                "plain": "e13eeaa4",
                "symbol": "7178da48"
            }
        }
    },
    "fill.transportation.cable-car": {
        "default": {
            "default": {
                "plain": "587c83a6",
                "symbol": "ead8406d"
            }
        },
        "v3": {
            "default": {
                "plain": "aa2dc97f",
                "symbol": "a6b8c061"
            }
        }
    },
    "fill.transportation.car": {
        "default": {
            "default": {
                "plain": "4bf73ec4",
                "symbol": "31f5a748"
            }
        },
        "v3": {
            "default": {
                "plain": "a815af84",
                "symbol": "f9532343"
            }
        }
    },
    "fill.transportation.car-charge": {
        "default": {
            "default": {
                "plain": "ee22683a",
                "symbol": "970880ef"
            }
        },
        "v3": {
            "default": {
                "plain": "97b2267c",
                "symbol": "a8e125a1"
            }
        }
    },
    "fill.transportation.car-flight": {
        "default": {
            "default": {
                "plain": "c8f2c610",
                "symbol": "3073527e"
            }
        },
        "v3": {
            "default": {
                "plain": "05a6498b",
                "symbol": "f8a5cc0b"
            }
        }
    },
    "fill.transportation.car-key": {
        "default": {
            "default": {
                "plain": "43d4fc69",
                "symbol": "83d5f9ff"
            }
        },
        "v3": {
            "default": {
                "plain": "cc51ab5a",
                "symbol": "88723219"
            }
        }
    },
    "fill.transportation.car-park": {
        "default": {
            "default": {
                "plain": "717e43c0",
                "symbol": "f155403d"
            }
        },
        "v3": {
            "default": {
                "plain": "95deb270",
                "symbol": "ff6f090f"
            }
        }
    },
    "fill.transportation.departure": {
        "default": {
            "default": {
                "plain": "dd2e89d7",
                "symbol": "e5e80474"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "ec9a6e06",
                "symbol": "0fee0d07"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.transportation.ferry": {
        "default": {
            "default": {
                "plain": "34e7dce7",
                "symbol": "bda82b1a"
            }
        },
        "v3": {
            "default": {
                "plain": "6c0d87df",
                "symbol": "febf2a0c"
            }
        }
    },
    "fill.transportation.flight-cancel": {
        "default": {
            "default": {
                "plain": "14d6c57c",
                "symbol": "d4a81b32"
            }
        },
        "v3": {
            "default": {
                "plain": "03f8e83d",
                "symbol": "f0a7671a"
            }
        }
    },
    "fill.transportation.flight-change": {
        "default": {
            "default": {
                "plain": "50b74b94",
                "symbol": "f93d461f"
            }
        },
        "v3": {
            "default": {
                "plain": "eee2bd91",
                "symbol": "7d9d8b92"
            }
        }
    },
    "fill.transportation.flight-change-no": {
        "default": {
            "default": {
                "plain": "fa91ac5f",
                "symbol": "46d8a5c9"
            }
        },
        "v3": {
            "default": {
                "plain": "33174006",
                "symbol": "855e0d5a"
            }
        }
    },
    "fill.transportation.flight-change-price": {
        "default": {
            "default": {
                "plain": "9b2f61ad",
                "symbol": "b0b4bb37"
            }
        },
        "v3": {
            "default": {
                "plain": "c2d53cee",
                "symbol": "c8c45c06"
            }
        }
    },
    "fill.transportation.flight-check": {
        "default": {
            "default": {
                "plain": "d3db7d64",
                "symbol": "5d180218"
            }
        },
        "v3": {
            "default": {
                "plain": "553c92c0",
                "symbol": "e13121b4"
            }
        }
    },
    "fill.transportation.flight-gate": {
        "default": {
            "default": {
                "plain": "9c9e7ccd",
                "symbol": "410dd4c1"
            }
        },
        "v3": {
            "default": {
                "plain": "966fcadb",
                "symbol": "e729e83e"
            }
        }
    },
    "fill.transportation.flight-multiple": {
        "default": {
            "default": {
                "plain": "e0c54480",
                "symbol": "de4231a1"
            }
        },
        "v3": {
            "default": {
                "plain": "a6556b5f",
                "symbol": "85a64834"
            }
        }
    },
    "fill.transportation.flight-transfer": {
        "default": {
            "default": {
                "plain": "dce75cf4",
                "symbol": "e87a6c00"
            }
        },
        "v3": {
            "default": {
                "plain": "084ae6ae",
                "symbol": "441235ab"
            }
        }
    },
    "fill.transportation.flight1": {
        "default": {
            "default": {
                "plain": "26a10e1d",
                "symbol": "3d7fda24"
            }
        },
        "v3": {
            "default": {
                "plain": "b45df52b",
                "symbol": "cbc73147"
            }
        }
    },
    "fill.transportation.flight2": {
        "default": {
            "default": {
                "plain": "d7db1c5c",
                "symbol": "4444252d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "857ddf1c",
                "symbol": "7bbfcc79"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "fill.transportation.flight3": {
        "default": {
            "default": {
                "plain": "9d2b6cd3",
                "symbol": "c00333f2"
            }
        },
        "v3": {
            "default": {
                "plain": "59659f8c",
                "symbol": "df1367ec"
            }
        }
    },
    "fill.transportation.fuel": {
        "default": {
            "default": {
                "plain": "850f3df9",
                "symbol": "4d3358c0"
            }
        }
    },
    "fill.transportation.jetski": {
        "default": {
            "default": {
                "plain": "113f334e",
                "symbol": "f554e9fa"
            }
        },
        "v3": {
            "default": {
                "plain": "1ea04c86",
                "symbol": "92d4b0cd"
            }
        }
    },
    "fill.transportation.metro": {
        "default": {
            "default": {
                "plain": "f8b34418",
                "symbol": "ba4e37a9"
            }
        },
        "v3": {
            "default": {
                "plain": "49b42a22",
                "symbol": "b2961148"
            }
        }
    },
    "fill.transportation.parking": {
        "default": {
            "default": {
                "plain": "22236d02",
                "symbol": "8a5ffd49"
            }
        },
        "v3": {
            "default": {
                "plain": "95deb270",
                "symbol": "ff6f090f"
            }
        }
    },
    "fill.transportation.parking-card": {
        "default": {
            "default": {
                "plain": "b197e995",
                "symbol": "476c1454"
            }
        },
        "v3": {
            "default": {
                "plain": "95deb270",
                "symbol": "ff6f090f"
            }
        }
    },
    "fill.transportation.parking-pay": {
        "default": {
            "default": {
                "plain": "42572d02",
                "symbol": "fcd54263"
            }
        },
        "v3": {
            "default": {
                "plain": "95deb270",
                "symbol": "ff6f090f"
            }
        }
    },
    "fill.transportation.roundtrip": {
        "default": {
            "default": {
                "plain": "e162363f",
                "symbol": "ecf36544"
            }
        },
        "v3": {
            "default": {
                "plain": "a4436217",
                "symbol": "39e09a5a"
            }
        }
    },
    "fill.transportation.seat": {
        "default": {
            "default": {
                "plain": "9f438f1e",
                "symbol": "485c048f"
            }
        },
        "v3": {
            "default": {
                "plain": "a86202c9",
                "symbol": "b695a5e8"
            }
        }
    },
    "fill.transportation.seat-no": {
        "default": {
            "default": {
                "plain": "42259567",
                "symbol": "427f0aa0"
            }
        },
        "v3": {
            "default": {
                "plain": "f393b808",
                "symbol": "8a9d6e4d"
            }
        }
    },
    "fill.transportation.seat-pay": {
        "default": {
            "default": {
                "plain": "a9c9fd01",
                "symbol": "0f0b659f"
            }
        },
        "v3": {
            "default": {
                "plain": "de300cc3",
                "symbol": "4c600e88"
            }
        }
    },
    "fill.transportation.shuttle": {
        "default": {
            "default": {
                "plain": "bc5462c0",
                "symbol": "d9a6618c"
            }
        },
        "v3": {
            "default": {
                "plain": "59edf001",
                "symbol": "689ae500"
            }
        }
    },
    "fill.transportation.shuttle-time": {
        "default": {
            "default": {
                "plain": "56dae0c7",
                "symbol": "40c23373"
            }
        },
        "v3": {
            "default": {
                "plain": "fd94a2dc",
                "symbol": "7230c12d"
            }
        }
    },
    "fill.transportation.taxi": {
        "default": {
            "default": {
                "plain": "8be40265",
                "symbol": "ab5d88bc"
            }
        },
        "v3": {
            "default": {
                "plain": "6941dcb4",
                "symbol": "0113f3d9"
            }
        }
    },
    "fill.transportation.tram": {
        "default": {
            "default": {
                "plain": "80ab90cf",
                "symbol": "cbcd6d91"
            }
        },
        "v3": {
            "default": {
                "plain": "babf3501",
                "symbol": "43034bf6"
            }
        }
    },
    "fill.transportation.transportation-system": {
        "default": {
            "default": {
                "plain": "5c52d1d0",
                "symbol": "25846869"
            }
        }
    },
    "fill.transportation.yacht": {
        "default": {
            "default": {
                "plain": "54c20d28",
                "symbol": "6338b378"
            }
        },
        "v3": {
            "default": {
                "plain": "7733c4a5",
                "symbol": "9ea0113a"
            }
        }
    },
    "line.accommodation.apartment": {
        "default": {
            "default": {
                "plain": "f76ede21",
                "symbol": "7ba17a85"
            }
        },
        "v3": {
            "default": {
                "plain": "20312dce",
                "symbol": "d7377fe2"
            }
        }
    },
    "line.accommodation.apartment-hand": {
        "default": {
            "default": {
                "plain": "440ba44d",
                "symbol": "dd69206e"
            }
        },
        "v3": {
            "default": {
                "plain": "20312dce",
                "symbol": "d7377fe2"
            }
        }
    },
    "line.accommodation.bungalow": {
        "default": {
            "default": {
                "plain": "88510127",
                "symbol": "b4800b8c"
            }
        },
        "v3": {
            "default": {
                "plain": "34dc650a",
                "symbol": "f33debac"
            }
        }
    },
    "line.accommodation.cabin": {
        "default": {
            "default": {
                "plain": "f7de0529",
                "symbol": "2c9f9859"
            }
        },
        "v3": {
            "default": {
                "plain": "85cdcab4",
                "symbol": "c720df04"
            }
        }
    },
    "line.accommodation.capsule-female": {
        "default": {
            "default": {
                "plain": "e8e7fc15",
                "symbol": "619ba5e0"
            }
        },
        "v3": {
            "default": {
                "plain": "81f40195",
                "symbol": "af03c9ec"
            }
        }
    },
    "line.accommodation.capsule-hotel": {
        "default": {
            "default": {
                "plain": "68de02b7",
                "symbol": "a83c270b"
            }
        },
        "v3": {
            "default": {
                "plain": "81f40195",
                "symbol": "af03c9ec"
            }
        }
    },
    "line.accommodation.capsule-male": {
        "default": {
            "default": {
                "plain": "2a95a750",
                "symbol": "7a85947b"
            }
        },
        "v3": {
            "default": {
                "plain": "81f40195",
                "symbol": "af03c9ec"
            }
        }
    },
    "line.accommodation.castle": {
        "default": {
            "default": {
                "plain": "7a56ff97",
                "symbol": "4f3a559e"
            }
        },
        "v3": {
            "default": {
                "plain": "736babd9",
                "symbol": "6c75f73b"
            }
        }
    },
    "line.accommodation.cave": {
        "default": {
            "default": {
                "plain": "60167444",
                "symbol": "2cde4574"
            }
        },
        "v3": {
            "default": {
                "plain": "48f8d708",
                "symbol": "32b19d61"
            }
        }
    },
    "line.accommodation.chalet": {
        "default": {
            "default": {
                "plain": "63453dc0",
                "symbol": "3310a4cd"
            }
        },
        "v3": {
            "default": {
                "plain": "2ec6493e",
                "symbol": "4bd179c1"
            }
        }
    },
    "line.accommodation.circle-ryokan": {
        "default": {
            "default": {
                "plain": "f170d0d5",
                "symbol": "32f117fc"
            }
        },
        "v3": {
            "default": {
                "plain": "ee43be25",
                "symbol": "121641b9"
            }
        }
    },
    "line.accommodation.cottage": {
        "default": {
            "default": {
                "plain": "6078f4fd",
                "symbol": "add8d5f8"
            }
        },
        "v3": {
            "default": {
                "plain": "bada6942",
                "symbol": "4db0019e"
            }
        }
    },
    "line.accommodation.country-house": {
        "default": {
            "default": {
                "plain": "43ad8215",
                "symbol": "b0a11142"
            }
        },
        "v3": {
            "default": {
                "plain": "aca281bd",
                "symbol": "9aa6ed95"
            }
        }
    },
    "line.accommodation.dome-house": {
        "default": {
            "default": {
                "plain": "be73e60b",
                "symbol": "e03ce040"
            }
        },
        "v3": {
            "default": {
                "plain": "5ce04e37",
                "symbol": "960b4a2b"
            }
        }
    },
    "line.accommodation.family-room": {
        "default": {
            "default": {
                "plain": "d6575e31",
                "symbol": "886b5f42"
            }
        },
        "v3": {
            "default": {
                "plain": "f5d710d8",
                "symbol": "5fe1921f"
            }
        }
    },
    "line.accommodation.farmstay": {
        "default": {
            "default": {
                "plain": "80b2c5d4",
                "symbol": "adfc4d10"
            }
        },
        "v3": {
            "default": {
                "plain": "4012e811",
                "symbol": "4867a16a"
            }
        }
    },
    "line.accommodation.haveli": {
        "default": {
            "default": {
                "plain": "8a7c3b51",
                "symbol": "ee5ae9e1"
            }
        },
        "v3": {
            "default": {
                "plain": "ecf30a8c",
                "symbol": "2e1dc040"
            }
        }
    },
    "line.accommodation.hotel": {
        "default": {
            "default": {
                "plain": "35b87036",
                "symbol": "27337d51"
            }
        },
        "v3": {
            "default": {
                "plain": "638acb3a",
                "symbol": "08a8979d"
            }
        }
    },
    "line.accommodation.hotel-flight": {
        "default": {
            "default": {
                "plain": "51d48f12",
                "symbol": "23fc5e29"
            }
        },
        "v3": {
            "default": {
                "plain": "6cd5594f",
                "symbol": "0e85e31c"
            }
        }
    },
    "line.accommodation.hotel-luxury": {
        "default": {
            "default": {
                "plain": "a86b0409",
                "symbol": "9abe40a1"
            }
        },
        "v3": {
            "default": {
                "plain": "374121ec",
                "symbol": "90583d2c"
            }
        }
    },
    "line.accommodation.house": {
        "default": {
            "default": {
                "plain": "2a57449c",
                "symbol": "3bde321a"
            }
        },
        "v3": {
            "default": {
                "plain": "f18e6d2a",
                "symbol": "dc227b35"
            }
        }
    },
    "line.accommodation.houseboat": {
        "default": {
            "default": {
                "plain": "1bd98cbe",
                "symbol": "0bd1a34f"
            }
        },
        "v3": {
            "default": {
                "plain": "ec29db32",
                "symbol": "7e6dfc6f"
            }
        }
    },
    "line.accommodation.igloo": {
        "default": {
            "default": {
                "plain": "3de9963a",
                "symbol": "6c9f100d"
            }
        },
        "v3": {
            "default": {
                "plain": "27a62d72",
                "symbol": "2ccf38c6"
            }
        }
    },
    "line.accommodation.inn": {
        "default": {
            "default": {
                "plain": "988bb29f",
                "symbol": "ee26a4a4"
            }
        },
        "v3": {
            "default": {
                "plain": "45eb751a",
                "symbol": "2bc009f5"
            }
        }
    },
    "line.accommodation.lodge": {
        "default": {
            "default": {
                "plain": "65792139",
                "symbol": "dad73e1e"
            }
        },
        "v3": {
            "default": {
                "plain": "375ad6ff",
                "symbol": "80407a61"
            }
        }
    },
    "line.accommodation.loft": {
        "default": {
            "default": {
                "plain": "ddf5bff1",
                "symbol": "7a8cfd46"
            }
        },
        "v3": {
            "default": {
                "plain": "ba07e335",
                "symbol": "3fbf0411"
            }
        }
    },
    "line.accommodation.love-hotel": {
        "default": {
            "default": {
                "plain": "d0513f79",
                "symbol": "a8b58f9d"
            }
        },
        "v3": {
            "default": {
                "plain": "7203497c",
                "symbol": "304b1f17"
            }
        }
    },
    "line.accommodation.machiya": {
        "default": {
            "default": {
                "plain": "8fe96235",
                "symbol": "59305583"
            }
        },
        "v3": {
            "default": {
                "plain": "ce832918",
                "symbol": "8f68eb14"
            }
        }
    },
    "line.accommodation.minsu": {
        "default": {
            "default": {
                "plain": "ec95c5a7",
                "symbol": "4befbf46"
            }
        },
        "v3": {
            "default": {
                "plain": "482a8217",
                "symbol": "d510b9dd"
            }
        }
    },
    "line.accommodation.pension": {
        "default": {
            "default": {
                "plain": "cf6a248c",
                "symbol": "caf49420"
            }
        },
        "v3": {
            "default": {
                "plain": "971081a7",
                "symbol": "79750e9a"
            }
        }
    },
    "line.accommodation.riad": {
        "default": {
            "default": {
                "plain": "19fbde2e",
                "symbol": "080c82d0"
            }
        },
        "v3": {
            "default": {
                "plain": "496c040e",
                "symbol": "91b7259b"
            }
        }
    },
    "line.accommodation.ryokan": {
        "default": {
            "default": {
                "plain": "daca87bc",
                "symbol": "ea5da0fc"
            }
        },
        "v3": {
            "default": {
                "plain": "ee43be25",
                "symbol": "121641b9"
            }
        }
    },
    "line.accommodation.tipi": {
        "default": {
            "default": {
                "plain": "c02ce9c0",
                "symbol": "e7cc35cf"
            }
        },
        "v3": {
            "default": {
                "plain": "740c8544",
                "symbol": "25e0bd9f"
            }
        }
    },
    "line.accommodation.townhouse": {
        "default": {
            "default": {
                "plain": "6d7a9e92",
                "symbol": "c6915ec9"
            }
        },
        "v3": {
            "default": {
                "plain": "6f1cc143",
                "symbol": "8ca25d3b"
            }
        }
    },
    "line.accommodation.treehouse": {
        "default": {
            "default": {
                "plain": "2784f285",
                "symbol": "ed972fa0"
            }
        },
        "v3": {
            "default": {
                "plain": "2a408eaa",
                "symbol": "febb2243"
            }
        }
    },
    "line.accommodation.villa": {
        "default": {
            "default": {
                "plain": "cc08f677",
                "symbol": "68140273"
            }
        },
        "v3": {
            "default": {
                "plain": "ba07e335",
                "symbol": "3fbf0411"
            }
        }
    },
    "line.accommodation.yurt": {
        "default": {
            "default": {
                "plain": "01ec11fe",
                "symbol": "d2f57df7"
            }
        },
        "v3": {
            "default": {
                "plain": "ecf9c4a5",
                "symbol": "ac327893"
            }
        }
    },
    "line.activity.activity-kits": {
        "default": {
            "default": {
                "plain": "f32d04ae",
                "symbol": "c88152d0"
            }
        },
        "v3": {
            "default": {
                "plain": "dba2d765",
                "symbol": "aaea0294"
            }
        }
    },
    "line.activity.archery": {
        "default": {
            "default": {
                "plain": "14800632",
                "symbol": "9bef466b"
            }
        },
        "v3": {
            "default": {
                "plain": "42861e7e",
                "symbol": "916d4282"
            }
        }
    },
    "line.activity.baseball": {
        "default": {
            "default": {
                "plain": "ea9e1b03",
                "symbol": "c782ef0c"
            }
        },
        "v3": {
            "default": {
                "plain": "4a54d18b",
                "symbol": "5e4d2213"
            }
        }
    },
    "line.activity.beach": {
        "default": {
            "default": {
                "plain": "b419ff35",
                "symbol": "2fb9ba69"
            }
        },
        "v3": {
            "default": {
                "plain": "6e788028",
                "symbol": "f463ae39"
            }
        }
    },
    "line.activity.bird": {
        "default": {
            "default": {
                "plain": "e3f98f99",
                "symbol": "3bd388d1"
            }
        },
        "v3": {
            "default": {
                "plain": "949dc6fc",
                "symbol": "cc259060"
            }
        }
    },
    "line.activity.bird-binocular": {
        "default": {
            "default": {
                "plain": "ab8eeeed",
                "symbol": "3c340ba9"
            }
        },
        "v3": {
            "default": {
                "plain": "f7dbc5d7",
                "symbol": "e5dd6687"
            }
        }
    },
    "line.activity.boat-row": {
        "default": {
            "default": {
                "plain": "73c118d6",
                "symbol": "6af3823f"
            }
        },
        "v3": {
            "default": {
                "plain": "b05feb6f",
                "symbol": "5d8ddaf7"
            }
        }
    },
    "line.activity.book": {
        "default": {
            "default": {
                "plain": "001fae85",
                "symbol": "f52d5d48"
            }
        },
        "v3": {
            "default": {
                "plain": "791afac2",
                "symbol": "a23d1ec2"
            }
        }
    },
    "line.activity.bowling": {
        "default": {
            "default": {
                "plain": "7bead112",
                "symbol": "ac283b92"
            }
        },
        "v3": {
            "default": {
                "plain": "a6561d7c",
                "symbol": "a1a8168f"
            }
        }
    },
    "line.activity.butterfly": {
        "default": {
            "default": {
                "plain": "0209beb5",
                "symbol": "3a659171"
            }
        },
        "v3": {
            "default": {
                "plain": "dbf01580",
                "symbol": "3d006546"
            }
        }
    },
    "line.activity.camping": {
        "default": {
            "default": {
                "plain": "db53d54f",
                "symbol": "2c1761bb"
            }
        },
        "v3": {
            "default": {
                "plain": "3836db74",
                "symbol": "0fe5a657"
            }
        }
    },
    "line.activity.clam": {
        "default": {
            "default": {
                "plain": "b430fa12",
                "symbol": "b884dea4"
            }
        },
        "v3": {
            "default": {
                "plain": "a8e23940",
                "symbol": "2b440f49"
            }
        }
    },
    "line.activity.cycle": {
        "default": {
            "default": {
                "plain": "e97e71f9",
                "symbol": "7fb98d08"
            }
        },
        "v3": {
            "default": {
                "plain": "37783fe2",
                "symbol": "a1263c26"
            }
        }
    },
    "line.activity.dance": {
        "default": {
            "default": {
                "plain": "563687c1",
                "symbol": "f8186c59"
            }
        },
        "v3": {
            "default": {
                "plain": "2bc5fea9",
                "symbol": "21682abd"
            }
        }
    },
    "line.activity.dart": {
        "default": {
            "default": {
                "plain": "6546ac7f",
                "symbol": "7f731ff4"
            }
        },
        "v3": {
            "default": {
                "plain": "025e193b",
                "symbol": "bc1b532c"
            }
        }
    },
    "line.activity.dumbbell": {
        "default": {
            "default": {
                "plain": "f9ba9387",
                "symbol": "3e002cbc"
            }
        },
        "v3": {
            "default": {
                "plain": "aecc6410",
                "symbol": "93372c78"
            }
        }
    },
    "line.activity.dumbbell-24": {
        "default": {
            "default": {
                "plain": "9d42fc54",
                "symbol": "7a7458a7"
            }
        },
        "v3": {
            "default": {
                "plain": "aecc6410",
                "symbol": "93372c78"
            }
        }
    },
    "line.activity.dumbbell-pay": {
        "default": {
            "default": {
                "plain": "a84fb0bd",
                "symbol": "fb615230"
            }
        },
        "v3": {
            "default": {
                "plain": "aecc6410",
                "symbol": "93372c78"
            }
        }
    },
    "line.activity.exposition": {
        "default": {
            "default": {
                "plain": "83d899a6",
                "symbol": "a10fd135"
            }
        },
        "v3": {
            "default": {
                "plain": "589c1051",
                "symbol": "caa0d44e"
            }
        }
    },
    "line.activity.ferris-wheel": {
        "default": {
            "default": {
                "plain": "92a8c720",
                "symbol": "282a733e"
            }
        },
        "v3": {
            "default": {
                "plain": "356bbbdf",
                "symbol": "ac657d99"
            }
        }
    },
    "line.activity.fish-water": {
        "default": {
            "default": {
                "plain": "cb101f6a",
                "symbol": "29de3642"
            }
        },
        "v3": {
            "default": {
                "plain": "6110702b",
                "symbol": "b3b54597"
            }
        }
    },
    "line.activity.fishing": {
        "default": {
            "default": {
                "plain": "ef47e6d6",
                "symbol": "90462356"
            }
        },
        "v3": {
            "default": {
                "plain": "8e1c59e8",
                "symbol": "83cd378d"
            }
        }
    },
    "line.activity.fishing-bird": {
        "default": {
            "default": {
                "plain": "f4380f0b",
                "symbol": "9efc6c81"
            }
        },
        "v3": {
            "default": {
                "plain": "6110702b",
                "symbol": "b3b54597"
            }
        }
    },
    "line.activity.fishing-net": {
        "default": {
            "default": {
                "plain": "21d311b4",
                "symbol": "e931801e"
            }
        },
        "v3": {
            "default": {
                "plain": "76b2ddba",
                "symbol": "d9386df1"
            }
        }
    },
    "line.activity.fishing-pay": {
        "default": {
            "default": {
                "plain": "3d0f9680",
                "symbol": "02b6ec47"
            }
        },
        "v3": {
            "default": {
                "plain": "8e1c59e8",
                "symbol": "83cd378d"
            }
        }
    },
    "line.activity.flower": {
        "default": {
            "default": {
                "plain": "88f60226",
                "symbol": "dc553391"
            }
        },
        "v3": {
            "default": {
                "plain": "7e1fa786",
                "symbol": "ff19bf9d"
            }
        }
    },
    "line.activity.forest": {
        "default": {
            "default": {
                "plain": "056b7fcc",
                "symbol": "5be0b2d6"
            }
        },
        "v3": {
            "default": {
                "plain": "c37a20e2",
                "symbol": "13a0af34"
            }
        }
    },
    "line.activity.gallery": {
        "default": {
            "default": {
                "plain": "50669c1e",
                "symbol": "41b72092"
            }
        },
        "v3": {
            "default": {
                "plain": "06d5c304",
                "symbol": "9d43c45a"
            }
        }
    },
    "line.activity.game": {
        "default": {
            "default": {
                "plain": "1602e826",
                "symbol": "444fb69e"
            }
        },
        "v3": {
            "default": {
                "plain": "f1d5e140",
                "symbol": "a6e8176e"
            }
        }
    },
    "line.activity.game-share": {
        "default": {
            "default": {
                "plain": "0f0d4544",
                "symbol": "9f9ebe0a"
            }
        },
        "v3": {
            "default": {
                "plain": "f1d5e140",
                "symbol": "a6e8176e"
            }
        }
    },
    "line.activity.gateball": {
        "default": {
            "default": {
                "plain": "4a8896c3",
                "symbol": "acfb73d6"
            }
        },
        "v3": {
            "default": {
                "plain": "3c3d1218",
                "symbol": "840e18f8"
            }
        }
    },
    "line.activity.go-game": {
        "default": {
            "default": {
                "plain": "b1433cb6",
                "symbol": "c644ab47"
            }
        },
        "v3": {
            "default": {
                "plain": "cf9d4e5d",
                "symbol": "67cb161a"
            }
        }
    },
    "line.activity.goggles": {
        "default": {
            "default": {
                "plain": "66724e00",
                "symbol": "6070a528"
            }
        },
        "v3": {
            "default": {
                "plain": "6a8bfdc3",
                "symbol": "d6374ff0"
            }
        }
    },
    "line.activity.golf": {
        "default": {
            "default": {
                "plain": "57068a54",
                "symbol": "de2f4a51"
            }
        },
        "v3": {
            "default": {
                "plain": "6b919c88",
                "symbol": "d4812021"
            }
        }
    },
    "line.activity.hang-gliding": {
        "default": {
            "default": {
                "plain": "ef8fb600",
                "symbol": "cb9b94b0"
            }
        },
        "v3": {
            "default": {
                "plain": "f403cf2f",
                "symbol": "061c175e"
            }
        }
    },
    "line.activity.hike": {
        "default": {
            "default": {
                "plain": "6f5d6039",
                "symbol": "a3f662f1"
            }
        },
        "v3": {
            "default": {
                "plain": "c736f3d0",
                "symbol": "a6b505a2"
            }
        }
    },
    "line.activity.horseride": {
        "default": {
            "default": {
                "plain": "850f3cc5",
                "symbol": "a2167103"
            }
        },
        "v3": {
            "default": {
                "plain": "b77ab0f9",
                "symbol": "a4ac3e11"
            }
        }
    },
    "line.activity.joystick": {
        "default": {
            "default": {
                "plain": "895460a9",
                "symbol": "2cac5ea6"
            }
        },
        "v3": {
            "default": {
                "plain": "fceaf988",
                "symbol": "c5d504a9"
            }
        }
    },
    "line.activity.karaoke": {
        "default": {
            "default": {
                "plain": "3a699620",
                "symbol": "20e8fa32"
            }
        },
        "v3": {
            "default": {
                "plain": "ca115324",
                "symbol": "55809774"
            }
        }
    },
    "line.activity.kick": {
        "default": {
            "default": {
                "plain": "64a64ecc",
                "symbol": "66b8b900"
            }
        },
        "v3": {
            "default": {
                "plain": "290defc3",
                "symbol": "8dd49c9a"
            }
        }
    },
    "line.activity.kids-club": {
        "default": {
            "default": {
                "plain": "b4b91b16",
                "symbol": "2698c824"
            }
        },
        "v3": {
            "default": {
                "plain": "99ac7f26",
                "symbol": "c8b8a7db"
            }
        }
    },
    "line.activity.leaf": {
        "default": {
            "default": {
                "plain": "80d422ed",
                "symbol": "a95f72d1"
            }
        },
        "v3": {
            "default": {
                "plain": "7fb9d542",
                "symbol": "a8148106"
            }
        }
    },
    "line.activity.mahjong": {
        "default": {
            "default": {
                "plain": "423b9286",
                "symbol": "3866a013"
            }
        },
        "v3": {
            "default": {
                "plain": "a9434fdd",
                "symbol": "373493a6"
            }
        }
    },
    "line.activity.mask": {
        "default": {
            "default": {
                "plain": "7c42e725",
                "symbol": "0efaf1bf"
            }
        },
        "v3": {
            "default": {
                "plain": "9d8ecdce",
                "symbol": "d7aa5018"
            }
        }
    },
    "line.activity.mat": {
        "default": {
            "default": {
                "plain": "d839283d",
                "symbol": "3d573d1e"
            }
        },
        "v3": {
            "default": {
                "plain": "0f05bb6b",
                "symbol": "004722c3"
            }
        }
    },
    "line.activity.mat-pay": {
        "default": {
            "default": {
                "plain": "3e389bb3",
                "symbol": "2fc3e265"
            }
        },
        "v3": {
            "default": {
                "plain": "0f05bb6b",
                "symbol": "004722c3"
            }
        }
    },
    "line.activity.meeting": {
        "default": {
            "default": {
                "plain": "18b37059",
                "symbol": "c3e128c0"
            }
        },
        "v3": {
            "default": {
                "plain": "45d07aeb",
                "symbol": "6bc56c6b"
            }
        }
    },
    "line.activity.mirrorball": {
        "default": {
            "default": {
                "plain": "1c82d3f6",
                "symbol": "0697edb9"
            }
        },
        "v3": {
            "default": {
                "plain": "2437cacc",
                "symbol": "6298a981"
            }
        }
    },
    "line.activity.museum": {
        "default": {
            "default": {
                "plain": "f2f229db",
                "symbol": "ea22ab99"
            }
        },
        "v3": {
            "default": {
                "plain": "46e6016f",
                "symbol": "922793bb"
            }
        }
    },
    "line.activity.newspaper": {
        "default": {
            "default": {
                "plain": "be7fc8f5",
                "symbol": "83e5573c"
            }
        },
        "v3": {
            "default": {
                "plain": "3f73b6b6",
                "symbol": "f6e66f81"
            }
        }
    },
    "line.activity.noh-stage": {
        "default": {
            "default": {
                "plain": "9292d5a7",
                "symbol": "2eebf1c7"
            }
        },
        "v3": {
            "default": {
                "plain": "9fcf50c4",
                "symbol": "9ed77beb"
            }
        }
    },
    "line.activity.orienteer": {
        "default": {
            "default": {
                "plain": "94201a33",
                "symbol": "62bcd738"
            }
        },
        "v3": {
            "default": {
                "plain": "a9d941e1",
                "symbol": "9fd5bc3d"
            }
        }
    },
    "line.activity.pillar": {
        "default": {
            "default": {
                "plain": "3f608c74",
                "symbol": "6f56a0cb"
            }
        },
        "v3": {
            "default": {
                "plain": "45fc2025",
                "symbol": "9e50bbc4"
            }
        }
    },
    "line.activity.pingpong": {
        "default": {
            "default": {
                "plain": "1faaddf2",
                "symbol": "eea7f809"
            }
        },
        "v3": {
            "default": {
                "plain": "19e09f96",
                "symbol": "89bfdc0d"
            }
        }
    },
    "line.activity.play": {
        "default": {
            "default": {
                "plain": "7370573c",
                "symbol": "4879bd90"
            }
        },
        "v3": {
            "default": {
                "plain": "2cf8b005",
                "symbol": "49347879"
            }
        }
    },
    "line.activity.play-pay": {
        "default": {
            "default": {
                "plain": "c23af5d7",
                "symbol": "77b7f9d1"
            }
        },
        "v3": {
            "default": {
                "plain": "209af935",
                "symbol": "607ffc35"
            }
        }
    },
    "line.activity.playground": {
        "default": {
            "default": {
                "plain": "d2c6bd96",
                "symbol": "7ee7ba70"
            }
        },
        "v3": {
            "default": {
                "plain": "967a88f7",
                "symbol": "4ade2b55"
            }
        }
    },
    "line.activity.poker": {
        "default": {
            "default": {
                "plain": "3dacce8b",
                "symbol": "69250902"
            }
        },
        "v3": {
            "default": {
                "plain": "030d418f",
                "symbol": "49ff02a3"
            }
        }
    },
    "line.activity.ropes": {
        "default": {
            "default": {
                "plain": "6773b644",
                "symbol": "faf17311"
            }
        },
        "v3": {
            "default": {
                "plain": "1d1dc2e6",
                "symbol": "debd90cb"
            }
        }
    },
    "line.activity.rugby": {
        "default": {
            "default": {
                "plain": "694f49ec",
                "symbol": "9380ddcd"
            }
        },
        "v3": {
            "default": {
                "plain": "29c5beb1",
                "symbol": "dd4663d8"
            }
        }
    },
    "line.activity.run": {
        "default": {
            "default": {
                "plain": "56ac07cc",
                "symbol": "b8194b31"
            }
        },
        "v3": {
            "default": {
                "plain": "7083efcb",
                "symbol": "85393a76"
            }
        }
    },
    "line.activity.scuba-dive": {
        "default": {
            "default": {
                "plain": "8037f596",
                "symbol": "e1e8b599"
            }
        },
        "v3": {
            "default": {
                "plain": "0e5e1df6",
                "symbol": "095ace8c"
            }
        }
    },
    "line.activity.shogi": {
        "default": {
            "default": {
                "plain": "dabccb9b",
                "symbol": "92baf298"
            }
        },
        "v3": {
            "default": {
                "plain": "80028687",
                "symbol": "e253ae91"
            }
        }
    },
    "line.activity.shrine-jp": {
        "default": {
            "default": {
                "plain": "1a292118",
                "symbol": "576c8b0a"
            }
        },
        "v3": {
            "default": {
                "plain": "fe894581",
                "symbol": "01c4387d"
            }
        }
    },
    "line.activity.skateboard": {
        "default": {
            "default": {
                "plain": "ede3639a",
                "symbol": "4dc0d7a7"
            }
        },
        "v3": {
            "default": {
                "plain": "8db6dc7e",
                "symbol": "93268128"
            }
        }
    },
    "line.activity.ski": {
        "default": {
            "default": {
                "plain": "61683bcd",
                "symbol": "1e431053"
            }
        },
        "v3": {
            "default": {
                "plain": "152331b1",
                "symbol": "4f5e623c"
            }
        }
    },
    "line.activity.ski-cloth-pay": {
        "default": {
            "default": {
                "plain": "88a085f8",
                "symbol": "db6f2aac"
            }
        },
        "v3": {
            "default": {
                "plain": "aa5cd96f",
                "symbol": "4f5116b3"
            }
        }
    },
    "line.activity.ski-pay": {
        "default": {
            "default": {
                "plain": "9fd5dd17",
                "symbol": "dca0b3ed"
            }
        },
        "v3": {
            "default": {
                "plain": "6554777a",
                "symbol": "3f603860"
            }
        }
    },
    "line.activity.ski-shoe-pay": {
        "default": {
            "default": {
                "plain": "b7f5903c",
                "symbol": "b0b07b67"
            }
        },
        "v3": {
            "default": {
                "plain": "194adade",
                "symbol": "0467a522"
            }
        }
    },
    "line.activity.sled-pay": {
        "default": {
            "default": {
                "plain": "9c45a841",
                "symbol": "555da5d4"
            }
        },
        "v3": {
            "default": {
                "plain": "6ac26bd6",
                "symbol": "ef74ae03"
            }
        }
    },
    "line.activity.snowboard-pay": {
        "default": {
            "default": {
                "plain": "7f9157d2",
                "symbol": "87ed3b10"
            }
        },
        "v3": {
            "default": {
                "plain": "c0e48cc3",
                "symbol": "4a3a9033"
            }
        }
    },
    "line.activity.sports-ground": {
        "default": {
            "default": {
                "plain": "55c9f015",
                "symbol": "9ed36ea2"
            }
        },
        "v3": {
            "default": {
                "plain": "12ea8777",
                "symbol": "a6f10523"
            }
        }
    },
    "line.activity.squash": {
        "default": {
            "default": {
                "plain": "e0e683fb",
                "symbol": "50081534"
            }
        },
        "v3": {
            "default": {
                "plain": "35850dfe",
                "symbol": "26882d58"
            }
        }
    },
    "line.activity.sunbath": {
        "default": {
            "default": {
                "plain": "8a95349b",
                "symbol": "5e2366f4"
            }
        },
        "v3": {
            "default": {
                "plain": "4a57482c",
                "symbol": "98d34792"
            }
        }
    },
    "line.activity.surf": {
        "default": {
            "default": {
                "plain": "72529217",
                "symbol": "e1e4911c"
            }
        },
        "v3": {
            "default": {
                "plain": "c1053e6d",
                "symbol": "b548125e"
            }
        }
    },
    "line.activity.swim-indoor": {
        "default": {
            "default": {
                "plain": "6f8fd880",
                "symbol": "65577788"
            }
        },
        "v3": {
            "default": {
                "plain": "ffd6758b",
                "symbol": "c54f9e7b"
            }
        }
    },
    "line.activity.swim-outdoor": {
        "default": {
            "default": {
                "plain": "ec9e4d64",
                "symbol": "0279e734"
            }
        },
        "v3": {
            "default": {
                "plain": "ffd6758b",
                "symbol": "c54f9e7b"
            }
        }
    },
    "line.activity.tennis": {
        "default": {
            "default": {
                "plain": "f546d137",
                "symbol": "63a57790"
            }
        },
        "v3": {
            "default": {
                "plain": "35850dfe",
                "symbol": "26882d58"
            }
        }
    },
    "line.activity.tennis-pay": {
        "default": {
            "default": {
                "plain": "fd767945",
                "symbol": "bed19f2b"
            }
        },
        "v3": {
            "default": {
                "plain": "35850dfe",
                "symbol": "26882d58"
            }
        }
    },
    "line.activity.tent": {
        "default": {
            "default": {
                "plain": "2f819bba",
                "symbol": "caf22800"
            }
        },
        "v3": {
            "default": {
                "plain": "5ad95725",
                "symbol": "ee505970"
            }
        }
    },
    "line.activity.ticket": {
        "default": {
            "default": {
                "plain": "fdfbf4a9",
                "symbol": "fa33d301"
            }
        },
        "v3": {
            "default": {
                "plain": "11e43de5",
                "symbol": "c92ba070"
            }
        }
    },
    "line.activity.treadmill": {
        "default": {
            "default": {
                "plain": "9ae07585",
                "symbol": "fb104f9d"
            }
        },
        "v3": {
            "default": {
                "plain": "e2098acd",
                "symbol": "fba16ad8"
            }
        }
    },
    "line.activity.treadmill-pay": {
        "default": {
            "default": {
                "plain": "7426ece9",
                "symbol": "0370dbd3"
            }
        },
        "v3": {
            "default": {
                "plain": "e2098acd",
                "symbol": "fba16ad8"
            }
        }
    },
    "line.activity.volleyball": {
        "default": {
            "default": {
                "plain": "5793f992",
                "symbol": "c203de34"
            }
        },
        "v3": {
            "default": {
                "plain": "5d61ee5c",
                "symbol": "52fac69a"
            }
        }
    },
    "line.activity.walk": {
        "default": {
            "default": {
                "plain": "b8d7fda8",
                "symbol": "6ceeb4d7"
            }
        },
        "v3": {
            "default": {
                "plain": "2f68ba7a",
                "symbol": "6a4488bf"
            }
        }
    },
    "line.activity.walk-no": {
        "default": {
            "default": {
                "plain": "0bff39d2",
                "symbol": "79307553"
            }
        },
        "v3": {
            "default": {
                "plain": "7545064c",
                "symbol": "442116d7"
            }
        }
    },
    "line.activity.wind-surf": {
        "default": {
            "default": {
                "plain": "cde69cd6",
                "symbol": "6cc05f9d"
            }
        },
        "v3": {
            "default": {
                "plain": "244e808e",
                "symbol": "2d57a220"
            }
        }
    },
    "line.activity.yoga": {
        "default": {
            "default": {
                "plain": "577395e7",
                "symbol": "3626a5f0"
            }
        },
        "v3": {
            "default": {
                "plain": "df546178",
                "symbol": "f36604d0"
            }
        }
    },
    "line.activity.yoga-pay": {
        "default": {
            "default": {
                "plain": "c1a21ea5",
                "symbol": "a406305a"
            }
        },
        "v3": {
            "default": {
                "plain": "df546178",
                "symbol": "f36604d0"
            }
        }
    },
    "line.amenity.apron": {
        "default": {
            "default": {
                "plain": "28215e08",
                "symbol": "133125b1"
            }
        },
        "v3": {
            "default": {
                "plain": "9cacf35a",
                "symbol": "5100a217"
            }
        }
    },
    "line.amenity.baby-changing-room": {
        "default": {
            "default": {
                "plain": "32068b01",
                "symbol": "ba89cfc9"
            }
        },
        "v3": {
            "default": {
                "plain": "5322615a",
                "symbol": "bdaf436f"
            }
        }
    },
    "line.amenity.baby-safety-gate": {
        "default": {
            "default": {
                "plain": "a5066352",
                "symbol": "cae6c87c"
            }
        },
        "v3": {
            "default": {
                "plain": "7e4f0dcc",
                "symbol": "abee0196"
            }
        }
    },
    "line.amenity.backpack": {
        "default": {
            "default": {
                "plain": "c3a185f8",
                "symbol": "ff70c9e2"
            }
        },
        "v3": {
            "default": {
                "plain": "9442ea1a",
                "symbol": "17bb842b"
            }
        }
    },
    "line.amenity.backpack-check": {
        "default": {
            "default": {
                "plain": "ce5589a4",
                "symbol": "7af1984c"
            }
        },
        "v3": {
            "default": {
                "plain": "e8479b7f",
                "symbol": "2cf7edd3"
            }
        }
    },
    "line.amenity.backpack-no": {
        "default": {
            "default": {
                "plain": "c9138ae1",
                "symbol": "04c3114e"
            }
        },
        "v3": {
            "default": {
                "plain": "4d973060",
                "symbol": "8e6135a6"
            }
        }
    },
    "line.amenity.backpack-pay": {
        "default": {
            "default": {
                "plain": "741ee39e",
                "symbol": "e49225c8"
            }
        },
        "v3": {
            "default": {
                "plain": "c0441648",
                "symbol": "bc2aa0bd"
            }
        }
    },
    "line.amenity.bag-business": {
        "default": {
            "default": {
                "plain": "2c8e07b3",
                "symbol": "a2dc621b"
            }
        },
        "v3": {
            "default": {
                "plain": "292230c8",
                "symbol": "471eb1ad"
            }
        }
    },
    "line.amenity.bag-key": {
        "default": {
            "default": {
                "plain": "9c432d72",
                "symbol": "6bf7dec2"
            }
        },
        "v3": {
            "default": {
                "plain": "b07f99fa",
                "symbol": "0405abb5"
            }
        }
    },
    "line.amenity.bag-safe": {
        "default": {
            "default": {
                "plain": "b445fcf4",
                "symbol": "040e79d6"
            }
        },
        "v3": {
            "default": {
                "plain": "f5acc57e",
                "symbol": "fdae351a"
            }
        }
    },
    "line.amenity.bag-travel": {
        "default": {
            "default": {
                "plain": "2e2a1949",
                "symbol": "c875e0e6"
            }
        },
        "v3": {
            "default": {
                "plain": "12c10b99",
                "symbol": "265af6a3"
            }
        }
    },
    "line.amenity.bag-travel-no": {
        "default": {
            "default": {
                "plain": "3ea76dfe",
                "symbol": "6bc0df90"
            }
        },
        "v3": {
            "default": {
                "plain": "8ac64efd",
                "symbol": "8a34a665"
            }
        }
    },
    "line.amenity.bathrobes": {
        "default": {
            "default": {
                "plain": "bad8c391",
                "symbol": "da7599b5"
            }
        },
        "v3": {
            "default": {
                "plain": "0eb690ad",
                "symbol": "dac84f2f"
            }
        }
    },
    "line.amenity.cabin-bag": {
        "default": {
            "default": {
                "plain": "3312db02",
                "symbol": "a912d485"
            }
        },
        "v3": {
            "default": {
                "plain": "5f84cfe9",
                "symbol": "ea99a4ce"
            }
        }
    },
    "line.amenity.cabin-bag-check": {
        "default": {
            "default": {
                "plain": "0217ef9b",
                "symbol": "1d50b6d9"
            }
        },
        "v3": {
            "default": {
                "plain": "d2d98929",
                "symbol": "1ac181d8"
            }
        }
    },
    "line.amenity.cabin-bag-no": {
        "default": {
            "default": {
                "plain": "a4121b3a",
                "symbol": "527362aa"
            }
        },
        "v3": {
            "default": {
                "plain": "3188f570",
                "symbol": "fea2dfee"
            }
        }
    },
    "line.amenity.cabin-bag-pay": {
        "default": {
            "default": {
                "plain": "d671e1a2",
                "symbol": "dbeb02e8"
            }
        },
        "v3": {
            "default": {
                "plain": "3047feae",
                "symbol": "ef2a1446"
            }
        }
    },
    "line.amenity.clock": {
        "default": {
            "default": {
                "plain": "da766949",
                "symbol": "4d51fe68"
            }
        },
        "v3": {
            "default": {
                "plain": "205dca96",
                "symbol": "b2c6d02b"
            }
        }
    },
    "line.amenity.comb-scissor": {
        "default": {
            "default": {
                "plain": "53a45946",
                "symbol": "78857e7d"
            }
        },
        "v3": {
            "default": {
                "plain": "fc17e348",
                "symbol": "b308b45d"
            }
        }
    },
    "line.amenity.cosmetic": {
        "default": {
            "default": {
                "plain": "4fa7134d",
                "symbol": "03c82c93"
            }
        },
        "v3": {
            "default": {
                "plain": "4f26676a",
                "symbol": "515888f8"
            }
        }
    },
    "line.amenity.donotuse-luggage": {
        "default": {
            "default": {
                "plain": "eec28b49",
                "symbol": "c9afe807"
            }
        }
    },
    "line.amenity.donotuse-luggage-check": {
        "default": {
            "default": {
                "plain": "03088b8e",
                "symbol": "34932d95"
            }
        }
    },
    "line.amenity.donotuse-luggage-no": {
        "default": {
            "default": {
                "plain": "740e04d2",
                "symbol": "af11f4d2"
            }
        }
    },
    "line.amenity.donotuse-luggage-pay": {
        "default": {
            "default": {
                "plain": "a735fc96",
                "symbol": "00c32119"
            }
        }
    },
    "line.amenity.facemask": {
        "default": {
            "default": {
                "plain": "c0d84f5e",
                "symbol": "d8c1d192"
            }
        },
        "v3": {
            "default": {
                "plain": "a3415be6",
                "symbol": "7b2702f0"
            }
        }
    },
    "line.amenity.facemask-cross": {
        "default": {
            "default": {
                "plain": "ece7530e",
                "symbol": "416d73d0"
            }
        },
        "v3": {
            "default": {
                "plain": "f2582d66",
                "symbol": "e9cc4c53"
            }
        }
    },
    "line.amenity.hanger": {
        "default": {
            "default": {
                "plain": "b2a519e0",
                "symbol": "a914eb4c"
            }
        },
        "v3": {
            "default": {
                "plain": "efb998d6",
                "symbol": "43b73909"
            }
        }
    },
    "line.amenity.key": {
        "default": {
            "default": {
                "plain": "b0a1edb6",
                "symbol": "81de4e3b"
            }
        },
        "v3": {
            "default": {
                "plain": "b07f99fa",
                "symbol": "0405abb5"
            }
        }
    },
    "line.amenity.key-no": {
        "default": {
            "default": {
                "plain": "37c1dab9",
                "symbol": "d46439a0"
            }
        },
        "v3": {
            "default": {
                "plain": "0fa67aff",
                "symbol": "495c75f8"
            }
        }
    },
    "line.amenity.kitchenware": {
        "default": {
            "default": {
                "plain": "e4613a5d",
                "symbol": "380285ce"
            }
        },
        "v3": {
            "default": {
                "plain": "0c0ab3e3",
                "symbol": "67c7cd47"
            }
        }
    },
    "line.amenity.linen": {
        "default": {
            "default": {
                "plain": "7c77bc06",
                "symbol": "3a080c88"
            }
        },
        "v3": {
            "default": {
                "plain": "f619befe",
                "symbol": "0b8e8def"
            }
        }
    },
    "line.amenity.luggage": {
        "default": {
            "default": {
                "plain": "8dcec3f8",
                "symbol": "bc333ea7"
            }
        },
        "v3": {
            "default": {
                "plain": "8f3324e0",
                "symbol": "499c64b0"
            }
        }
    },
    "line.amenity.luggage-check": {
        "default": {
            "default": {
                "plain": "6b6f89ab",
                "symbol": "77c8b0cd"
            }
        },
        "v3": {
            "default": {
                "plain": "23144a23",
                "symbol": "a1da29ee"
            }
        }
    },
    "line.amenity.luggage-heart": {
        "default": {
            "default": {
                "plain": "5965400e",
                "symbol": "dfa3b34d"
            }
        },
        "v3": {
            "default": {
                "plain": "2ea86d78",
                "symbol": "722d21ad"
            }
        }
    },
    "line.amenity.luggage-no": {
        "default": {
            "default": {
                "plain": "4094d7fa",
                "symbol": "3519352e"
            }
        },
        "v3": {
            "default": {
                "plain": "7725223b",
                "symbol": "277a994a"
            }
        }
    },
    "line.amenity.luggage-pay": {
        "default": {
            "default": {
                "plain": "02955680",
                "symbol": "61567c71"
            }
        },
        "v3": {
            "default": {
                "plain": "a9979ee2",
                "symbol": "6f298294"
            }
        }
    },
    "line.amenity.mirror": {
        "default": {
            "default": {
                "plain": "040fdadd",
                "symbol": "c3456340"
            }
        },
        "v3": {
            "default": {
                "plain": "4c8a17e8",
                "symbol": "8f555ba1"
            }
        }
    },
    "line.amenity.razor": {
        "default": {
            "default": {
                "plain": "cfb8f09a",
                "symbol": "51d0248a"
            }
        },
        "v3": {
            "default": {
                "plain": "aad163a9",
                "symbol": "b184fde3"
            }
        }
    },
    "line.amenity.ring": {
        "default": {
            "default": {
                "plain": "618bd25c",
                "symbol": "fcd08f03"
            }
        },
        "v3": {
            "default": {
                "plain": "dec40ca1",
                "symbol": "7c7f6254"
            }
        }
    },
    "line.amenity.sanitizer": {
        "default": {
            "default": {
                "plain": "50edea61",
                "symbol": "897d262e"
            }
        },
        "v3": {
            "default": {
                "plain": "1af2462f",
                "symbol": "ac8212b5"
            }
        }
    },
    "line.amenity.scissor": {
        "default": {
            "default": {
                "plain": "cd04277b",
                "symbol": "37dc90be"
            }
        },
        "v3": {
            "default": {
                "plain": "ea54e507",
                "symbol": "f6f99f0f"
            }
        }
    },
    "line.amenity.sewing": {
        "default": {
            "default": {
                "plain": "71ee6dfe",
                "symbol": "06543631"
            }
        },
        "v3": {
            "default": {
                "plain": "0e86db61",
                "symbol": "53694b42"
            }
        }
    },
    "line.amenity.shoeshine": {
        "default": {
            "default": {
                "plain": "37fc194d",
                "symbol": "6a65e95d"
            }
        },
        "v3": {
            "default": {
                "plain": "2e5738eb",
                "symbol": "5f67215d"
            }
        }
    },
    "line.amenity.shopping-bag": {
        "default": {
            "default": {
                "plain": "0c636157",
                "symbol": "35a3e5ce"
            }
        },
        "v3": {
            "default": {
                "plain": "062a27b6",
                "symbol": "48c63d33"
            }
        }
    },
    "line.amenity.slipper": {
        "default": {
            "default": {
                "plain": "dbcf706f",
                "symbol": "629728f9"
            }
        },
        "v3": {
            "default": {
                "plain": "19a94d93",
                "symbol": "f5418792"
            }
        }
    },
    "line.amenity.step-stool": {
        "default": {
            "default": {
                "plain": "9e5c6878",
                "symbol": "19fdfe78"
            }
        }
    },
    "line.amenity.toiletries": {
        "default": {
            "default": {
                "plain": "2908f86f",
                "symbol": "efccef9a"
            }
        },
        "v3": {
            "default": {
                "plain": "4d63454e",
                "symbol": "1f601a14"
            }
        }
    },
    "line.amenity.tool": {
        "default": {
            "default": {
                "plain": "f9c21046",
                "symbol": "d29220df"
            }
        },
        "v3": {
            "default": {
                "plain": "d2b924e6",
                "symbol": "dfccd4d1"
            }
        }
    },
    "line.amenity.toothbrush": {
        "default": {
            "default": {
                "plain": "c1e29fa1",
                "symbol": "a62e8d7d"
            }
        },
        "v3": {
            "default": {
                "plain": "c32c2a95",
                "symbol": "93bdf6a3"
            }
        }
    },
    "line.amenity.towel": {
        "default": {
            "default": {
                "plain": "15443de3",
                "symbol": "9ce32976"
            }
        },
        "v3": {
            "default": {
                "plain": "ca95c132",
                "symbol": "bdee0914"
            }
        }
    },
    "line.amenity.toy": {
        "default": {
            "default": {
                "plain": "b024ea0d",
                "symbol": "5ebfd15e"
            }
        },
        "v3": {
            "default": {
                "plain": "99ac7f26",
                "symbol": "c8b8a7db"
            }
        }
    },
    "line.amenity.trouser": {
        "default": {
            "default": {
                "plain": "b024e393",
                "symbol": "8a4de29b"
            }
        },
        "v3": {
            "default": {
                "plain": "fe7e816b",
                "symbol": "58f06e32"
            }
        }
    },
    "line.amenity.umbrella": {
        "default": {
            "default": {
                "plain": "6f9f14a2",
                "symbol": "f4bf576a"
            }
        },
        "v3": {
            "default": {
                "plain": "59e07fee",
                "symbol": "aa1de372"
            }
        }
    },
    "line.amenity.waterbottle": {
        "default": {
            "default": {
                "plain": "78fadcd0",
                "symbol": "efb44aa8"
            }
        },
        "v3": {
            "default": {
                "plain": "7af815ba",
                "symbol": "0235f367"
            }
        }
    },
    "line.amenity.yukata": {
        "default": {
            "default": {
                "plain": "7ed9a9a7",
                "symbol": "65cc4860"
            }
        },
        "v3": {
            "default": {
                "plain": "ab737148",
                "symbol": "4aa3c3a2"
            }
        }
    },
    "line.arrow.back": {
        "default": {
            "android": {
                "plain": "3ed717c2",
                "symbol": "d96d138f"
            },
            "default": {
                "plain": "a63ff36f",
                "symbol": "cef1b2ea"
            },
            "ios": {
                "plain": "cb2b3915",
                "symbol": "457bcbea"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "android": {
                "plain": "641454d0",
                "symbol": "d36b90da"
            },
            "default": {
                "plain": "84468e6d",
                "symbol": "b88238a9"
            },
            "ios": {
                "plain": "60f5eaeb",
                "symbol": "bee28aa2"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.bothway": {
        "default": {
            "default": {
                "plain": "a0df49c2",
                "symbol": "c3a7ac7d"
            }
        }
    },
    "line.arrow.channel": {
        "default": {
            "default": {
                "plain": "4118c4f5",
                "symbol": "539fce21"
            }
        },
        "v3": {
            "default": {
                "plain": "f7abf865",
                "symbol": "31fee591"
            }
        }
    },
    "line.arrow.circle-down": {
        "default": {
            "default": {
                "plain": "cfddfceb",
                "symbol": "5288b6a4"
            }
        },
        "v3": {
            "default": {
                "plain": "732b8d0d",
                "symbol": "bcfe084a"
            }
        }
    },
    "line.arrow.circle-left": {
        "default": {
            "default": {
                "plain": "b609bbfa",
                "symbol": "763deaeb"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "b247c504",
                "symbol": "af175c9a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.circle-right": {
        "default": {
            "default": {
                "plain": "7c4f5190",
                "symbol": "56b75ab7"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "6803a1e0",
                "symbol": "a585e9ea"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.circle-up": {
        "default": {
            "default": {
                "plain": "e31166ef",
                "symbol": "d063e8b5"
            }
        },
        "v3": {
            "default": {
                "plain": "2f8a2084",
                "symbol": "c401c5af"
            }
        }
    },
    "line.arrow.currency": {
        "default": {
            "default": {
                "plain": "f8a38b8f",
                "symbol": "2177341a"
            }
        }
    },
    "line.arrow.dbl-down": {
        "default": {
            "default": {
                "plain": "c3a58b9d",
                "symbol": "fbbb7f3f"
            }
        },
        "v3": {
            "default": {
                "plain": "42767228",
                "symbol": "274823f4"
            }
        }
    },
    "line.arrow.dbl-left": {
        "default": {
            "default": {
                "plain": "f37d430f",
                "symbol": "7c7e7a71"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "eb1f4b45",
                "symbol": "a43e8f9d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.dbl-right": {
        "default": {
            "default": {
                "plain": "c526b430",
                "symbol": "5d85528d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "79400576",
                "symbol": "dc50d255"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.dbl-up": {
        "default": {
            "default": {
                "plain": "ba8d842d",
                "symbol": "9bf3139b"
            }
        },
        "v3": {
            "default": {
                "plain": "b924fa0d",
                "symbol": "05e8d23c"
            }
        }
    },
    "line.arrow.download": {
        "default": {
            "default": {
                "plain": "dd286847",
                "symbol": "882ece44"
            }
        },
        "v3": {
            "default": {
                "plain": "445ea06e",
                "symbol": "f03bb5a3"
            }
        }
    },
    "line.arrow.exchange": {
        "default": {
            "default": {
                "plain": "648943a0",
                "symbol": "d96bbe73"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "160b5610",
                "symbol": "fa2446db"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.leftdown": {
        "default": {
            "default": {
                "plain": "f357b63f",
                "symbol": "2f31b46c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "d0309f49",
                "symbol": "58626662"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.loop": {
        "default": {
            "default": {
                "plain": "22712296",
                "symbol": "52950d04"
            }
        },
        "v3": {
            "default": {
                "plain": "67a87b3a",
                "symbol": "2adecb6d"
            }
        }
    },
    "line.arrow.newpage": {
        "default": {
            "default": {
                "plain": "522f3b3c",
                "symbol": "bf43e71c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "02457a6f",
                "symbol": "dd25affe"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.oneway": {
        "default": {
            "default": {
                "plain": "7f727154",
                "symbol": "5272fb0f"
            }
        }
    },
    "line.arrow.processing": {
        "default": {
            "default": {
                "plain": "dea7f657",
                "symbol": "7c821b8a"
            }
        },
        "v3": {
            "default": {
                "plain": "83e3d763",
                "symbol": "b070a61e"
            }
        }
    },
    "line.arrow.rightdown": {
        "default": {
            "default": {
                "plain": "1504c039",
                "symbol": "4ad68429"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "c965e07f",
                "symbol": "0e90d922"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.rotate": {
        "default": {
            "default": {
                "plain": "f8233885",
                "symbol": "1d3debc4"
            }
        },
        "v3": {
            "default": {
                "plain": "ae7d51c2",
                "symbol": "1c85fc6e"
            }
        }
    },
    "line.arrow.rotate-360": {
        "default": {
            "default": {
                "plain": "26443384",
                "symbol": "7cf1eb33"
            }
        }
    },
    "line.arrow.rotate2": {
        "default": {
            "default": {
                "plain": "94acab43",
                "symbol": "57f38031"
            }
        }
    },
    "line.arrow.scroll-top": {
        "default": {
            "default": {
                "plain": "6ad432ee",
                "symbol": "3a7946ac"
            }
        },
        "v3": {
            "default": {
                "plain": "28ca1d12",
                "symbol": "0a78f1c0"
            }
        }
    },
    "line.arrow.share": {
        "default": {
            "default": {
                "plain": "3bb2a5f9",
                "symbol": "d5665f43"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "8b7b9e8f",
                "symbol": "69d9fa9a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.sign-out": {
        "default": {
            "default": {
                "plain": "decd88e0",
                "symbol": "041a6fd5"
            }
        }
    },
    "line.arrow.size": {
        "default": {
            "default": {
                "plain": "633208f0",
                "symbol": "4498bfc3"
            }
        },
        "v3": {
            "default": {
                "plain": "f6102de5",
                "symbol": "4b07549c"
            }
        }
    },
    "line.arrow.sort": {
        "default": {
            "default": {
                "plain": "737dca34",
                "symbol": "e86f7c47"
            }
        },
        "v3": {
            "default": {
                "plain": "f5defe72",
                "symbol": "73cd7dd7"
            }
        }
    },
    "line.arrow.thick-back": {
        "default": {
            "default": {
                "plain": "0d5393ee",
                "symbol": "3e0699c6"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "35985056",
                "symbol": "9b98f007"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thick-collapse": {
        "default": {
            "default": {
                "plain": "7142b79b",
                "symbol": "ed2ff1c5"
            }
        },
        "v3": {
            "default": {
                "plain": "e50a04e4",
                "symbol": "fa5a4bb7"
            }
        }
    },
    "line.arrow.thick-down": {
        "default": {
            "default": {
                "plain": "caf770a0",
                "symbol": "e23785a0"
            }
        },
        "v3": {
            "default": {
                "plain": "00f1c1ff",
                "symbol": "a5380ec3"
            }
        }
    },
    "line.arrow.thick-dropdown": {
        "default": {
            "default": {
                "plain": "e22a3c0b",
                "symbol": "5556faa6"
            }
        },
        "v3": {
            "default": {
                "plain": "0f10a78b",
                "symbol": "92328793"
            }
        }
    },
    "line.arrow.thick-forward": {
        "default": {
            "default": {
                "plain": "aab2785d",
                "symbol": "8d503fdd"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "8bc5e802",
                "symbol": "fd841e7e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thick-left": {
        "default": {
            "default": {
                "plain": "eb46dde9",
                "symbol": "4558a79d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "19121b16",
                "symbol": "605cbe3b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thick-leftright": {
        "default": {
            "default": {
                "plain": "4e3b373b",
                "symbol": "9523d750"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "cb4e8130",
                "symbol": "99f33454"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thick-leftup": {
        "default": {
            "default": {
                "plain": "97483cd9",
                "symbol": "8c9dc5f3"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "2ab7dc2b",
                "symbol": "aaf32c6d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thick-right": {
        "default": {
            "default": {
                "plain": "8cfff297",
                "symbol": "5788f049"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "d0f15796",
                "symbol": "f239361b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thick-rightdown": {
        "default": {
            "default": {
                "plain": "b00b339b",
                "symbol": "fdea3e4f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "bebcdd3a",
                "symbol": "01ab5d9e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thick-up": {
        "default": {
            "default": {
                "plain": "37961db3",
                "symbol": "d40e0c9e"
            }
        },
        "v3": {
            "default": {
                "plain": "c99f73e2",
                "symbol": "ee94e553"
            }
        }
    },
    "line.arrow.thick-updown": {
        "default": {
            "default": {
                "plain": "c01191c1",
                "symbol": "d45c0131"
            }
        },
        "v3": {
            "default": {
                "plain": "4f9d72e8",
                "symbol": "b158ede1"
            }
        }
    },
    "line.arrow.thin-back": {
        "default": {
            "default": {
                "plain": "d03e1314",
                "symbol": "cd6d2826"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "de9319d5",
                "symbol": "a75e6ca8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thin-collapse": {
        "default": {
            "default": {
                "plain": "c30f2ab8",
                "symbol": "437158b1"
            }
        },
        "v3": {
            "default": {
                "plain": "0c7a36e8",
                "symbol": "9416530f"
            }
        }
    },
    "line.arrow.thin-down": {
        "default": {
            "default": {
                "plain": "900f6636",
                "symbol": "61e48a8a"
            }
        },
        "v3": {
            "default": {
                "plain": "535c3245",
                "symbol": "81ce346d"
            }
        }
    },
    "line.arrow.thin-dropdown": {
        "default": {
            "default": {
                "plain": "2ea63f3b",
                "symbol": "9711fb1d"
            }
        },
        "v3": {
            "default": {
                "plain": "842645f9",
                "symbol": "f35682ee"
            }
        }
    },
    "line.arrow.thin-forward": {
        "default": {
            "default": {
                "plain": "8b07fd3c",
                "symbol": "a23ff73b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "ae492043",
                "symbol": "86437a70"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thin-left": {
        "default": {
            "default": {
                "plain": "fd07e0d9",
                "symbol": "777642bb"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "5fc25709",
                "symbol": "9d6e4db8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thin-leftright": {
        "default": {
            "default": {
                "plain": "e43a3329",
                "symbol": "8d5fec17"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "3de8d577",
                "symbol": "62c82899"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thin-right": {
        "default": {
            "default": {
                "plain": "02950c92",
                "symbol": "009ffb51"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "ceb98792",
                "symbol": "5ec08d58"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.thin-up": {
        "default": {
            "default": {
                "plain": "6b64ff18",
                "symbol": "3ab948cf"
            }
        },
        "v3": {
            "default": {
                "plain": "5befd045",
                "symbol": "8a15fc40"
            }
        }
    },
    "line.arrow.thin-updown": {
        "default": {
            "default": {
                "plain": "733af0b6",
                "symbol": "f389bd26"
            }
        },
        "v3": {
            "default": {
                "plain": "d4681236",
                "symbol": "d78e7393"
            }
        }
    },
    "line.arrow.todown": {
        "default": {
            "default": {
                "plain": "7143d06a",
                "symbol": "37aafbc0"
            }
        },
        "v3": {
            "default": {
                "plain": "9fe05033",
                "symbol": "b8149269"
            }
        }
    },
    "line.arrow.totop": {
        "default": {
            "default": {
                "plain": "6fafa2ba",
                "symbol": "22c48cce"
            }
        },
        "v3": {
            "default": {
                "plain": "0d13466d",
                "symbol": "7dcd2fa0"
            }
        }
    },
    "line.arrow.turn": {
        "default": {
            "default": {
                "plain": "04a0f2ad",
                "symbol": "59bb16ae"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.turn-down-left": {
        "default": {
            "default": {
                "plain": "be482b3d",
                "symbol": "c06389de"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "83e2ee16",
                "symbol": "1c3e23bc"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.turn-down-right": {
        "default": {
            "default": {
                "plain": "94c8a1ca",
                "symbol": "dc5901c9"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "9fbb4945",
                "symbol": "9e9dbd76"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.turn-left": {
        "default": {
            "default": {
                "plain": "053cc7ca",
                "symbol": "d9fb4558"
            }
        }
    },
    "line.arrow.turn-right": {
        "default": {
            "default": {
                "plain": "b950c827",
                "symbol": "46b908fc"
            }
        }
    },
    "line.arrow.turn-up-left": {
        "default": {
            "default": {
                "plain": "eddffbbb",
                "symbol": "abe0bf53"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "36c5f18d",
                "symbol": "07fce7b3"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.turn-up-right": {
        "default": {
            "default": {
                "plain": "f57b4b89",
                "symbol": "9816c016"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "7b6f2f06",
                "symbol": "114ed3e1"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.upleft": {
        "default": {
            "default": {
                "plain": "2d55e7f3",
                "symbol": "b39422ed"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f1a90fbe",
                "symbol": "f5dd1f49"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.upload": {
        "default": {
            "default": {
                "plain": "46b7d762",
                "symbol": "56f9f44e"
            }
        },
        "v3": {
            "default": {
                "plain": "e1a20b16",
                "symbol": "0bd77a5c"
            }
        }
    },
    "line.arrow.upright": {
        "default": {
            "default": {
                "plain": "3421a90c",
                "symbol": "e1344ec9"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "65b8897b",
                "symbol": "fa708e63"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.arrow.zoom-in": {
        "default": {
            "default": {
                "plain": "77c836b2",
                "symbol": "2ef1d84e"
            }
        },
        "v3": {
            "default": {
                "plain": "71b15071",
                "symbol": "7a4ecad4"
            }
        }
    },
    "line.arrow.zoom-out": {
        "default": {
            "default": {
                "plain": "2ceaa08f",
                "symbol": "2e58bd90"
            }
        },
        "v3": {
            "default": {
                "plain": "dd832d87",
                "symbol": "64161f4e"
            }
        }
    },
    "line.brand.circle-ecodeal": {
        "default": {
            "default": {
                "plain": "09ac0473",
                "symbol": "da27d9ef"
            }
        }
    },
    "line.brand.circle-ecodeals": {
        "default": {
            "default": {
                "plain": "46b9dd2b",
                "symbol": "6f6b806b"
            }
        }
    },
    "line.brand.circle-loyaltycash": {
        "default": {
            "default": {
                "plain": "732a44c8",
                "symbol": "fc8d356a"
            }
        },
        "v3": {
            "default": {
                "plain": "d418b3f6",
                "symbol": "24ed7f38"
            }
        }
    },
    "line.brand.circle-mixsave": {
        "default": {
            "default": {
                "plain": "42f7d9cc",
                "symbol": "088ca634"
            }
        },
        "v3": {
            "default": {
                "plain": "da5d2e72",
                "symbol": "ba401620"
            }
        }
    },
    "line.brand.easycancel": {
        "default": {
            "default": {
                "plain": "d0633cdb",
                "symbol": "8f11a7e1"
            }
        }
    },
    "line.brand.ecodeal": {
        "default": {
            "default": {
                "plain": "a021cf94",
                "symbol": "f973d990"
            }
        }
    },
    "line.brand.ecodeals": {
        "default": {
            "default": {
                "plain": "46b9dd2b",
                "symbol": "89e335f1"
            }
        }
    },
    "line.brand.golocal": {
        "default": {
            "default": {
                "plain": "0dfe0de4",
                "symbol": "70edaafe"
            }
        }
    },
    "line.brand.homes": {
        "default": {
            "default": {
                "plain": "4cd5ef72",
                "symbol": "46b8b516"
            }
        },
        "v3": {
            "default": {
                "plain": "3e46f62b",
                "symbol": "09292f71"
            }
        }
    },
    "line.brand.homes2": {
        "default": {
            "default": {
                "plain": "5817d146",
                "symbol": "4bad0f87"
            }
        }
    },
    "line.brand.loyaltycash": {
        "default": {
            "default": {
                "plain": "b5fa12ac",
                "symbol": "2c68fcb0"
            }
        }
    },
    "line.brand.loyaltypoints": {
        "default": {
            "default": {
                "plain": "74b9292a",
                "symbol": "43673166"
            }
        },
        "v3": {
            "default": {
                "plain": "a01c3cf7",
                "symbol": "abecbaf2"
            }
        }
    },
    "line.brand.mixsave": {
        "default": {
            "default": {
                "plain": "31bb9456",
                "symbol": "bbe654ab"
            }
        }
    },
    "line.brand.specialoffers": {
        "default": {
            "default": {
                "plain": "bf2ca618",
                "symbol": "83dca86f"
            }
        },
        "v3": {
            "default": {
                "plain": "02797da0",
                "symbol": "2846b363"
            }
        }
    },
    "line.brand.tripsavings": {
        "default": {
            "default": {
                "plain": "6a04ff30",
                "symbol": "4b6aa5ae"
            }
        }
    },
    "line.brand.vipstar": {
        "default": {
            "default": {
                "plain": "9652715c",
                "symbol": "b802891e"
            }
        },
        "v3": {
            "default": {
                "plain": "b362f59b",
                "symbol": "c0cdbaa8"
            }
        }
    },
    "line.electrics.air-purifier": {
        "default": {
            "default": {
                "plain": "e6d853c6",
                "symbol": "0759ba08"
            }
        },
        "v3": {
            "default": {
                "plain": "90b6b8d2",
                "symbol": "c323e775"
            }
        }
    },
    "line.electrics.camera": {
        "default": {
            "default": {
                "plain": "9b3b2b81",
                "symbol": "96ef5814"
            }
        },
        "v3": {
            "default": {
                "plain": "467bf2c4",
                "symbol": "a097a6ea"
            }
        }
    },
    "line.electrics.camera-no": {
        "default": {
            "default": {
                "plain": "cb2e07fb",
                "symbol": "bf36fc02"
            }
        },
        "v3": {
            "default": {
                "plain": "afbd8831",
                "symbol": "bde96385"
            }
        }
    },
    "line.electrics.cd": {
        "default": {
            "default": {
                "plain": "20e91e32",
                "symbol": "e99416f8"
            }
        },
        "v3": {
            "default": {
                "plain": "dca456d0",
                "symbol": "a84ecbb9"
            }
        }
    },
    "line.electrics.cellphone": {
        "default": {
            "default": {
                "plain": "8d7b673c",
                "symbol": "ba0a51a7"
            }
        },
        "v3": {
            "default": {
                "plain": "32dcee7c",
                "symbol": "884c833f"
            }
        }
    },
    "line.electrics.coffee-maker": {
        "default": {
            "default": {
                "plain": "bd81372f",
                "symbol": "13b36f2f"
            }
        },
        "v3": {
            "default": {
                "plain": "cc1bb5a8",
                "symbol": "3ff0c80b"
            }
        }
    },
    "line.electrics.desktop": {
        "default": {
            "default": {
                "plain": "9c121577",
                "symbol": "6e7a9552"
            }
        },
        "v3": {
            "default": {
                "plain": "13e5e7ad",
                "symbol": "92613cf7"
            }
        }
    },
    "line.electrics.dial-pad": {
        "default": {
            "default": {
                "plain": "3928ea91",
                "symbol": "a1006296"
            }
        }
    },
    "line.electrics.dishwasher": {
        "default": {
            "default": {
                "plain": "2969cac0",
                "symbol": "4a174e57"
            }
        },
        "v3": {
            "default": {
                "plain": "aca6c91d",
                "symbol": "e0be98c2"
            }
        }
    },
    "line.electrics.dryer": {
        "default": {
            "default": {
                "plain": "ea978c54",
                "symbol": "dc148feb"
            }
        },
        "v3": {
            "default": {
                "plain": "e0428e55",
                "symbol": "c5309cfe"
            }
        }
    },
    "line.electrics.electric-blanket": {
        "default": {
            "default": {
                "plain": "71a1a4a8",
                "symbol": "0a1934b6"
            }
        },
        "v3": {
            "default": {
                "plain": "f619befe",
                "symbol": "0b8e8def"
            }
        }
    },
    "line.electrics.fan": {
        "default": {
            "default": {
                "plain": "eaf8559b",
                "symbol": "b7fcb5e5"
            }
        },
        "v3": {
            "default": {
                "plain": "2b210594",
                "symbol": "e4615c67"
            }
        }
    },
    "line.electrics.fax": {
        "default": {
            "default": {
                "plain": "607f0087",
                "symbol": "b3492b21"
            }
        },
        "v3": {
            "default": {
                "plain": "f7bcf65d",
                "symbol": "10da3eb2"
            }
        }
    },
    "line.electrics.gauge": {
        "default": {
            "default": {
                "plain": "baa4f42b",
                "symbol": "e6ebc062"
            }
        },
        "v3": {
            "default": {
                "plain": "1ffa4705",
                "symbol": "c90c7bfc"
            }
        }
    },
    "line.electrics.heater": {
        "default": {
            "default": {
                "plain": "510775c9",
                "symbol": "aeae386f"
            }
        },
        "v3": {
            "default": {
                "plain": "1d00d249",
                "symbol": "45ef7320"
            }
        }
    },
    "line.electrics.humidifier": {
        "default": {
            "default": {
                "plain": "8f5e5d67",
                "symbol": "ff5e5c0a"
            }
        },
        "v3": {
            "default": {
                "plain": "90b6b8d2",
                "symbol": "c323e775"
            }
        }
    },
    "line.electrics.intercome": {
        "default": {
            "default": {
                "plain": "fa24d3ff",
                "symbol": "6850f12d"
            }
        },
        "v3": {
            "default": {
                "plain": "8acc515e",
                "symbol": "9bad475b"
            }
        }
    },
    "line.electrics.internet": {
        "default": {
            "default": {
                "plain": "609b9b21",
                "symbol": "1108db4b"
            }
        },
        "v3": {
            "default": {
                "plain": "b5bf1edb",
                "symbol": "773ca8aa"
            }
        }
    },
    "line.electrics.internet-wire": {
        "default": {
            "default": {
                "plain": "8989b655",
                "symbol": "9ab646f4"
            }
        },
        "v3": {
            "default": {
                "plain": "3c5ec006",
                "symbol": "02b7a415"
            }
        }
    },
    "line.electrics.internet-wire-pay": {
        "default": {
            "default": {
                "plain": "3fde67eb",
                "symbol": "0abe88a1"
            }
        },
        "v3": {
            "default": {
                "plain": "3c5ec006",
                "symbol": "02b7a415"
            }
        }
    },
    "line.electrics.iron": {
        "default": {
            "default": {
                "plain": "d16a5df6",
                "symbol": "48e83418"
            }
        },
        "v3": {
            "default": {
                "plain": "5b65ef7e",
                "symbol": "ec4305a7"
            }
        }
    },
    "line.electrics.kotatsu": {
        "default": {
            "default": {
                "plain": "1e41c45e",
                "symbol": "fda46546"
            }
        },
        "v3": {
            "default": {
                "plain": "cdb5c6aa",
                "symbol": "2f7acf7a"
            }
        }
    },
    "line.electrics.laptop": {
        "default": {
            "default": {
                "plain": "8be5c2d5",
                "symbol": "9bfd2331"
            }
        },
        "v3": {
            "default": {
                "plain": "d57f9c56",
                "symbol": "5a6c3753"
            }
        }
    },
    "line.electrics.laundry-dry": {
        "default": {
            "default": {
                "plain": "db200c0e",
                "symbol": "03328810"
            }
        },
        "v3": {
            "default": {
                "plain": "d92dd359",
                "symbol": "080e2260"
            }
        }
    },
    "line.electrics.laundry-wash": {
        "default": {
            "default": {
                "plain": "7b1456cd",
                "symbol": "42bb3e73"
            }
        },
        "v3": {
            "default": {
                "plain": "d92dd359",
                "symbol": "080e2260"
            }
        }
    },
    "line.electrics.microwave": {
        "default": {
            "default": {
                "plain": "03b6eb7a",
                "symbol": "ed0e11c4"
            }
        },
        "v3": {
            "default": {
                "plain": "0f2e1043",
                "symbol": "5acbcca4"
            }
        }
    },
    "line.electrics.phone-rotate": {
        "default": {
            "default": {
                "plain": "66fc81dd",
                "symbol": "e1462b16"
            }
        },
        "v3": {
            "default": {
                "plain": "1f74c8b7",
                "symbol": "c40b76df"
            }
        }
    },
    "line.electrics.plug": {
        "default": {
            "default": {
                "plain": "50a39e59",
                "symbol": "5e65708f"
            }
        },
        "v3": {
            "default": {
                "plain": "98a876ca",
                "symbol": "bcd9f88a"
            }
        }
    },
    "line.electrics.plug-no": {
        "default": {
            "default": {
                "plain": "25158a5c",
                "symbol": "24899637"
            }
        },
        "v3": {
            "default": {
                "plain": "64064c20",
                "symbol": "56ff9e14"
            }
        }
    },
    "line.electrics.printer": {
        "default": {
            "default": {
                "plain": "231a32cf",
                "symbol": "002a370b"
            }
        },
        "v3": {
            "default": {
                "plain": "850fbb27",
                "symbol": "eb807758"
            }
        }
    },
    "line.electrics.radio": {
        "default": {
            "default": {
                "plain": "0a82630d",
                "symbol": "ce8219b7"
            }
        },
        "v3": {
            "default": {
                "plain": "1e2a0ad2",
                "symbol": "54985fad"
            }
        }
    },
    "line.electrics.refrigerator": {
        "default": {
            "default": {
                "plain": "d07c0787",
                "symbol": "af65b0c2"
            }
        },
        "v3": {
            "default": {
                "plain": "57e69acf",
                "symbol": "1a14ecbc"
            }
        }
    },
    "line.electrics.safety-box": {
        "default": {
            "default": {
                "plain": "3ad0b0c4",
                "symbol": "3e3a4069"
            }
        },
        "v3": {
            "default": {
                "plain": "896e6c07",
                "symbol": "b70c141a"
            }
        }
    },
    "line.electrics.scale": {
        "default": {
            "default": {
                "plain": "143e6e7a",
                "symbol": "e38add80"
            }
        },
        "v3": {
            "default": {
                "plain": "8fed3d04",
                "symbol": "f9a03da4"
            }
        }
    },
    "line.electrics.signal-full": {
        "default": {
            "default": {
                "plain": "8db6aed0",
                "symbol": "ce2348ba"
            }
        },
        "v3": {
            "default": {
                "plain": "aedb3862",
                "symbol": "6d2e7aca"
            }
        }
    },
    "line.electrics.signal-high": {
        "default": {
            "default": {
                "plain": "aaca853c",
                "symbol": "9b0465d6"
            }
        },
        "v3": {
            "default": {
                "plain": "7ecd9416",
                "symbol": "a1b16adb"
            }
        }
    },
    "line.electrics.signal-low": {
        "default": {
            "default": {
                "plain": "7c2240d4",
                "symbol": "ca2ff363"
            }
        },
        "v3": {
            "default": {
                "plain": "55cc531d",
                "symbol": "5a81a152"
            }
        }
    },
    "line.electrics.signal-medium": {
        "default": {
            "default": {
                "plain": "cd1d7a7a",
                "symbol": "1d6f1b95"
            }
        },
        "v3": {
            "default": {
                "plain": "f41735ed",
                "symbol": "92ad43aa"
            }
        }
    },
    "line.electrics.signal-none": {
        "default": {
            "default": {
                "plain": "d513a209",
                "symbol": "9b7bbb86"
            }
        },
        "v3": {
            "default": {
                "plain": "d120e1d5",
                "symbol": "451532b7"
            }
        }
    },
    "line.electrics.signal-very-low": {
        "default": {
            "default": {
                "plain": "fc6ef0af",
                "symbol": "142e70b2"
            }
        },
        "v3": {
            "default": {
                "plain": "8df81507",
                "symbol": "008f036a"
            }
        }
    },
    "line.electrics.smoke-detector": {
        "default": {
            "default": {
                "plain": "8d698edf",
                "symbol": "8efae300"
            }
        },
        "v3": {
            "default": {
                "plain": "252f5280",
                "symbol": "68095be2"
            }
        }
    },
    "line.electrics.table-dock": {
        "default": {
            "default": {
                "plain": "194a664f",
                "symbol": "c6b3e5e2"
            }
        }
    },
    "line.electrics.tablet": {
        "default": {
            "default": {
                "plain": "d49acf07",
                "symbol": "5820c74c"
            }
        },
        "v3": {
            "default": {
                "plain": "26c5227d",
                "symbol": "740c7a05"
            }
        }
    },
    "line.electrics.tablet-dock": {
        "default": {
            "default": {
                "plain": "0da8e568",
                "symbol": "c0c57dd8"
            }
        }
    },
    "line.electrics.tv": {
        "default": {
            "default": {
                "plain": "55c3cdf0",
                "symbol": "3b352613"
            }
        },
        "v3": {
            "default": {
                "plain": "e21560d6",
                "symbol": "68d607d9"
            }
        }
    },
    "line.electrics.tv-cable": {
        "default": {
            "default": {
                "plain": "ce5ccac0",
                "symbol": "82c43c02"
            }
        },
        "v3": {
            "default": {
                "plain": "e21560d6",
                "symbol": "68d607d9"
            }
        }
    },
    "line.electrics.tv-hd": {
        "default": {
            "default": {
                "plain": "e94d2ffa",
                "symbol": "72f08aca"
            }
        },
        "v3": {
            "default": {
                "plain": "e21560d6",
                "symbol": "68d607d9"
            }
        }
    },
    "line.electrics.vendingmachine": {
        "default": {
            "default": {
                "plain": "1031b7c1",
                "symbol": "ce165470"
            }
        },
        "v3": {
            "default": {
                "plain": "a06257b7",
                "symbol": "7281afc8"
            }
        }
    },
    "line.electrics.video-vod": {
        "default": {
            "default": {
                "plain": "5767f313",
                "symbol": "3ffd5f34"
            }
        },
        "v3": {
            "default": {
                "plain": "5a133480",
                "symbol": "78452829"
            }
        }
    },
    "line.electrics.video-vod-no": {
        "default": {
            "default": {
                "plain": "c9a27868",
                "symbol": "a5c8d429"
            }
        },
        "v3": {
            "default": {
                "plain": "8f127377",
                "symbol": "14b723aa"
            }
        }
    },
    "line.electrics.water-pot": {
        "default": {
            "default": {
                "plain": "c64aab83",
                "symbol": "066bd2af"
            }
        },
        "v3": {
            "default": {
                "plain": "acb99520",
                "symbol": "8bbd890e"
            }
        }
    },
    "line.electrics.wifi": {
        "default": {
            "default": {
                "plain": "b977b200",
                "symbol": "c5c5e0d9"
            }
        },
        "v3": {
            "default": {
                "plain": "3c5ec006",
                "symbol": "02b7a415"
            }
        }
    },
    "line.electrics.wifi-no": {
        "default": {
            "default": {
                "plain": "cbc7b7d3",
                "symbol": "fc90b66e"
            }
        },
        "v3": {
            "default": {
                "plain": "eb58c7cc",
                "symbol": "60b7375c"
            }
        }
    },
    "line.electrics.wifi-pay": {
        "default": {
            "default": {
                "plain": "c6249710",
                "symbol": "208f6a88"
            }
        },
        "v3": {
            "default": {
                "plain": "3c5ec006",
                "symbol": "02b7a415"
            }
        }
    },
    "line.facility.air-conditioner": {
        "default": {
            "default": {
                "plain": "e8960ccb",
                "symbol": "ab2d43e2"
            }
        },
        "v3": {
            "default": {
                "plain": "5a284c2e",
                "symbol": "16de0d78"
            }
        }
    },
    "line.facility.atm": {
        "default": {
            "default": {
                "plain": "6c8f537a",
                "symbol": "d3035e38"
            }
        },
        "v3": {
            "default": {
                "plain": "42ac0474",
                "symbol": "ba66e2ad"
            }
        }
    },
    "line.facility.baby-cot": {
        "default": {
            "default": {
                "plain": "b55281f1",
                "symbol": "ab6bd3c2"
            }
        },
        "v3": {
            "default": {
                "plain": "fda3dc5a",
                "symbol": "e8f15c89"
            }
        }
    },
    "line.facility.balcony": {
        "default": {
            "default": {
                "plain": "937b7a8d",
                "symbol": "31b7fa47"
            }
        },
        "v3": {
            "default": {
                "plain": "a65c39c4",
                "symbol": "c91ee0e4"
            }
        }
    },
    "line.facility.bath-family": {
        "default": {
            "default": {
                "plain": "2c53b6b8",
                "symbol": "cbe61e02"
            }
        },
        "v3": {
            "default": {
                "plain": "8724dea6",
                "symbol": "1dc3e772"
            }
        }
    },
    "line.facility.bath-open": {
        "default": {
            "default": {
                "plain": "48eef1e2",
                "symbol": "8b12a35b"
            }
        },
        "v3": {
            "default": {
                "plain": "8724dea6",
                "symbol": "1dc3e772"
            }
        }
    },
    "line.facility.bath-separate": {
        "default": {
            "default": {
                "plain": "9ad66f66",
                "symbol": "94c59904"
            }
        },
        "v3": {
            "default": {
                "plain": "8724dea6",
                "symbol": "1dc3e772"
            }
        }
    },
    "line.facility.bathtub": {
        "default": {
            "default": {
                "plain": "f9b73d74",
                "symbol": "77ad2900"
            }
        },
        "v3": {
            "default": {
                "plain": "bc520325",
                "symbol": "0ec16c17"
            }
        }
    },
    "line.facility.bathtub-air": {
        "default": {
            "default": {
                "plain": "59e852b9",
                "symbol": "00b0b497"
            }
        },
        "v3": {
            "default": {
                "plain": "bc520325",
                "symbol": "0ec16c17"
            }
        }
    },
    "line.facility.bathtub-shower": {
        "default": {
            "default": {
                "plain": "8d44eb92",
                "symbol": "8740b69d"
            }
        },
        "v3": {
            "default": {
                "plain": "bc520325",
                "symbol": "0ec16c17"
            }
        }
    },
    "line.facility.bed": {
        "default": {
            "default": {
                "plain": "ea34b787",
                "symbol": "70ca8489"
            }
        },
        "v3": {
            "default": {
                "plain": "a114002e",
                "symbol": "ad6eebd1"
            }
        }
    },
    "line.facility.bed-add": {
        "default": {
            "default": {
                "plain": "dae877b0",
                "symbol": "db65ef3e"
            }
        },
        "v3": {
            "default": {
                "plain": "9af3e1b8",
                "symbol": "de9f4cdc"
            }
        }
    },
    "line.facility.bed-change": {
        "default": {
            "default": {
                "plain": "19abd6a8",
                "symbol": "ece1639a"
            }
        },
        "v3": {
            "default": {
                "plain": "67a87b3a",
                "symbol": "2adecb6d"
            }
        }
    },
    "line.facility.bed-door": {
        "default": {
            "default": {
                "plain": "86d3b8d7",
                "symbol": "5db39c54"
            }
        },
        "v3": {
            "default": {
                "plain": "0c2ece55",
                "symbol": "a5106b2d"
            }
        }
    },
    "line.facility.bed-double": {
        "default": {
            "default": {
                "plain": "d2f7231a",
                "symbol": "fb15d5ec"
            }
        },
        "v3": {
            "default": {
                "plain": "02b35e99",
                "symbol": "421ec643"
            }
        }
    },
    "line.facility.bed-king": {
        "default": {
            "default": {
                "plain": "89e616dd",
                "symbol": "fbbc74d6"
            }
        },
        "v3": {
            "default": {
                "plain": "79d59c86",
                "symbol": "4a6fdd39"
            }
        }
    },
    "line.facility.bed-queen": {
        "default": {
            "default": {
                "plain": "98c2eeb9",
                "symbol": "cdfabb64"
            }
        },
        "v3": {
            "default": {
                "plain": "02b35e99",
                "symbol": "421ec643"
            }
        }
    },
    "line.facility.bed-single": {
        "default": {
            "default": {
                "plain": "b144ba93",
                "symbol": "9f1f6461"
            }
        },
        "v3": {
            "default": {
                "plain": "42666825",
                "symbol": "98858a89"
            }
        }
    },
    "line.facility.bed-twin": {
        "default": {
            "default": {
                "plain": "5b7b6561",
                "symbol": "e0ab02d3"
            }
        },
        "v3": {
            "default": {
                "plain": "b6a9eff2",
                "symbol": "1800624a"
            }
        }
    },
    "line.facility.bunkbed": {
        "default": {
            "default": {
                "plain": "2d281b27",
                "symbol": "9d48800e"
            }
        },
        "v3": {
            "default": {
                "plain": "cc9f7005",
                "symbol": "f4dae0a2"
            }
        }
    },
    "line.facility.cabinet": {
        "default": {
            "default": {
                "plain": "7a2b64c2",
                "symbol": "3e09c062"
            }
        },
        "v3": {
            "default": {
                "plain": "b55069da",
                "symbol": "0590eba9"
            }
        }
    },
    "line.facility.carpet": {
        "default": {
            "default": {
                "plain": "87ece39f",
                "symbol": "246a32f1"
            }
        },
        "v3": {
            "default": {
                "plain": "b781dd76",
                "symbol": "35a1452f"
            }
        }
    },
    "line.facility.cctv": {
        "default": {
            "default": {
                "plain": "9428df70",
                "symbol": "8e509d53"
            }
        },
        "v3": {
            "default": {
                "plain": "592a77a8",
                "symbol": "294c7791"
            }
        }
    },
    "line.facility.chair-kid": {
        "default": {
            "default": {
                "plain": "5cd19fdf",
                "symbol": "f682dffa"
            }
        },
        "v3": {
            "default": {
                "plain": "96d571f5",
                "symbol": "362fc308"
            }
        }
    },
    "line.facility.desk": {
        "default": {
            "default": {
                "plain": "7e5eeeff",
                "symbol": "9371e593"
            }
        },
        "v3": {
            "default": {
                "plain": "d75ea834",
                "symbol": "7117dd9e"
            }
        }
    },
    "line.facility.drawer": {
        "default": {
            "default": {
                "plain": "35620b4a",
                "symbol": "01716126"
            }
        },
        "v3": {
            "default": {
                "plain": "c150b8ab",
                "symbol": "7ae9bbb7"
            }
        }
    },
    "line.facility.drugstore": {
        "default": {
            "default": {
                "plain": "77f833cb",
                "symbol": "9ed7cdf0"
            }
        },
        "v3": {
            "default": {
                "plain": "a27eb381",
                "symbol": "36461daa"
            }
        }
    },
    "line.facility.elevator": {
        "default": {
            "default": {
                "plain": "4b7554a2",
                "symbol": "554da22a"
            }
        },
        "v3": {
            "default": {
                "plain": "9d490bd7",
                "symbol": "7cff284a"
            }
        }
    },
    "line.facility.fire-extinguisher": {
        "default": {
            "default": {
                "plain": "6282ba69",
                "symbol": "09a312f2"
            }
        },
        "v3": {
            "default": {
                "plain": "70f0cca3",
                "symbol": "e447bc54"
            }
        }
    },
    "line.facility.fireplace": {
        "default": {
            "default": {
                "plain": "649b47a1",
                "symbol": "d7212840"
            }
        },
        "v3": {
            "default": {
                "plain": "4bbda3cd",
                "symbol": "7d68ca80"
            }
        }
    },
    "line.facility.firstaid": {
        "default": {
            "default": {
                "plain": "549e743e",
                "symbol": "e81de859"
            }
        },
        "v3": {
            "default": {
                "plain": "3433fb82",
                "symbol": "b39b13eb"
            }
        }
    },
    "line.facility.grill": {
        "default": {
            "default": {
                "plain": "b093802a",
                "symbol": "fa0a1d38"
            }
        },
        "v3": {
            "default": {
                "plain": "7e7662f1",
                "symbol": "26acbfe2"
            }
        }
    },
    "line.facility.hospital": {
        "default": {
            "default": {
                "plain": "9f4cd661",
                "symbol": "798c3ad2"
            }
        },
        "v3": {
            "default": {
                "plain": "cb76b88c",
                "symbol": "26375224"
            }
        }
    },
    "line.facility.hot-spring": {
        "default": {
            "default": {
                "plain": "7af60290",
                "symbol": "f56adbf5"
            }
        },
        "v3": {
            "default": {
                "plain": "89e45767",
                "symbol": "92876e3f"
            }
        }
    },
    "line.facility.lounge": {
        "default": {
            "default": {
                "plain": "61949c52",
                "symbol": "82fd4652"
            }
        },
        "v3": {
            "default": {
                "plain": "f10a4849",
                "symbol": "a948b32e"
            }
        }
    },
    "line.facility.mosquitonet": {
        "default": {
            "default": {
                "plain": "76b2ddba",
                "symbol": "d9386df1"
            }
        }
    },
    "line.facility.motel": {
        "default": {
            "default": {
                "plain": "a666aa98",
                "symbol": "415e90e1"
            }
        },
        "v3": {
            "default": {
                "plain": "638acb3a",
                "symbol": "08a8979d"
            }
        }
    },
    "line.facility.pet": {
        "default": {
            "default": {
                "plain": "6ebf3c1d",
                "symbol": "6b35ce29"
            }
        },
        "v3": {
            "default": {
                "plain": "1cc10036",
                "symbol": "4624aaa8"
            }
        }
    },
    "line.facility.pet-bath": {
        "default": {
            "default": {
                "plain": "f273b3b9",
                "symbol": "0817b202"
            }
        },
        "v3": {
            "default": {
                "plain": "1cc10036",
                "symbol": "4624aaa8"
            }
        }
    },
    "line.facility.pet-no": {
        "default": {
            "default": {
                "plain": "13fdaf65",
                "symbol": "eb875bdf"
            }
        },
        "v3": {
            "default": {
                "plain": "068d6e39",
                "symbol": "e496c20b"
            }
        }
    },
    "line.facility.pet-pay": {
        "default": {
            "default": {
                "plain": "f094a1bb",
                "symbol": "c4d8c76e"
            }
        },
        "v3": {
            "default": {
                "plain": "1cc10036",
                "symbol": "4624aaa8"
            }
        }
    },
    "line.facility.pool-indoor": {
        "default": {
            "default": {
                "plain": "e4e3905f",
                "symbol": "7b019bac"
            }
        },
        "v3": {
            "default": {
                "plain": "c3c0f21e",
                "symbol": "1ceef29b"
            }
        }
    },
    "line.facility.pool-kid": {
        "default": {
            "default": {
                "plain": "be9f7b70",
                "symbol": "e5a3b217"
            }
        },
        "v3": {
            "default": {
                "plain": "9ed578b2",
                "symbol": "1665de91"
            }
        }
    },
    "line.facility.pool-outdoor": {
        "default": {
            "default": {
                "plain": "88ce155c",
                "symbol": "f3ca1956"
            }
        },
        "v3": {
            "default": {
                "plain": "c3c0f21e",
                "symbol": "1ceef29b"
            }
        }
    },
    "line.facility.pray": {
        "default": {
            "default": {
                "plain": "73a2504d",
                "symbol": "7b592a43"
            }
        },
        "v3": {
            "default": {
                "plain": "9867e056",
                "symbol": "aaecde65"
            }
        }
    },
    "line.facility.pray-separate": {
        "default": {
            "default": {
                "plain": "ab3dd173",
                "symbol": "3e013546"
            }
        },
        "v3": {
            "default": {
                "plain": "9867e056",
                "symbol": "aaecde65"
            }
        }
    },
    "line.facility.projector": {
        "default": {
            "default": {
                "plain": "28e3b2de",
                "symbol": "766ba162"
            }
        },
        "v3": {
            "default": {
                "plain": "02ae3cc4",
                "symbol": "7b168450"
            }
        }
    },
    "line.facility.room-size": {
        "default": {
            "default": {
                "plain": "272a1723",
                "symbol": "6c637aa1"
            }
        },
        "v3": {
            "default": {
                "plain": "c4d5c72e",
                "symbol": "0249be8e"
            }
        }
    },
    "line.facility.roomplan": {
        "default": {
            "default": {
                "plain": "c0e2393d",
                "symbol": "2ac0cb86"
            }
        },
        "v3": {
            "default": {
                "plain": "ab3e086a",
                "symbol": "7d94ed3b"
            }
        }
    },
    "line.facility.sauna": {
        "default": {
            "default": {
                "plain": "1eeaae8a",
                "symbol": "d12b6606"
            }
        },
        "v3": {
            "default": {
                "plain": "1270584f",
                "symbol": "45524a1b"
            }
        }
    },
    "line.facility.shop": {
        "default": {
            "default": {
                "plain": "ebc32f2d",
                "symbol": "adf9f764"
            }
        },
        "v3": {
            "default": {
                "plain": "070b8d6f",
                "symbol": "705cf501"
            }
        }
    },
    "line.facility.shower": {
        "default": {
            "default": {
                "plain": "79bc204e",
                "symbol": "48f7b03d"
            }
        },
        "v3": {
            "default": {
                "plain": "8724dea6",
                "symbol": "1dc3e772"
            }
        }
    },
    "line.facility.shower-share": {
        "default": {
            "default": {
                "plain": "fe9b4bd9",
                "symbol": "edc98b68"
            }
        },
        "v3": {
            "default": {
                "plain": "8724dea6",
                "symbol": "1dc3e772"
            }
        }
    },
    "line.facility.slope": {
        "default": {
            "default": {
                "plain": "0fb0bdca",
                "symbol": "eb90a690"
            }
        },
        "v3": {
            "default": {
                "plain": "81a4fd78",
                "symbol": "9c03ebf3"
            }
        }
    },
    "line.facility.smoke": {
        "default": {
            "default": {
                "plain": "9f54f856",
                "symbol": "c8a99f02"
            }
        },
        "v3": {
            "default": {
                "plain": "78c9f241",
                "symbol": "fab8fdae"
            }
        }
    },
    "line.facility.smoke-no": {
        "default": {
            "default": {
                "plain": "06c8ab50",
                "symbol": "81b01be7"
            }
        },
        "v3": {
            "default": {
                "plain": "04ad19e9",
                "symbol": "0f0ddd84"
            }
        }
    },
    "line.facility.sofa": {
        "default": {
            "default": {
                "plain": "68a9754e",
                "symbol": "750c5f82"
            }
        },
        "v3": {
            "default": {
                "plain": "aea3ef0b",
                "symbol": "ff3c669c"
            }
        }
    },
    "line.facility.sofa-stool": {
        "default": {
            "default": {
                "plain": "c3739453",
                "symbol": "e0c5fe9b"
            }
        },
        "v3": {
            "default": {
                "plain": "f10a4849",
                "symbol": "a948b32e"
            }
        }
    },
    "line.facility.sofa2": {
        "default": {
            "default": {
                "plain": "ab902525",
                "symbol": "4df9bc3f"
            }
        },
        "v3": {
            "default": {
                "plain": "f10a4849",
                "symbol": "a948b32e"
            }
        }
    },
    "line.facility.soundproof": {
        "default": {
            "default": {
                "plain": "fb0cf983",
                "symbol": "8721c3b9"
            }
        },
        "v3": {
            "default": {
                "plain": "f488f8df",
                "symbol": "fbf442ea"
            }
        }
    },
    "line.facility.spa": {
        "default": {
            "default": {
                "plain": "54b31f2c",
                "symbol": "2d963bbd"
            }
        },
        "v3": {
            "default": {
                "plain": "f475b082",
                "symbol": "e19282d1"
            }
        }
    },
    "line.facility.stair-ground": {
        "default": {
            "default": {
                "plain": "35f93e5d",
                "symbol": "51ddbd47"
            }
        },
        "v3": {
            "default": {
                "plain": "311dd0c3",
                "symbol": "7d957388"
            }
        }
    },
    "line.facility.stair-handrail": {
        "default": {
            "default": {
                "plain": "5e1f0cf2",
                "symbol": "2b652aa5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "311dd0c3",
                "symbol": "7d957388"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.stair-high": {
        "default": {
            "default": {
                "plain": "267a378f",
                "symbol": "5f7965bd"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "311dd0c3",
                "symbol": "7d957388"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.stair-lock": {
        "default": {
            "default": {
                "plain": "b6e06d40",
                "symbol": "506332e7"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "311dd0c3",
                "symbol": "7d957388"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.stair-low": {
        "default": {
            "default": {
                "plain": "799b8360",
                "symbol": "5623b3a4"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "311dd0c3",
                "symbol": "7d957388"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.stair-no": {
        "default": {
            "default": {
                "plain": "2ce089d7",
                "symbol": "8fdefd6d"
            }
        },
        "v3": {
            "default": {
                "plain": "56b4fb75",
                "symbol": "79001f45"
            }
        }
    },
    "line.facility.stair-number": {
        "default": {
            "default": {
                "plain": "bf6f6c58",
                "symbol": "abdad7b6"
            }
        },
        "v3": {
            "default": {
                "plain": "311dd0c3",
                "symbol": "7d957388"
            }
        }
    },
    "line.facility.stove": {
        "default": {
            "default": {
                "plain": "c10c9946",
                "symbol": "5a3613df"
            }
        },
        "v3": {
            "default": {
                "plain": "ac7858a8",
                "symbol": "2b7aff83"
            }
        }
    },
    "line.facility.stove-share": {
        "default": {
            "default": {
                "plain": "d8c442cc",
                "symbol": "4febacba"
            }
        },
        "v3": {
            "default": {
                "plain": "ac7858a8",
                "symbol": "2b7aff83"
            }
        }
    },
    "line.facility.table": {
        "default": {
            "default": {
                "plain": "55c28f9d",
                "symbol": "93754541"
            }
        },
        "v3": {
            "default": {
                "plain": "91b8555b",
                "symbol": "7ed77a66"
            }
        }
    },
    "line.facility.tatami": {
        "default": {
            "default": {
                "plain": "4903d8df",
                "symbol": "5408d082"
            }
        },
        "v3": {
            "default": {
                "plain": "bf58ff50",
                "symbol": "597dd10e"
            }
        }
    },
    "line.facility.tatami-mix": {
        "default": {
            "default": {
                "plain": "b310e1a8",
                "symbol": "ab403dfb"
            }
        },
        "v3": {
            "default": {
                "plain": "2b296fa0",
                "symbol": "e097e731"
            }
        }
    },
    "line.facility.temperature": {
        "default": {
            "default": {
                "plain": "d3ef6c19",
                "symbol": "f70c1098"
            }
        },
        "v3": {
            "default": {
                "plain": "3ccf5649",
                "symbol": "cb74be4d"
            }
        }
    },
    "line.facility.toilet": {
        "default": {
            "default": {
                "plain": "42f92133",
                "symbol": "7368cc3c"
            }
        },
        "v3": {
            "default": {
                "plain": "5bec2c19",
                "symbol": "4ab4e4b3"
            }
        }
    },
    "line.facility.toilet-add": {
        "default": {
            "default": {
                "plain": "6e641065",
                "symbol": "daa07bb1"
            }
        },
        "v3": {
            "default": {
                "plain": "0d0e8c63",
                "symbol": "8de79e20"
            }
        }
    },
    "line.facility.toilet-bidet": {
        "default": {
            "default": {
                "plain": "a5571eb7",
                "symbol": "1ac4b0b0"
            }
        },
        "v3": {
            "default": {
                "plain": "ccaab3ac",
                "symbol": "22fc24eb"
            }
        }
    },
    "line.facility.toilet-handrail": {
        "default": {
            "default": {
                "plain": "0413bce7",
                "symbol": "c4ef20fe"
            }
        },
        "v3": {
            "default": {
                "plain": "daec177b",
                "symbol": "f3cb3f37"
            }
        }
    },
    "line.facility.toilet-phone": {
        "default": {
            "default": {
                "plain": "290bbbd2",
                "symbol": "b078d1cb"
            }
        },
        "v3": {
            "default": {
                "plain": "7173730d",
                "symbol": "b5ff9dc7"
            }
        }
    },
    "line.facility.toilet-share": {
        "default": {
            "default": {
                "plain": "121894e8",
                "symbol": "9b08a441"
            }
        },
        "v3": {
            "default": {
                "plain": "5bec2c19",
                "symbol": "4ab4e4b3"
            }
        }
    },
    "line.facility.toilet-squat": {
        "default": {
            "default": {
                "plain": "607e352c",
                "symbol": "df257d44"
            }
        },
        "v3": {
            "default": {
                "plain": "d345c253",
                "symbol": "442304f2"
            }
        }
    },
    "line.facility.tv-area": {
        "default": {
            "default": {
                "plain": "0922e9dd",
                "symbol": "b50145bd"
            }
        },
        "v3": {
            "default": {
                "plain": "0686eefc",
                "symbol": "c0a0dd59"
            }
        }
    },
    "line.facility.tv-area-share": {
        "default": {
            "default": {
                "plain": "1583fae1",
                "symbol": "eef80df5"
            }
        },
        "v3": {
            "default": {
                "plain": "0686eefc",
                "symbol": "c0a0dd59"
            }
        }
    },
    "line.facility.wheelchair": {
        "default": {
            "default": {
                "plain": "4c4969b0",
                "symbol": "c6c9ec20"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "eb59ae50",
                "symbol": "b075c524"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.wheelchair-arrow": {
        "default": {
            "default": {
                "plain": "7c8d0564",
                "symbol": "44b02d1f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "eb59ae50",
                "symbol": "b075c524"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.wheelchair-bath": {
        "default": {
            "default": {
                "plain": "b185f4ab",
                "symbol": "c512ece3"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "eb59ae50",
                "symbol": "b075c524"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.wheelchair-elevator": {
        "default": {
            "default": {
                "plain": "1a89077a",
                "symbol": "abdbc301"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "839352f3",
                "symbol": "1e24e74d"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.wheelchair-park": {
        "default": {
            "default": {
                "plain": "c3159b19",
                "symbol": "8f786099"
            }
        },
        "v3": {
            "default": {
                "plain": "8689a5f0",
                "symbol": "588dbda8"
            }
        }
    },
    "line.facility.wheelchair-stair": {
        "default": {
            "default": {
                "plain": "f2f40582",
                "symbol": "191cdbb3"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "eb59ae50",
                "symbol": "b075c524"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.facility.window": {
        "default": {
            "default": {
                "plain": "65c8f8e1",
                "symbol": "36ad2362"
            }
        },
        "v3": {
            "default": {
                "plain": "aee89362",
                "symbol": "64d39c4e"
            }
        }
    },
    "line.facility.wood": {
        "default": {
            "default": {
                "plain": "f14a0ae8",
                "symbol": "2a53309c"
            }
        },
        "v3": {
            "default": {
                "plain": "2b002759",
                "symbol": "bbab1b31"
            }
        }
    },
    "line.food.babybottle": {
        "default": {
            "default": {
                "plain": "a6118375",
                "symbol": "07297baa"
            }
        },
        "v3": {
            "default": {
                "plain": "e48e819a",
                "symbol": "140a03b2"
            }
        }
    },
    "line.food.buffet": {
        "default": {
            "default": {
                "plain": "372648c2",
                "symbol": "8bea5319"
            }
        },
        "v3": {
            "default": {
                "plain": "15710017",
                "symbol": "b7bd8b0a"
            }
        }
    },
    "line.food.circle-fork-knife": {
        "default": {
            "default": {
                "plain": "058ba6fd",
                "symbol": "69e5e447"
            }
        },
        "v3": {
            "default": {
                "plain": "31baa4e6",
                "symbol": "4714c6b8"
            }
        }
    },
    "line.food.cocktail": {
        "default": {
            "default": {
                "plain": "e83b025c",
                "symbol": "69c244f1"
            }
        },
        "v3": {
            "default": {
                "plain": "e836799c",
                "symbol": "f9d3b511"
            }
        }
    },
    "line.food.cocktail-pool": {
        "default": {
            "default": {
                "plain": "886bdec9",
                "symbol": "f40ca89d"
            }
        },
        "v3": {
            "default": {
                "plain": "e836799c",
                "symbol": "f9d3b511"
            }
        }
    },
    "line.food.coffee": {
        "default": {
            "default": {
                "plain": "a14eae7e",
                "symbol": "f07ac35f"
            }
        },
        "v3": {
            "default": {
                "plain": "07d97911",
                "symbol": "b8b00de3"
            }
        }
    },
    "line.food.cookie": {
        "default": {
            "default": {
                "plain": "fe9c9a4b",
                "symbol": "d6a9a936"
            }
        },
        "v3": {
            "default": {
                "plain": "462f2adf",
                "symbol": "1d98d474"
            }
        }
    },
    "line.food.croissant": {
        "default": {
            "default": {
                "plain": "45576068",
                "symbol": "d17e7dfa"
            }
        },
        "v3": {
            "default": {
                "plain": "c04be0ce",
                "symbol": "bba6a4a8"
            }
        }
    },
    "line.food.fork-knife": {
        "default": {
            "default": {
                "plain": "89aea1e7",
                "symbol": "8f7775eb"
            }
        },
        "v3": {
            "default": {
                "plain": "31baa4e6",
                "symbol": "4714c6b8"
            }
        }
    },
    "line.food.fork-knife-no": {
        "default": {
            "default": {
                "plain": "b7cd4d44",
                "symbol": "ce4bc92d"
            }
        },
        "v3": {
            "default": {
                "plain": "14d2acc6",
                "symbol": "a5094bb9"
            }
        }
    },
    "line.food.fork-knife-pay": {
        "default": {
            "default": {
                "plain": "014b71de",
                "symbol": "5b96d84a"
            }
        },
        "v3": {
            "default": {
                "plain": "31baa4e6",
                "symbol": "4714c6b8"
            }
        }
    },
    "line.food.fork-spoon": {
        "default": {
            "default": {
                "plain": "f3cb169f",
                "symbol": "76ba4267"
            }
        },
        "v3": {
            "default": {
                "plain": "ffd75d84",
                "symbol": "c238d6b8"
            }
        }
    },
    "line.food.juice": {
        "default": {
            "default": {
                "plain": "8f871e3b",
                "symbol": "56c925bf"
            }
        },
        "v3": {
            "default": {
                "plain": "be2d0def",
                "symbol": "47de229b"
            }
        }
    },
    "line.food.noodle": {
        "default": {
            "default": {
                "plain": "eb7e1cd5",
                "symbol": "6c1fe09d"
            }
        },
        "v3": {
            "default": {
                "plain": "ae805fe6",
                "symbol": "29902d41"
            }
        }
    },
    "line.food.salt": {
        "default": {
            "default": {
                "plain": "74ca2c07",
                "symbol": "97e4ded6"
            }
        },
        "v3": {
            "default": {
                "plain": "7d39556b",
                "symbol": "e412ad9d"
            }
        }
    },
    "line.food.sushi": {
        "default": {
            "default": {
                "plain": "13cba7ba",
                "symbol": "43796138"
            }
        },
        "v3": {
            "default": {
                "plain": "d5cba5ee",
                "symbol": "ea32e872"
            }
        }
    },
    "line.food.tea": {
        "default": {
            "default": {
                "plain": "86493fb1",
                "symbol": "8083b0d5"
            }
        },
        "v3": {
            "default": {
                "plain": "57273d6f",
                "symbol": "e2f63b00"
            }
        }
    },
    "line.food.tea-ceremony": {
        "default": {
            "default": {
                "plain": "fa225f43",
                "symbol": "7b14e174"
            }
        },
        "v3": {
            "default": {
                "plain": "9c4790a2",
                "symbol": "54a1c223"
            }
        }
    },
    "line.food.teapot": {
        "default": {
            "default": {
                "plain": "75ef6d0a",
                "symbol": "6a48b05d"
            }
        },
        "v3": {
            "default": {
                "plain": "9c4790a2",
                "symbol": "54a1c223"
            }
        }
    },
    "line.food.wine": {
        "default": {
            "default": {
                "plain": "0091c729",
                "symbol": "9fed5d41"
            }
        },
        "v3": {
            "default": {
                "plain": "b6fbe0bd",
                "symbol": "4c8577d6"
            }
        }
    },
    "line.food.wine-bottle": {
        "default": {
            "default": {
                "plain": "018a824c",
                "symbol": "04031476"
            }
        },
        "v3": {
            "default": {
                "plain": "2e71477d",
                "symbol": "0f8c79f3"
            }
        }
    },
    "line.people.adult2": {
        "default": {
            "default": {
                "plain": "e6eaa6b1",
                "symbol": "b73676a2"
            }
        },
        "v3": {
            "default": {
                "plain": "44b2c294",
                "symbol": "80e4f740"
            }
        }
    },
    "line.people.baby": {
        "default": {
            "default": {
                "plain": "9618b5a8",
                "symbol": "1ed70429"
            }
        },
        "v3": {
            "default": {
                "plain": "8588fa10",
                "symbol": "1022b9ea"
            }
        }
    },
    "line.people.baby-no": {
        "default": {
            "default": {
                "plain": "8ebd7890",
                "symbol": "83ed2552"
            }
        },
        "v3": {
            "default": {
                "plain": "6e083d10",
                "symbol": "62b23787"
            }
        }
    },
    "line.people.child": {
        "default": {
            "default": {
                "plain": "572e5cf4",
                "symbol": "82645aaa"
            }
        }
    },
    "line.people.circle-user": {
        "default": {
            "default": {
                "plain": "b96e62c9",
                "symbol": "90232769"
            }
        },
        "v3": {
            "default": {
                "plain": "42dc25fc",
                "symbol": "ed5a3fcf"
            }
        }
    },
    "line.people.emoji-angry": {
        "default": {
            "default": {
                "plain": "a6755562",
                "symbol": "d6566b9a"
            }
        },
        "v3": {
            "default": {
                "plain": "cc9d861b",
                "symbol": "d5f6f601"
            }
        }
    },
    "line.people.emoji-dislike": {
        "default": {
            "default": {
                "plain": "f2e36d01",
                "symbol": "1ad4f1c4"
            }
        },
        "v3": {
            "default": {
                "plain": "8107422a",
                "symbol": "8cb7fe73"
            }
        }
    },
    "line.people.emoji-heart": {
        "default": {
            "default": {
                "plain": "40d5effd",
                "symbol": "fba74baa"
            }
        },
        "v3": {
            "default": {
                "plain": "21ac73bb",
                "symbol": "ec8b1b81"
            }
        }
    },
    "line.people.emoji-like": {
        "default": {
            "default": {
                "plain": "4483449a",
                "symbol": "985b1d9a"
            }
        },
        "v3": {
            "default": {
                "plain": "36bb3b68",
                "symbol": "0307af87"
            }
        }
    },
    "line.people.emoji-meh": {
        "default": {
            "default": {
                "plain": "2753483a",
                "symbol": "44df2a50"
            }
        },
        "v3": {
            "default": {
                "plain": "f8360954",
                "symbol": "2c65b625"
            }
        }
    },
    "line.people.emoji-normal": {
        "default": {
            "default": {
                "plain": "8853222e",
                "symbol": "8fb494a6"
            }
        },
        "v3": {
            "default": {
                "plain": "72a63916",
                "symbol": "cf62c627"
            }
        }
    },
    "line.people.family": {
        "default": {
            "default": {
                "plain": "ee77df15",
                "symbol": "349cb4d8"
            }
        },
        "v3": {
            "default": {
                "plain": "f5d710d8",
                "symbol": "5fe1921f"
            }
        }
    },
    "line.people.family2": {
        "default": {
            "default": {
                "plain": "f5d710d8",
                "symbol": "5fe1921f"
            }
        }
    },
    "line.people.gender": {
        "default": {
            "default": {
                "plain": "f081ca76",
                "symbol": "3416704e"
            }
        },
        "v3": {
            "default": {
                "plain": "2e3d58d4",
                "symbol": "f86c5500"
            }
        }
    },
    "line.people.infant": {
        "default": {
            "default": {
                "plain": "6f2362f1",
                "symbol": "e91dde85"
            }
        }
    },
    "line.people.kid": {
        "default": {
            "default": {
                "plain": "5b35e5ee",
                "symbol": "37f53723"
            }
        },
        "v3": {
            "default": {
                "plain": "5cdc1f33",
                "symbol": "33a4c970"
            }
        }
    },
    "line.people.people": {
        "default": {
            "default": {
                "plain": "e6a5a837",
                "symbol": "aa9f311e"
            }
        },
        "v3": {
            "default": {
                "plain": "32e1bac6",
                "symbol": "28ab3add"
            }
        }
    },
    "line.people.sit": {
        "default": {
            "default": {
                "plain": "5be5298e",
                "symbol": "cd8a3dab"
            }
        },
        "v3": {
            "default": {
                "plain": "02a5a9bc",
                "symbol": "fe6a3386"
            }
        }
    },
    "line.people.traveler": {
        "default": {
            "default": {
                "plain": "3ef883a9",
                "symbol": "09cdb222"
            }
        },
        "v3": {
            "default": {
                "plain": "5c4df7b5",
                "symbol": "a661e555"
            }
        }
    },
    "line.people.user": {
        "default": {
            "default": {
                "plain": "2b9fc9cb",
                "symbol": "d5345a8e"
            }
        },
        "v3": {
            "default": {
                "plain": "3ae2a8b6",
                "symbol": "59c0a78f"
            }
        }
    },
    "line.people.user-add": {
        "default": {
            "default": {
                "plain": "21022773",
                "symbol": "ec6ef2a8"
            }
        },
        "v3": {
            "default": {
                "plain": "55b23113",
                "symbol": "ca28afc5"
            }
        }
    },
    "line.people.user-address": {
        "default": {
            "default": {
                "plain": "43561199",
                "symbol": "814fe3ef"
            }
        },
        "v3": {
            "default": {
                "plain": "5ca22f2a",
                "symbol": "fab8ab5c"
            }
        }
    },
    "line.people.user-detail": {
        "default": {
            "default": {
                "plain": "772eabd0",
                "symbol": "a2d54562"
            }
        },
        "v3": {
            "default": {
                "plain": "15a4b356",
                "symbol": "8faa9a9c"
            }
        }
    },
    "line.people.user-question": {
        "default": {
            "default": {
                "plain": "6cb74936",
                "symbol": "f972c76e"
            }
        },
        "v3": {
            "default": {
                "plain": "61169718",
                "symbol": "eb52f730"
            }
        }
    },
    "line.people.user-setting": {
        "default": {
            "default": {
                "plain": "1a236b1a",
                "symbol": "fa299c81"
            }
        },
        "v3": {
            "default": {
                "plain": "0d297cde",
                "symbol": "08108d25"
            }
        }
    },
    "line.people.user-star": {
        "default": {
            "default": {
                "plain": "090ba8c1",
                "symbol": "a98abe4e"
            }
        },
        "v3": {
            "default": {
                "plain": "bb987942",
                "symbol": "0f51100e"
            }
        }
    },
    "line.people.users": {
        "default": {
            "default": {
                "plain": "1ea21fa3",
                "symbol": "13254a65"
            }
        },
        "v3": {
            "default": {
                "plain": "818bd2f5",
                "symbol": "4633dae2"
            }
        }
    },
    "line.service.alarm": {
        "default": {
            "default": {
                "plain": "f1c53581",
                "symbol": "55df228f"
            }
        },
        "v3": {
            "default": {
                "plain": "74298a7f",
                "symbol": "3d596bda"
            }
        }
    },
    "line.service.babysitter": {
        "default": {
            "default": {
                "plain": "6952f8ba",
                "symbol": "417a8d3b"
            }
        },
        "v3": {
            "default": {
                "plain": "87c428f3",
                "symbol": "72ec18db"
            }
        }
    },
    "line.service.braille": {
        "default": {
            "default": {
                "plain": "b8ddffae",
                "symbol": "de88d239"
            }
        },
        "v3": {
            "default": {
                "plain": "18e83e3b",
                "symbol": "ac7f5aa6"
            }
        }
    },
    "line.service.call": {
        "default": {
            "default": {
                "plain": "28e0daa7",
                "symbol": "4f7d1161"
            }
        },
        "v3": {
            "default": {
                "plain": "a77a8fd3",
                "symbol": "03beb5b3"
            }
        }
    },
    "line.service.call-fast": {
        "default": {
            "default": {
                "plain": "fe61e7a3",
                "symbol": "1ed114a1"
            }
        }
    },
    "line.service.call-morning": {
        "default": {
            "default": {
                "plain": "ed8a4024",
                "symbol": "99c95d30"
            }
        },
        "v3": {
            "default": {
                "plain": "7173730d",
                "symbol": "b5ff9dc7"
            }
        }
    },
    "line.service.call-no": {
        "default": {
            "default": {
                "plain": "7d189cf1",
                "symbol": "0459a071"
            }
        },
        "v3": {
            "default": {
                "plain": "7b1a70f3",
                "symbol": "f4ed913f"
            }
        }
    },
    "line.service.call-time": {
        "default": {
            "default": {
                "plain": "b6004d64",
                "symbol": "91768c31"
            }
        }
    },
    "line.service.call2": {
        "default": {
            "default": {
                "plain": "8cf7da07",
                "symbol": "81f6772c"
            }
        },
        "v3": {
            "default": {
                "plain": "7173730d",
                "symbol": "b5ff9dc7"
            }
        }
    },
    "line.service.clean": {
        "default": {
            "default": {
                "plain": "9d0c8507",
                "symbol": "a0b6256d"
            }
        },
        "v3": {
            "default": {
                "plain": "1376fa83",
                "symbol": "408562a2"
            }
        }
    },
    "line.service.cs": {
        "default": {
            "default": {
                "plain": "978c419c",
                "symbol": "2b00fd55"
            }
        },
        "v3": {
            "default": {
                "plain": "87c11960",
                "symbol": "8fb1c70d"
            }
        }
    },
    "line.service.cs-24": {
        "default": {
            "default": {
                "plain": "4844f760",
                "symbol": "702e2741"
            }
        },
        "v3": {
            "default": {
                "plain": "5baf1401",
                "symbol": "7a5e3794"
            }
        }
    },
    "line.service.delivery": {
        "default": {
            "default": {
                "plain": "191f6a20",
                "symbol": "f73afd6e"
            }
        },
        "v3": {
            "default": {
                "plain": "4dcd1c27",
                "symbol": "29d5a38b"
            }
        }
    },
    "line.service.doorman": {
        "default": {
            "default": {
                "plain": "9ad2d660",
                "symbol": "a0ed9740"
            }
        },
        "v3": {
            "default": {
                "plain": "48c7a9db",
                "symbol": "a097ff34"
            }
        }
    },
    "line.service.guide": {
        "default": {
            "default": {
                "plain": "c0f86e27",
                "symbol": "d5d6c2c5"
            }
        },
        "v3": {
            "default": {
                "plain": "f52cb81d",
                "symbol": "e0a2c57c"
            }
        }
    },
    "line.service.guidedog": {
        "default": {
            "default": {
                "plain": "83c30b5e",
                "symbol": "2c9c97c3"
            }
        },
        "v3": {
            "default": {
                "plain": "7b90c76e",
                "symbol": "05cdf296"
            }
        }
    },
    "line.service.hand-cash": {
        "default": {
            "default": {
                "plain": "644c48be",
                "symbol": "dbe5a1e6"
            }
        },
        "v3": {
            "default": {
                "plain": "07b53bbd",
                "symbol": "7083a4e4"
            }
        }
    },
    "line.service.laundry": {
        "default": {
            "default": {
                "plain": "49f70f35",
                "symbol": "83b36346"
            }
        },
        "v3": {
            "default": {
                "plain": "8013d271",
                "symbol": "9663d8a5"
            }
        }
    },
    "line.service.massage": {
        "default": {
            "default": {
                "plain": "8036c61d",
                "symbol": "26d0de64"
            }
        },
        "v3": {
            "default": {
                "plain": "62c76f29",
                "symbol": "3a5cea2b"
            }
        }
    },
    "line.service.massage-foot": {
        "default": {
            "default": {
                "plain": "2f79ecd1",
                "symbol": "576ee2fd"
            }
        },
        "v3": {
            "default": {
                "plain": "89579e95",
                "symbol": "f306f235"
            }
        }
    },
    "line.service.postal": {
        "default": {
            "default": {
                "plain": "85b92485",
                "symbol": "e09f1899"
            }
        },
        "v3": {
            "default": {
                "plain": "e9a3407d",
                "symbol": "4a859295"
            }
        }
    },
    "line.service.reception": {
        "default": {
            "default": {
                "plain": "e7cdf466",
                "symbol": "b0bb0595"
            }
        },
        "v3": {
            "default": {
                "plain": "fbe81a54",
                "symbol": "63c96358"
            }
        }
    },
    "line.service.reception-24": {
        "default": {
            "default": {
                "plain": "82deeb43",
                "symbol": "b7c3e6d9"
            }
        },
        "v3": {
            "default": {
                "plain": "42224f20",
                "symbol": "ff7af950"
            }
        }
    },
    "line.service.reception-am": {
        "default": {
            "default": {
                "plain": "e463e53b",
                "symbol": "955df857"
            }
        },
        "v3": {
            "default": {
                "plain": "fbe81a54",
                "symbol": "63c96358"
            }
        }
    },
    "line.service.reception-check": {
        "default": {
            "default": {
                "plain": "2a13e29e",
                "symbol": "bfb05609"
            }
        },
        "v3": {
            "default": {
                "plain": "8fbf32a5",
                "symbol": "4eaf1db8"
            }
        }
    },
    "line.service.reception-flight": {
        "default": {
            "default": {
                "plain": "9fd75b4f",
                "symbol": "1686336b"
            }
        },
        "v3": {
            "default": {
                "plain": "7c9269da",
                "symbol": "e09446c1"
            }
        }
    },
    "line.service.reception-globe": {
        "default": {
            "default": {
                "plain": "7c76d6d2",
                "symbol": "29c0c431"
            }
        },
        "v3": {
            "default": {
                "plain": "fbe81a54",
                "symbol": "63c96358"
            }
        }
    },
    "line.service.reception-pm": {
        "default": {
            "default": {
                "plain": "3f9831c8",
                "symbol": "d069d941"
            }
        },
        "v3": {
            "default": {
                "plain": "fbe81a54",
                "symbol": "63c96358"
            }
        }
    },
    "line.service.reception-vip": {
        "default": {
            "default": {
                "plain": "e64024f7",
                "symbol": "6b32e15d"
            }
        },
        "v3": {
            "default": {
                "plain": "fbe81a54",
                "symbol": "63c96358"
            }
        }
    },
    "line.service.roomservice": {
        "default": {
            "default": {
                "plain": "a5c43868",
                "symbol": "8e3512fd"
            }
        },
        "v3": {
            "default": {
                "plain": "8f2701ff",
                "symbol": "9e05d2d0"
            }
        }
    },
    "line.service.roomservice-24": {
        "default": {
            "default": {
                "plain": "aa25ef61",
                "symbol": "575aec22"
            }
        },
        "v3": {
            "default": {
                "plain": "8f2701ff",
                "symbol": "9e05d2d0"
            }
        }
    },
    "line.service.security": {
        "default": {
            "default": {
                "plain": "770b9429",
                "symbol": "c53cc890"
            }
        },
        "v3": {
            "default": {
                "plain": "5df6e0a5",
                "symbol": "a779a973"
            }
        }
    },
    "line.service.signlanguage": {
        "default": {
            "default": {
                "plain": "85a5bcec",
                "symbol": "cc47799b"
            }
        },
        "v3": {
            "default": {
                "plain": "2b7d475f",
                "symbol": "269d5444"
            }
        }
    },
    "line.service.theraphy": {
        "default": {
            "default": {
                "plain": "4d66be22",
                "symbol": "f656b0d0"
            }
        },
        "v3": {
            "default": {
                "plain": "509719cc",
                "symbol": "8a68dc01"
            }
        }
    },
    "line.service.valet": {
        "default": {
            "default": {
                "plain": "4d94b128",
                "symbol": "0b207d0f"
            }
        },
        "v3": {
            "default": {
                "plain": "7b90659d",
                "symbol": "e7790ffa"
            }
        }
    },
    "line.symbol.24hours": {
        "default": {
            "default": {
                "plain": "10c8b546",
                "symbol": "f064ba35"
            }
        },
        "v3": {
            "default": {
                "plain": "42224f20",
                "symbol": "ff7af950"
            }
        }
    },
    "line.symbol.a11y": {
        "default": {
            "default": {
                "plain": "153c454f",
                "symbol": "2281a2ea"
            }
        },
        "v3": {
            "default": {
                "plain": "49ec84a5",
                "symbol": "20d1b699"
            }
        }
    },
    "line.symbol.ai-generated": {
        "default": {
            "default": {
                "plain": "667b6f5e",
                "symbol": "6e78e8f2"
            }
        },
        "v3": {
            "default": {
                "plain": "770dce17",
                "symbol": "cd0c14f7"
            }
        }
    },
    "line.symbol.bank": {
        "default": {
            "default": {
                "plain": "356e73b4",
                "symbol": "54333aee"
            }
        },
        "v3": {
            "default": {
                "plain": "a3cf376a",
                "symbol": "3b64f240"
            }
        }
    },
    "line.symbol.bell": {
        "default": {
            "default": {
                "plain": "cdf8a5e0",
                "symbol": "2e06fcbc"
            }
        },
        "v3": {
            "default": {
                "plain": "72f9e27a",
                "symbol": "0677e660"
            }
        }
    },
    "line.symbol.bell-no": {
        "default": {
            "default": {
                "plain": "db66a4dd",
                "symbol": "f08216af"
            }
        },
        "v3": {
            "default": {
                "plain": "4b0d21ef",
                "symbol": "eb513634"
            }
        }
    },
    "line.symbol.bin": {
        "default": {
            "default": {
                "plain": "f3d1511b",
                "symbol": "9560df05"
            }
        },
        "v3": {
            "default": {
                "plain": "2e335e3b",
                "symbol": "151a2b1e"
            }
        }
    },
    "line.symbol.bookmark": {
        "default": {
            "default": {
                "plain": "b74cc8ec",
                "symbol": "f884ac9d"
            }
        },
        "v3": {
            "default": {
                "plain": "c36482ef",
                "symbol": "103a76c8"
            }
        }
    },
    "line.symbol.box-star": {
        "default": {
            "default": {
                "plain": "06a22a82",
                "symbol": "28c0abf6"
            }
        },
        "v3": {
            "default": {
                "plain": "6158938f",
                "symbol": "76679d79"
            }
        }
    },
    "line.symbol.box-star-half": {
        "default": {
            "default": {
                "plain": "18764457",
                "symbol": "0eafc058"
            }
        },
        "v3": {
            "default": {
                "plain": "f8400c89",
                "symbol": "d5b23818"
            }
        }
    },
    "line.symbol.bubble-chat": {
        "default": {
            "default": {
                "plain": "3f6a6647",
                "symbol": "eaf6b8b4"
            }
        },
        "v3": {
            "default": {
                "plain": "abc89f00",
                "symbol": "6f3d4d7e"
            }
        }
    },
    "line.symbol.bubble-chat-fast": {
        "default": {
            "default": {
                "plain": "b843c224",
                "symbol": "aac84403"
            }
        }
    },
    "line.symbol.bubble-language": {
        "default": {
            "default": {
                "plain": "9dfd7ded",
                "symbol": "188acd20"
            }
        },
        "v3": {
            "default": {
                "plain": "d75a72e6",
                "symbol": "b46cc856"
            }
        }
    },
    "line.symbol.bubble-language-no": {
        "default": {
            "default": {
                "plain": "1d514975",
                "symbol": "64102fe8"
            }
        },
        "v3": {
            "default": {
                "plain": "8493033a",
                "symbol": "60c42e88"
            }
        }
    },
    "line.symbol.bubble-sparkle": {
        "default": {
            "default": {
                "plain": "5cc01ee8",
                "symbol": "94032ba9"
            }
        },
        "v3": {
            "default": {
                "plain": "51c3a17c",
                "symbol": "84e8060b"
            }
        }
    },
    "line.symbol.bubble-text": {
        "default": {
            "default": {
                "plain": "e6bc6e04",
                "symbol": "0d80ba17"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "ceff4cfe",
                "symbol": "533a331e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.bubble-write": {
        "default": {
            "default": {
                "plain": "21c31a49",
                "symbol": "d20826c3"
            }
        },
        "v3": {
            "default": {
                "plain": "609e52fa",
                "symbol": "3699df6f"
            }
        }
    },
    "line.symbol.bubbles": {
        "default": {
            "default": {
                "plain": "f420745c",
                "symbol": "5ca3d3c0"
            }
        },
        "v3": {
            "default": {
                "plain": "26bf7550",
                "symbol": "e8badca4"
            }
        }
    },
    "line.symbol.bug": {
        "default": {
            "default": {
                "plain": "75c6e177",
                "symbol": "39b379b2"
            }
        },
        "v3": {
            "default": {
                "plain": "82cf5dbd",
                "symbol": "057ed904"
            }
        }
    },
    "line.symbol.bulk-action": {
        "default": {
            "default": {
                "plain": "749be78a",
                "symbol": "6885d2b9"
            }
        },
        "v3": {
            "default": {
                "plain": "792edb17",
                "symbol": "47698e1c"
            }
        }
    },
    "line.symbol.calendar": {
        "default": {
            "default": {
                "plain": "853de3c6",
                "symbol": "c80f9926"
            }
        },
        "v3": {
            "default": {
                "plain": "3a43733c",
                "symbol": "b2cfedc9"
            }
        }
    },
    "line.symbol.calendar-30": {
        "default": {
            "default": {
                "plain": "30eead33",
                "symbol": "36b00f03"
            }
        },
        "v3": {
            "default": {
                "plain": "d1f674bc",
                "symbol": "b849be8b"
            }
        }
    },
    "line.symbol.calendar-7": {
        "default": {
            "default": {
                "plain": "74ae59b6",
                "symbol": "8fd49d24"
            }
        },
        "v3": {
            "default": {
                "plain": "f4347818",
                "symbol": "03e2b0d9"
            }
        }
    },
    "line.symbol.calendar-cancel": {
        "default": {
            "default": {
                "plain": "fcd0f1d8",
                "symbol": "c85fa0ee"
            }
        },
        "v3": {
            "default": {
                "plain": "20fc6614",
                "symbol": "14320ae3"
            }
        }
    },
    "line.symbol.calendar-cancel-check": {
        "default": {
            "default": {
                "plain": "b802b471",
                "symbol": "4e174337"
            }
        },
        "v3": {
            "default": {
                "plain": "b4b32d7b",
                "symbol": "cb7e2b85"
            }
        }
    },
    "line.symbol.calendar-cancel-no": {
        "default": {
            "default": {
                "plain": "65783892",
                "symbol": "743c717a"
            }
        },
        "v3": {
            "default": {
                "plain": "bf8a9042",
                "symbol": "88586e1a"
            }
        }
    },
    "line.symbol.calendar-cancel-pay": {
        "default": {
            "default": {
                "plain": "9b6015b2",
                "symbol": "627fd650"
            }
        },
        "v3": {
            "default": {
                "plain": "66e5b1aa",
                "symbol": "97d86782"
            }
        }
    },
    "line.symbol.calendar-change": {
        "default": {
            "default": {
                "plain": "62517709",
                "symbol": "264ae359"
            }
        },
        "v3": {
            "default": {
                "plain": "e3293019",
                "symbol": "94e63335"
            }
        }
    },
    "line.symbol.calendar-change-check": {
        "default": {
            "default": {
                "plain": "965a1ef9",
                "symbol": "57114013"
            }
        },
        "v3": {
            "default": {
                "plain": "68c7400f",
                "symbol": "ee34b23d"
            }
        }
    },
    "line.symbol.calendar-change-no": {
        "default": {
            "default": {
                "plain": "1dd065f4",
                "symbol": "7bdf46b4"
            }
        },
        "v3": {
            "default": {
                "plain": "36228501",
                "symbol": "a43ee72a"
            }
        }
    },
    "line.symbol.calendar-change-pay": {
        "default": {
            "default": {
                "plain": "40cfa7a8",
                "symbol": "f95e7afd"
            }
        },
        "v3": {
            "default": {
                "plain": "eb5daede",
                "symbol": "2716056b"
            }
        }
    },
    "line.symbol.calendar-check": {
        "default": {
            "default": {
                "plain": "5335aa07",
                "symbol": "2ea552a5"
            }
        },
        "v3": {
            "default": {
                "plain": "3faf8f11",
                "symbol": "a7604690"
            }
        }
    },
    "line.symbol.calendar-in": {
        "default": {
            "default": {
                "plain": "aaba6d54",
                "symbol": "40c216eb"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "7aa65790",
                "symbol": "ab89946a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.calendar-out": {
        "default": {
            "default": {
                "plain": "2f6ac411",
                "symbol": "3b017706"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "cc026a6e",
                "symbol": "826756e8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.calendar-pay": {
        "default": {
            "default": {
                "plain": "44e1a288",
                "symbol": "db1032c4"
            }
        },
        "v3": {
            "default": {
                "plain": "2afe71d0",
                "symbol": "babaf9cf"
            }
        }
    },
    "line.symbol.card": {
        "default": {
            "default": {
                "plain": "95c028ea",
                "symbol": "c8393249"
            }
        },
        "v3": {
            "default": {
                "plain": "2b92d969",
                "symbol": "db5d40f8"
            }
        }
    },
    "line.symbol.card-no": {
        "default": {
            "default": {
                "plain": "d3fad6c8",
                "symbol": "4387891b"
            }
        },
        "v3": {
            "default": {
                "plain": "7b15e39e",
                "symbol": "81fa20c7"
            }
        }
    },
    "line.symbol.cart": {
        "default": {
            "default": {
                "plain": "348433f2",
                "symbol": "130ca7b8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "cdb08b53",
                "symbol": "12e5fa0a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.cart-add": {
        "default": {
            "default": {
                "plain": "2987c657",
                "symbol": "ebf31efb"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "7ed5af8b",
                "symbol": "80d8b97f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.cart-check": {
        "default": {
            "default": {
                "plain": "97f7a711",
                "symbol": "51ac5a6e"
            },
            "rtl": {
                "plain": "6e4cd646",
                "symbol": "c3bac4a4"
            }
        },
        "v3": {
            "default": {
                "plain": "a5817326",
                "symbol": "a38878c0"
            },
            "rtl": {
                "plain": "29e26b70",
                "symbol": "7b599a22"
            }
        }
    },
    "line.symbol.cart-empty": {
        "default": {
            "default": {
                "plain": "50dcf26c",
                "symbol": "72dfdb7b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.cfar": {
        "default": {
            "default": {
                "plain": "0f314440",
                "symbol": "3ee1ed49"
            }
        }
    },
    "line.symbol.check": {
        "default": {
            "default": {
                "plain": "3d7cee6f",
                "symbol": "9178b9cb"
            }
        },
        "v3": {
            "default": {
                "plain": "2bed95c1",
                "symbol": "522d8d24"
            }
        }
    },
    "line.symbol.church": {
        "default": {
            "default": {
                "plain": "bacb14b3",
                "symbol": "49854c87"
            }
        },
        "v3": {
            "default": {
                "plain": "31ac90bd",
                "symbol": "5896e490"
            }
        }
    },
    "line.symbol.circle": {
        "default": {
            "default": {
                "plain": "fa7ef73a",
                "symbol": "ecab82a7"
            }
        },
        "v3": {
            "default": {
                "plain": "483b838c",
                "symbol": "97e9ff53"
            }
        }
    },
    "line.symbol.circle-card": {
        "default": {
            "default": {
                "plain": "79da0753",
                "symbol": "d7b4b1b9"
            }
        },
        "v3": {
            "default": {
                "plain": "08173f5e",
                "symbol": "493e720b"
            }
        }
    },
    "line.symbol.circle-card-no": {
        "default": {
            "default": {
                "plain": "07a0c31d",
                "symbol": "b3ce6850"
            }
        },
        "v3": {
            "default": {
                "plain": "82231705",
                "symbol": "ebc0b9ef"
            }
        }
    },
    "line.symbol.circle-check": {
        "default": {
            "default": {
                "plain": "7c474f7b",
                "symbol": "c3348700"
            }
        },
        "v3": {
            "default": {
                "plain": "6986b37a",
                "symbol": "1d64491f"
            }
        }
    },
    "line.symbol.circle-close": {
        "default": {
            "default": {
                "plain": "a2367096",
                "symbol": "00ed43b3"
            }
        },
        "v3": {
            "default": {
                "plain": "26e3df5f",
                "symbol": "c00a5b25"
            }
        }
    },
    "line.symbol.circle-exclamation": {
        "default": {
            "default": {
                "plain": "4d3839ea",
                "symbol": "fb33b555"
            }
        },
        "v3": {
            "default": {
                "plain": "38714faf",
                "symbol": "1d2a0fd8"
            }
        }
    },
    "line.symbol.circle-flight": {
        "default": {
            "default": {
                "plain": "d55f0292",
                "symbol": "d6ae7431"
            }
        },
        "v3": {
            "default": {
                "plain": "19fc798f",
                "symbol": "6e14d74e"
            }
        }
    },
    "line.symbol.circle-gift": {
        "default": {
            "default": {
                "plain": "5bcc33f4",
                "symbol": "ab6468fd"
            }
        },
        "v3": {
            "default": {
                "plain": "24d75722",
                "symbol": "3f3daf35"
            }
        }
    },
    "line.symbol.circle-half": {
        "default": {
            "default": {
                "plain": "a1e4bd36",
                "symbol": "c8df7fda"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "866caffc",
                "symbol": "a7775fe0"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.circle-home": {
        "default": {
            "default": {
                "plain": "28a8632b",
                "symbol": "3f02b060"
            }
        },
        "v3": {
            "default": {
                "plain": "d09c4f12",
                "symbol": "d61cdfe7"
            }
        }
    },
    "line.symbol.circle-home-check": {
        "default": {
            "default": {
                "plain": "d23c5588",
                "symbol": "2ee00fae"
            }
        },
        "v3": {
            "default": {
                "plain": "50b7bd97",
                "symbol": "feb148ee"
            }
        }
    },
    "line.symbol.circle-info": {
        "default": {
            "default": {
                "plain": "b319ee45",
                "symbol": "571b37cb"
            }
        },
        "v3": {
            "default": {
                "plain": "fc3a270a",
                "symbol": "5d4fcc47"
            }
        }
    },
    "line.symbol.circle-lightbulb": {
        "default": {
            "default": {
                "plain": "306ab091",
                "symbol": "7a3922c2"
            }
        },
        "v3": {
            "default": {
                "plain": "3621adc9",
                "symbol": "121ba302"
            }
        }
    },
    "line.symbol.circle-lightning1": {
        "default": {
            "default": {
                "plain": "c41f874a",
                "symbol": "25d891ef"
            }
        },
        "v3": {
            "default": {
                "plain": "4ca9bb3e",
                "symbol": "f42fe3e8"
            }
        }
    },
    "line.symbol.circle-mandarin": {
        "default": {
            "default": {
                "plain": "db3eeb6e",
                "symbol": "34e99971"
            }
        },
        "v3": {
            "default": {
                "plain": "5ed956e9",
                "symbol": "6c9ad374"
            }
        }
    },
    "line.symbol.circle-minus": {
        "default": {
            "default": {
                "plain": "7df6cda9",
                "symbol": "658aeb0f"
            }
        },
        "v3": {
            "default": {
                "plain": "e775b695",
                "symbol": "e3142ef8"
            }
        }
    },
    "line.symbol.circle-pin": {
        "default": {
            "default": {
                "plain": "0a5c81a5",
                "symbol": "13d1cda5"
            }
        },
        "v3": {
            "default": {
                "plain": "69a667ec",
                "symbol": "e7bf4aab"
            }
        }
    },
    "line.symbol.circle-plus": {
        "default": {
            "default": {
                "plain": "45dc8138",
                "symbol": "37c569b9"
            }
        },
        "v3": {
            "default": {
                "plain": "24fe5533",
                "symbol": "b6087c21"
            }
        }
    },
    "line.symbol.circle-question": {
        "default": {
            "default": {
                "plain": "2f26afce",
                "symbol": "1f429d1b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "57a14c73",
                "symbol": "d2030c8b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.circle-ribbon": {
        "default": {
            "default": {
                "plain": "a24ca8a9",
                "symbol": "3ee66381"
            }
        },
        "v3": {
            "default": {
                "plain": "f662399e",
                "symbol": "18e31f52"
            }
        }
    },
    "line.symbol.circle-star": {
        "default": {
            "default": {
                "plain": "dc21e6ed",
                "symbol": "49dc9049"
            }
        },
        "v3": {
            "default": {
                "plain": "5633fd02",
                "symbol": "ec17e29e"
            }
        }
    },
    "line.symbol.circle-start": {
        "default": {
            "default": {
                "plain": "5fef4b82",
                "symbol": "1c931853"
            }
        },
        "v3": {
            "default": {
                "plain": "1700dfaa",
                "symbol": "a4dbf81d"
            }
        }
    },
    "line.symbol.circle-stop": {
        "default": {
            "default": {
                "plain": "c754e540",
                "symbol": "c50a46e0"
            }
        },
        "v3": {
            "default": {
                "plain": "f49b436c",
                "symbol": "01a7c04f"
            }
        }
    },
    "line.symbol.circle-tag": {
        "default": {
            "default": {
                "plain": "3165ff2c",
                "symbol": "2c6ab81b"
            }
        },
        "v3": {
            "default": {
                "plain": "46566b74",
                "symbol": "cdc4385a"
            }
        }
    },
    "line.symbol.circle-ticket": {
        "default": {
            "default": {
                "plain": "922764af",
                "symbol": "b3b8b9af"
            }
        },
        "v3": {
            "default": {
                "plain": "67be6470",
                "symbol": "bd464c32"
            }
        }
    },
    "line.symbol.city": {
        "default": {
            "default": {
                "plain": "724a4f28",
                "symbol": "c9ac5159"
            }
        },
        "v3": {
            "default": {
                "plain": "e4378948",
                "symbol": "056733e3"
            }
        }
    },
    "line.symbol.city-pin": {
        "default": {
            "default": {
                "plain": "c040c309",
                "symbol": "366d1ac7"
            }
        },
        "v3": {
            "default": {
                "plain": "35f97866",
                "symbol": "fac0416d"
            }
        }
    },
    "line.symbol.clip": {
        "default": {
            "default": {
                "plain": "4057d767",
                "symbol": "c00e5c6c"
            }
        },
        "v3": {
            "default": {
                "plain": "dea52c04",
                "symbol": "e6ab2fad"
            }
        }
    },
    "line.symbol.close": {
        "default": {
            "default": {
                "plain": "42dc9199",
                "symbol": "9523eea2"
            }
        },
        "v3": {
            "default": {
                "plain": "e850e4bd",
                "symbol": "0873b4c5"
            }
        }
    },
    "line.symbol.closed-caption": {
        "default": {
            "default": {
                "plain": "7e829e68",
                "symbol": "c258af04"
            }
        },
        "v3": {
            "default": {
                "plain": "7eb6103a",
                "symbol": "18ba24b1"
            }
        }
    },
    "line.symbol.coordinate": {
        "default": {
            "default": {
                "plain": "7404ddd7",
                "symbol": "932c9f86"
            }
        },
        "v3": {
            "default": {
                "plain": "ca7147e2",
                "symbol": "595cf546"
            }
        }
    },
    "line.symbol.copy": {
        "default": {
            "default": {
                "plain": "5122035d",
                "symbol": "203c34a5"
            }
        }
    },
    "line.symbol.currency": {
        "default": {
            "default": {
                "plain": "02619f63",
                "symbol": "4a7e3af0"
            }
        }
    },
    "line.symbol.currency-baht": {
        "default": {
            "default": {
                "plain": "f73d8748",
                "symbol": "dbeac21f"
            }
        },
        "v3": {
            "default": {
                "plain": "1af66cba",
                "symbol": "dcd44aff"
            }
        }
    },
    "line.symbol.deal-percent": {
        "default": {
            "default": {
                "plain": "6c98f9ce",
                "symbol": "0b7be79e"
            }
        },
        "v3": {
            "default": {
                "plain": "158373df",
                "symbol": "9789b71a"
            }
        }
    },
    "line.symbol.diamond": {
        "default": {
            "default": {
                "plain": "330aeab9",
                "symbol": "c96efc44"
            }
        },
        "v3": {
            "default": {
                "plain": "1edfe02c",
                "symbol": "4da06a3a"
            }
        }
    },
    "line.symbol.diamond-half": {
        "default": {
            "default": {
                "plain": "36896201",
                "symbol": "de0dd652"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "1a2254c6",
                "symbol": "b77214f1"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.doc-check": {
        "default": {
            "default": {
                "plain": "c7d41ab4",
                "symbol": "c93f57ee"
            }
        },
        "v3": {
            "default": {
                "plain": "6986b37a",
                "symbol": "1d64491f"
            }
        }
    },
    "line.symbol.doc-checklist": {
        "default": {
            "default": {
                "plain": "9c6906b8",
                "symbol": "275c5158"
            }
        },
        "v3": {
            "default": {
                "plain": "d27a98dd",
                "symbol": "f7f7f871"
            }
        }
    },
    "line.symbol.doc-clip": {
        "default": {
            "default": {
                "plain": "01dd4086",
                "symbol": "c56844c0"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f8464eb3",
                "symbol": "6a65eb55"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.doc-close": {
        "default": {
            "default": {
                "plain": "21061be3",
                "symbol": "9e758ed5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "acb2096b",
                "symbol": "0bdd800c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.doc-csv": {
        "default": {
            "default": {
                "plain": "904b3724",
                "symbol": "bf038c5f"
            }
        },
        "v3": {
            "default": {
                "plain": "445ea06e",
                "symbol": "f03bb5a3"
            }
        }
    },
    "line.symbol.doc-download": {
        "default": {
            "default": {
                "plain": "facc9d1c",
                "symbol": "a35e79e7"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "445ea06e",
                "symbol": "f03bb5a3"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.doc-exclamation": {
        "default": {
            "default": {
                "plain": "060255af",
                "symbol": "a864cb98"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "38714faf",
                "symbol": "1d2a0fd8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.doc-info": {
        "default": {
            "default": {
                "plain": "0de79bbc",
                "symbol": "de78a5dd"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "fc3a270a",
                "symbol": "5d4fcc47"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.doc-pay": {
        "default": {
            "default": {
                "plain": "25ac6ef5",
                "symbol": "22334485"
            }
        },
        "v3": {
            "default": {
                "plain": "fd485719",
                "symbol": "ed497f50"
            }
        }
    },
    "line.symbol.doc-pdf": {
        "default": {
            "default": {
                "plain": "4dc4465f",
                "symbol": "dea0a6d7"
            }
        },
        "v3": {
            "default": {
                "plain": "445ea06e",
                "symbol": "f03bb5a3"
            }
        }
    },
    "line.symbol.doc-write": {
        "default": {
            "default": {
                "plain": "b16c1672",
                "symbol": "37ea12ac"
            }
        },
        "v3": {
            "default": {
                "plain": "fd48ff42",
                "symbol": "92a27e35"
            }
        }
    },
    "line.symbol.doc-xls": {
        "default": {
            "default": {
                "plain": "ca8c6f15",
                "symbol": "9254e35b"
            }
        },
        "v3": {
            "default": {
                "plain": "445ea06e",
                "symbol": "f03bb5a3"
            }
        }
    },
    "line.symbol.document": {
        "default": {
            "default": {
                "plain": "78cf6f40",
                "symbol": "048cb128"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "a51cac4f",
                "symbol": "9900ac0f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.dollar": {
        "default": {
            "default": {
                "plain": "dbf01c39",
                "symbol": "115faa06"
            }
        },
        "v3": {
            "default": {
                "plain": "4299e907",
                "symbol": "f9711bba"
            }
        }
    },
    "line.symbol.door": {
        "default": {
            "default": {
                "plain": "9dec8555",
                "symbol": "4a141fc4"
            }
        },
        "v3": {
            "default": {
                "plain": "15e250b7",
                "symbol": "61597b03"
            }
        }
    },
    "line.symbol.door-check": {
        "default": {
            "default": {
                "plain": "88159d1e",
                "symbol": "316ea1db"
            }
        },
        "v3": {
            "default": {
                "plain": "56f66ba8",
                "symbol": "94e66057"
            }
        }
    },
    "line.symbol.doortag": {
        "default": {
            "default": {
                "plain": "ad0382b3",
                "symbol": "ce0fd28d"
            }
        },
        "v3": {
            "default": {
                "plain": "f9cb6ac1",
                "symbol": "4e1ed143"
            }
        }
    },
    "line.symbol.edit": {
        "default": {
            "default": {
                "plain": "bcaba3c8",
                "symbol": "72aeb293"
            }
        },
        "v3": {
            "default": {
                "plain": "fd48ff42",
                "symbol": "92a27e35"
            }
        }
    },
    "line.symbol.envelope": {
        "default": {
            "default": {
                "plain": "527b9b0b",
                "symbol": "7f0030f3"
            }
        },
        "v3": {
            "default": {
                "plain": "a5f8f69d",
                "symbol": "9bc06ca8"
            }
        }
    },
    "line.symbol.envelope-arrow": {
        "default": {
            "default": {
                "plain": "06ef7c99",
                "symbol": "a8d559c0"
            }
        },
        "v3": {
            "default": {
                "plain": "3b3be400",
                "symbol": "2a451075"
            }
        }
    },
    "line.symbol.external-link": {
        "default": {
            "default": {
                "plain": "13a6240c",
                "symbol": "7ede1bbf"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "754c024e",
                "symbol": "024d53fe"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.eye": {
        "default": {
            "default": {
                "plain": "c0727706",
                "symbol": "b960946f"
            }
        },
        "v3": {
            "default": {
                "plain": "222cf55b",
                "symbol": "e4e51131"
            }
        }
    },
    "line.symbol.eye-no": {
        "default": {
            "default": {
                "plain": "14b037cf",
                "symbol": "65c46dec"
            }
        },
        "v3": {
            "default": {
                "plain": "9c763fe8",
                "symbol": "3d291118"
            }
        }
    },
    "line.symbol.female": {
        "default": {
            "default": {
                "plain": "3fc84cb4",
                "symbol": "42ca69ef"
            }
        },
        "v3": {
            "default": {
                "plain": "543ccae8",
                "symbol": "a5022b2a"
            }
        }
    },
    "line.symbol.filter": {
        "default": {
            "default": {
                "plain": "2d3b7318",
                "symbol": "b6a6af64"
            }
        },
        "v3": {
            "default": {
                "plain": "88608bc2",
                "symbol": "045c3623"
            }
        }
    },
    "line.symbol.filter2": {
        "default": {
            "default": {
                "plain": "be29aef8",
                "symbol": "cf4443e6"
            }
        },
        "v3": {
            "default": {
                "plain": "84186022",
                "symbol": "b7dc6d9a"
            }
        }
    },
    "line.symbol.flag": {
        "default": {
            "default": {
                "plain": "9b50f002",
                "symbol": "3c396d66"
            }
        },
        "v3": {
            "default": {
                "plain": "59cf4f63",
                "symbol": "c6e0311c"
            }
        }
    },
    "line.symbol.gift": {
        "default": {
            "default": {
                "plain": "18484d80",
                "symbol": "5819c2d0"
            }
        },
        "v3": {
            "default": {
                "plain": "882b72ce",
                "symbol": "a2737f2d"
            }
        }
    },
    "line.symbol.globe": {
        "default": {
            "default": {
                "plain": "acb6bd32",
                "symbol": "46747c25"
            }
        },
        "v3": {
            "default": {
                "plain": "9ccd76cd",
                "symbol": "59c928da"
            }
        }
    },
    "line.symbol.graph-ascend": {
        "default": {
            "default": {
                "plain": "7429fbf9",
                "symbol": "d251fe20"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "9a50b1d1",
                "symbol": "b19bdddd"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.graph-descend": {
        "default": {
            "default": {
                "plain": "b899cd1e",
                "symbol": "926b8987"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "0465317a",
                "symbol": "bdf4a93b"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.halal": {
        "default": {
            "default": {
                "plain": "b428923a",
                "symbol": "8a1d95b3"
            }
        },
        "v3": {
            "default": {
                "plain": "60b88bd5",
                "symbol": "6f4e55ad"
            }
        }
    },
    "line.symbol.hearing": {
        "default": {
            "default": {
                "plain": "48184136",
                "symbol": "c798e830"
            }
        },
        "v3": {
            "default": {
                "plain": "66b8feb8",
                "symbol": "01ddcfcc"
            }
        }
    },
    "line.symbol.heart": {
        "default": {
            "default": {
                "plain": "c3aeecfd",
                "symbol": "7c5057a7"
            }
        },
        "v3": {
            "default": {
                "plain": "c3986c76",
                "symbol": "748629fd"
            }
        }
    },
    "line.symbol.heart-beat": {
        "default": {
            "default": {
                "plain": "a4551969",
                "symbol": "d7db1888"
            }
        },
        "v3": {
            "default": {
                "plain": "2f16e14e",
                "symbol": "7f202cdf"
            }
        }
    },
    "line.symbol.heart-empty": {
        "default": {
            "default": {
                "plain": "ac2a5f65",
                "symbol": "75e78206"
            }
        }
    },
    "line.symbol.hearts": {
        "default": {
            "default": {
                "plain": "316e7e1f",
                "symbol": "6130b76a"
            }
        },
        "v3": {
            "default": {
                "plain": "3f0fa50d",
                "symbol": "80d420ff"
            }
        }
    },
    "line.symbol.home": {
        "default": {
            "default": {
                "plain": "6e3c11f7",
                "symbol": "61c546eb"
            }
        },
        "v3": {
            "default": {
                "plain": "afff0f37",
                "symbol": "6b8fc73b"
            }
        }
    },
    "line.symbol.home-check": {
        "default": {
            "default": {
                "plain": "e8ea78b8",
                "symbol": "593d7d02"
            }
        },
        "v3": {
            "default": {
                "plain": "aebc8851",
                "symbol": "b5a0809d"
            }
        }
    },
    "line.symbol.hygiene": {
        "default": {
            "default": {
                "plain": "fedb2107",
                "symbol": "ef14f825"
            }
        },
        "v3": {
            "default": {
                "plain": "979d17cc",
                "symbol": "acf2f1fa"
            }
        }
    },
    "line.symbol.inbox": {
        "default": {
            "default": {
                "plain": "cc13175c",
                "symbol": "3c28a923"
            }
        },
        "v3": {
            "default": {
                "plain": "096f2706",
                "symbol": "b877cbcb"
            }
        }
    },
    "line.symbol.jewish": {
        "default": {
            "default": {
                "plain": "2fc829fb",
                "symbol": "4ead746f"
            }
        },
        "v3": {
            "default": {
                "plain": "cd033676",
                "symbol": "8dbc22f8"
            }
        }
    },
    "line.symbol.lightbulb": {
        "default": {
            "default": {
                "plain": "de9c2f43",
                "symbol": "924c4ca0"
            }
        },
        "v3": {
            "default": {
                "plain": "152ac7ea",
                "symbol": "7ce0806e"
            }
        }
    },
    "line.symbol.lightning1": {
        "default": {
            "default": {
                "plain": "7d93fb00",
                "symbol": "66b79979"
            }
        },
        "v3": {
            "default": {
                "plain": "87b183de",
                "symbol": "8ba83064"
            }
        }
    },
    "line.symbol.lightning2": {
        "default": {
            "default": {
                "plain": "70fabfd0",
                "symbol": "94442082"
            }
        },
        "v3": {
            "default": {
                "plain": "877577dc",
                "symbol": "d051eb58"
            }
        }
    },
    "line.symbol.link": {
        "default": {
            "default": {
                "plain": "56cee399",
                "symbol": "39dc38a4"
            }
        },
        "v3": {
            "default": {
                "plain": "fc8e2f22",
                "symbol": "4f35a17f"
            }
        }
    },
    "line.symbol.list": {
        "default": {
            "default": {
                "plain": "e143fe0e",
                "symbol": "52a50ed2"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "05a1f359",
                "symbol": "4987b3f0"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.location": {
        "default": {
            "default": {
                "plain": "e9d01d85",
                "symbol": "34107b81"
            }
        },
        "v3": {
            "default": {
                "plain": "ad7e5ad5",
                "symbol": "f2c9f1b6"
            }
        }
    },
    "line.symbol.location-review": {
        "default": {
            "default": {
                "plain": "2c628ad0",
                "symbol": "358238bb"
            }
        }
    },
    "line.symbol.lock-locked": {
        "default": {
            "default": {
                "plain": "c45df9cc",
                "symbol": "2ff4d83c"
            }
        },
        "v3": {
            "default": {
                "plain": "079b54a2",
                "symbol": "97b87740"
            }
        }
    },
    "line.symbol.lock-unlocked": {
        "default": {
            "default": {
                "plain": "ee08b227",
                "symbol": "b2eea250"
            }
        },
        "v3": {
            "default": {
                "plain": "fb0cfd3f",
                "symbol": "af3d2c0b"
            }
        }
    },
    "line.symbol.loudspeaker": {
        "default": {
            "default": {
                "plain": "12f556a4",
                "symbol": "9dbc645e"
            }
        },
        "v3": {
            "default": {
                "plain": "5cd938a1",
                "symbol": "69f2c1a2"
            }
        }
    },
    "line.symbol.male": {
        "default": {
            "default": {
                "plain": "55a0c83b",
                "symbol": "d901a15e"
            }
        },
        "v3": {
            "default": {
                "plain": "bbd82b7e",
                "symbol": "897793e9"
            }
        }
    },
    "line.symbol.mandarin": {
        "default": {
            "default": {
                "plain": "18c17df2",
                "symbol": "7bd65000"
            }
        },
        "v3": {
            "default": {
                "plain": "2373e07c",
                "symbol": "4b703ad0"
            }
        }
    },
    "line.symbol.medal-check": {
        "default": {
            "default": {
                "plain": "25430d64",
                "symbol": "dbee4012"
            }
        },
        "v3": {
            "default": {
                "plain": "443e13fa",
                "symbol": "7b64080c"
            }
        }
    },
    "line.symbol.medal-one": {
        "default": {
            "default": {
                "plain": "6c443820",
                "symbol": "356f2a4d"
            }
        },
        "v3": {
            "default": {
                "plain": "bcb77512",
                "symbol": "9b538609"
            }
        }
    },
    "line.symbol.medal1": {
        "default": {
            "default": {
                "plain": "424c5740",
                "symbol": "70ee2763"
            }
        },
        "v3": {
            "default": {
                "plain": "6686fb16",
                "symbol": "1150fed5"
            }
        }
    },
    "line.symbol.medal2": {
        "default": {
            "default": {
                "plain": "789df1d1",
                "symbol": "81f2df75"
            }
        },
        "v3": {
            "default": {
                "plain": "85f165bf",
                "symbol": "df3f9d5d"
            }
        }
    },
    "line.symbol.menu": {
        "default": {
            "default": {
                "plain": "246835ce",
                "symbol": "ac7e3714"
            }
        },
        "v3": {
            "default": {
                "plain": "3094a487",
                "symbol": "c31ad80f"
            }
        }
    },
    "line.symbol.microphone": {
        "default": {
            "default": {
                "plain": "3594cfd9",
                "symbol": "0b2029fb"
            }
        },
        "v3": {
            "default": {
                "plain": "368acc59",
                "symbol": "58fd08ab"
            }
        }
    },
    "line.symbol.microphone-no": {
        "default": {
            "default": {
                "plain": "49ada83d",
                "symbol": "32884430"
            }
        },
        "v3": {
            "default": {
                "plain": "0e36a63b",
                "symbol": "f542d46f"
            }
        }
    },
    "line.symbol.minus": {
        "default": {
            "default": {
                "plain": "f5cad33d",
                "symbol": "1d08cebf"
            }
        },
        "v3": {
            "default": {
                "plain": "f640fe1d",
                "symbol": "61daccb0"
            }
        }
    },
    "line.symbol.moon": {
        "default": {
            "default": {
                "plain": "cdb7b325",
                "symbol": "ae686fc4"
            }
        },
        "v3": {
            "default": {
                "plain": "1b7cc0df",
                "symbol": "f1eddab7"
            }
        }
    },
    "line.symbol.more": {
        "default": {
            "default": {
                "plain": "c155636c",
                "symbol": "c462c35e"
            }
        },
        "v3": {
            "default": {
                "plain": "544a7993",
                "symbol": "20954659"
            }
        }
    },
    "line.symbol.more2": {
        "default": {
            "default": {
                "plain": "7ef55930",
                "symbol": "0f02682e"
            }
        },
        "v3": {
            "default": {
                "plain": "f7b63b52",
                "symbol": "29817c74"
            }
        }
    },
    "line.symbol.multi-ticket": {
        "default": {
            "default": {
                "plain": "6dfe70a3",
                "symbol": "d5a69fc9"
            }
        }
    },
    "line.symbol.navigate": {
        "default": {
            "default": {
                "plain": "7f05e2da",
                "symbol": "8aeff43d"
            }
        },
        "v3": {
            "default": {
                "plain": "77676ee1",
                "symbol": "6a85e2fc"
            }
        }
    },
    "line.symbol.paragraph": {
        "default": {
            "default": {
                "plain": "daa8f352",
                "symbol": "5946a0c5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "7e803c65",
                "symbol": "9d946373"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.passport": {
        "default": {
            "default": {
                "plain": "09035171",
                "symbol": "1906d661"
            }
        },
        "v3": {
            "default": {
                "plain": "0d7b0d6c",
                "symbol": "84d9c196"
            }
        }
    },
    "line.symbol.photo": {
        "default": {
            "default": {
                "plain": "9eeab804",
                "symbol": "02358be0"
            }
        },
        "v3": {
            "default": {
                "plain": "93379cbd",
                "symbol": "6d535f80"
            }
        }
    },
    "line.symbol.pin": {
        "default": {
            "default": {
                "plain": "a6aa9022",
                "symbol": "f06ccc9d"
            }
        },
        "v3": {
            "default": {
                "plain": "e7ae1be4",
                "symbol": "b644ac4a"
            }
        }
    },
    "line.symbol.pin-board": {
        "default": {
            "default": {
                "plain": "34ae1f92",
                "symbol": "548be423"
            }
        },
        "v3": {
            "default": {
                "plain": "814c9273",
                "symbol": "34ba599f"
            }
        }
    },
    "line.symbol.pin-location": {
        "default": {
            "default": {
                "plain": "504823e0",
                "symbol": "11ceef68"
            }
        },
        "v3": {
            "default": {
                "plain": "231db3d3",
                "symbol": "bd0010ec"
            }
        }
    },
    "line.symbol.pin-map": {
        "default": {
            "default": {
                "plain": "f20c3d16",
                "symbol": "74e94c9a"
            }
        },
        "v3": {
            "default": {
                "plain": "ea4db054",
                "symbol": "5999712a"
            }
        }
    },
    "line.symbol.pin-route": {
        "default": {
            "default": {
                "plain": "4f2b8232",
                "symbol": "6739f279"
            }
        },
        "v3": {
            "default": {
                "plain": "7d6cb0c5",
                "symbol": "e41d1a56"
            }
        }
    },
    "line.symbol.pin-star": {
        "default": {
            "default": {
                "plain": "0f2ef55c",
                "symbol": "95407186"
            }
        },
        "v3": {
            "default": {
                "plain": "12454b8f",
                "symbol": "e57a6718"
            }
        }
    },
    "line.symbol.pin-streetview": {
        "default": {
            "default": {
                "plain": "e62e81f5",
                "symbol": "28163400"
            }
        },
        "v3": {
            "default": {
                "plain": "956c5523",
                "symbol": "2f8c022e"
            }
        }
    },
    "line.symbol.plus": {
        "default": {
            "default": {
                "plain": "4898c929",
                "symbol": "0c64ec96"
            }
        },
        "v3": {
            "default": {
                "plain": "7a504a57",
                "symbol": "28347084"
            }
        }
    },
    "line.symbol.qr-code": {
        "default": {
            "default": {
                "plain": "04233a95",
                "symbol": "c25523bb"
            }
        },
        "v3": {
            "default": {
                "plain": "b5c414ee",
                "symbol": "d3b0ea8b"
            }
        }
    },
    "line.symbol.quotes-left": {
        "default": {
            "default": {
                "plain": "827cecac",
                "symbol": "26c62537"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "49717252",
                "symbol": "59b07202"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.quotes-right": {
        "default": {
            "default": {
                "plain": "ac384e1a",
                "symbol": "3e423557"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "8f04d2fd",
                "symbol": "8270f62a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.receipt-rmb": {
        "default": {
            "default": {
                "plain": "b09156f1",
                "symbol": "4e6eec3f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "9ac841ec",
                "symbol": "ccc9c095"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.receipt1": {
        "default": {
            "default": {
                "plain": "ee651410",
                "symbol": "948f0b57"
            }
        },
        "v3": {
            "default": {
                "plain": "9ac841ec",
                "symbol": "ccc9c095"
            }
        }
    },
    "line.symbol.receipt2": {
        "default": {
            "default": {
                "plain": "865d721b",
                "symbol": "43c79d1a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "9ac841ec",
                "symbol": "ccc9c095"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.restricted": {
        "default": {
            "default": {
                "plain": "a1d08dc7",
                "symbol": "c01ca681"
            }
        },
        "v3": {
            "default": {
                "plain": "e14b7e9c",
                "symbol": "bf37eb6d"
            }
        }
    },
    "line.symbol.ribbon": {
        "default": {
            "default": {
                "plain": "6278a374",
                "symbol": "1a09f8a3"
            }
        },
        "v3": {
            "default": {
                "plain": "12193a3f",
                "symbol": "f7100343"
            }
        }
    },
    "line.symbol.ribbon-card": {
        "default": {
            "default": {
                "plain": "a276cec3",
                "symbol": "41aa3b67"
            }
        },
        "v3": {
            "default": {
                "plain": "3721b2cc",
                "symbol": "a77819a8"
            }
        }
    },
    "line.symbol.safe": {
        "default": {
            "default": {
                "plain": "72ab1239",
                "symbol": "9210858a"
            }
        },
        "v3": {
            "default": {
                "plain": "67584852",
                "symbol": "39addca6"
            }
        }
    },
    "line.symbol.sandglass": {
        "default": {
            "default": {
                "plain": "66bf5362",
                "symbol": "2a19c940"
            }
        },
        "v3": {
            "default": {
                "plain": "a437d230",
                "symbol": "79bb453f"
            }
        }
    },
    "line.symbol.search": {
        "default": {
            "default": {
                "plain": "44454792",
                "symbol": "d4ae31bb"
            }
        },
        "v3": {
            "default": {
                "plain": "5d6e12d1",
                "symbol": "b4bb385f"
            }
        }
    },
    "line.symbol.search-ai": {
        "default": {
            "default": {
                "plain": "4886d01e",
                "symbol": "70791ca6"
            }
        },
        "v3": {
            "default": {
                "plain": "f31eb1ba",
                "symbol": "25dbb9d7"
            }
        }
    },
    "line.symbol.send": {
        "default": {
            "default": {
                "plain": "386c3d8b",
                "symbol": "daa67f8a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "71d37203",
                "symbol": "83b957aa"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.setting": {
        "default": {
            "default": {
                "plain": "b915fba3",
                "symbol": "a7d4648c"
            }
        },
        "v3": {
            "default": {
                "plain": "f30f4bdb",
                "symbol": "c03cead2"
            }
        }
    },
    "line.symbol.share": {
        "default": {
            "default": {
                "plain": "ad66c222",
                "symbol": "7603261c"
            },
            "ios": {
                "plain": "f1df11e0",
                "symbol": "9a9a8d50"
            }
        },
        "v3": {
            "default": {
                "plain": "1592b931",
                "symbol": "ff5a33b4"
            },
            "ios": {
                "plain": "e1625e9e",
                "symbol": "bade1a2f"
            }
        }
    },
    "line.symbol.shield-locker": {
        "default": {
            "default": {
                "plain": "f0b8ed2b",
                "symbol": "0401a9cc"
            }
        },
        "v3": {
            "default": {
                "plain": "627fd15f",
                "symbol": "19f5a77e"
            }
        }
    },
    "line.symbol.shield-user": {
        "default": {
            "default": {
                "plain": "0c139b38",
                "symbol": "3f2f3de8"
            }
        },
        "v3": {
            "default": {
                "plain": "1227ddc0",
                "symbol": "e3cf2e40"
            }
        }
    },
    "line.symbol.sim": {
        "default": {
            "default": {
                "plain": "6289ffff",
                "symbol": "7d820aa2"
            }
        },
        "v3": {
            "default": {
                "plain": "383ea7ed",
                "symbol": "17c30b0b"
            }
        }
    },
    "line.symbol.snowflake": {
        "default": {
            "default": {
                "plain": "3a86c9a0",
                "symbol": "d7a099f8"
            }
        },
        "v3": {
            "default": {
                "plain": "950eff14",
                "symbol": "5fa2ca92"
            }
        }
    },
    "line.symbol.sort1": {
        "default": {
            "default": {
                "plain": "6548f133",
                "symbol": "6f1775e6"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "f32ebc46",
                "symbol": "3493238e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.sort2": {
        "default": {
            "default": {
                "plain": "f3ebc6cc",
                "symbol": "c6802706"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "5d1207cb",
                "symbol": "ef395264"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.square-2": {
        "default": {
            "default": {
                "plain": "c65cc861",
                "symbol": "c4963981"
            }
        },
        "v3": {
            "default": {
                "plain": "270dcd25",
                "symbol": "1325027d"
            }
        }
    },
    "line.symbol.square-4": {
        "default": {
            "default": {
                "plain": "d80cc586",
                "symbol": "de9869d5"
            }
        },
        "v3": {
            "default": {
                "plain": "a9ec4c93",
                "symbol": "2fd06950"
            }
        }
    },
    "line.symbol.stack": {
        "default": {
            "default": {
                "plain": "dac91c10",
                "symbol": "1c38bffc"
            }
        },
        "v3": {
            "default": {
                "plain": "c29a2027",
                "symbol": "1f583db8"
            }
        }
    },
    "line.symbol.stack-base": {
        "default": {
            "default": {
                "plain": "ea6a0785",
                "symbol": "25b8f82b"
            }
        },
        "v3": {
            "default": {
                "plain": "556d79e9",
                "symbol": "a08b6b5b"
            }
        }
    },
    "line.symbol.stack-no": {
        "default": {
            "default": {
                "plain": "fd2c08bb",
                "symbol": "2180f4fc"
            }
        },
        "v3": {
            "default": {
                "plain": "0a49291b",
                "symbol": "828b477f"
            }
        }
    },
    "line.symbol.star": {
        "default": {
            "default": {
                "plain": "22a51b06",
                "symbol": "5b6ee262"
            }
        },
        "v3": {
            "default": {
                "plain": "6dc826c1",
                "symbol": "6899f772"
            }
        }
    },
    "line.symbol.star-half": {
        "default": {
            "default": {
                "plain": "fea6f027",
                "symbol": "90958f9f"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "1f7e7072",
                "symbol": "601872d5"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.streetview": {
        "default": {
            "default": {
                "plain": "b9723ea7",
                "symbol": "dd6b52f1"
            }
        },
        "v3": {
            "default": {
                "plain": "3732dd2c",
                "symbol": "a3f02eb8"
            }
        }
    },
    "line.symbol.sun": {
        "default": {
            "default": {
                "plain": "06500e05",
                "symbol": "7cf5a240"
            }
        },
        "v3": {
            "default": {
                "plain": "e8c7ca8d",
                "symbol": "6a2732de"
            }
        }
    },
    "line.symbol.sun-cloud": {
        "default": {
            "default": {
                "plain": "eb94c37f",
                "symbol": "1c488fd2"
            }
        },
        "v3": {
            "default": {
                "plain": "b2c10de1",
                "symbol": "4a4a5d5c"
            }
        }
    },
    "line.symbol.sun-half": {
        "default": {
            "default": {
                "plain": "2c22c965",
                "symbol": "1eddfcf6"
            }
        },
        "v3": {
            "default": {
                "plain": "0903a685",
                "symbol": "e11f5073"
            }
        }
    },
    "line.symbol.tag": {
        "default": {
            "default": {
                "plain": "ad2ceb44",
                "symbol": "a24b0901"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "b07bf020",
                "symbol": "f9385f4a"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.tags": {
        "default": {
            "default": {
                "plain": "e8d4b758",
                "symbol": "e339350c"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "4528b0b6",
                "symbol": "0edff862"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.symbol.tamil": {
        "default": {
            "default": {
                "plain": "98bcebe9",
                "symbol": "cc455df5"
            }
        },
        "v3": {
            "default": {
                "plain": "6ed254f5",
                "symbol": "4c7691bf"
            }
        }
    },
    "line.symbol.text-size": {
        "default": {
            "default": {
                "plain": "e5b8e239",
                "symbol": "6eeb74c8"
            }
        }
    },
    "line.symbol.thumbs-down": {
        "default": {
            "default": {
                "plain": "6d06b68a",
                "symbol": "c9796aa9"
            }
        },
        "v3": {
            "default": {
                "plain": "441fe66d",
                "symbol": "4d199cbb"
            }
        }
    },
    "line.symbol.thumbs-up": {
        "default": {
            "default": {
                "plain": "c15b975e",
                "symbol": "6fee4cd5"
            }
        },
        "v3": {
            "default": {
                "plain": "9455b5a1",
                "symbol": "96c60c67"
            }
        }
    },
    "line.symbol.time": {
        "default": {
            "default": {
                "plain": "53bb6b76",
                "symbol": "79bc617f"
            }
        },
        "v3": {
            "default": {
                "plain": "14fb9d81",
                "symbol": "2b7a5327"
            }
        }
    },
    "line.symbol.time-arrow": {
        "default": {
            "default": {
                "plain": "5bc415ea",
                "symbol": "cbf92259"
            }
        },
        "v3": {
            "default": {
                "plain": "b53c19ed",
                "symbol": "676bc385"
            }
        }
    },
    "line.symbol.triangle-exclamation": {
        "default": {
            "default": {
                "plain": "81179430",
                "symbol": "1caf3174"
            }
        },
        "v3": {
            "default": {
                "plain": "b260aef4",
                "symbol": "4d86975e"
            }
        }
    },
    "line.symbol.trophy": {
        "default": {
            "default": {
                "plain": "8accdeeb",
                "symbol": "f4ffb667"
            }
        },
        "v3": {
            "default": {
                "plain": "dde615ab",
                "symbol": "5d15bd4f"
            }
        }
    },
    "line.symbol.trophy-star": {
        "default": {
            "default": {
                "plain": "30fedf6a",
                "symbol": "0640a910"
            }
        },
        "v3": {
            "default": {
                "plain": "64a4da8d",
                "symbol": "e5941153"
            }
        }
    },
    "line.symbol.unicorn": {
        "default": {
            "default": {
                "plain": "62725d53",
                "symbol": "fc633af4"
            }
        },
        "v3": {
            "default": {
                "plain": "9dec276f",
                "symbol": "20702537"
            }
        }
    },
    "line.symbol.unsave": {
        "default": {
            "default": {
                "plain": "5e50d8a9",
                "symbol": "28a148ce"
            }
        },
        "v3": {
            "default": {
                "plain": "116bc070",
                "symbol": "09ef5701"
            }
        }
    },
    "line.symbol.vaccine": {
        "default": {
            "default": {
                "plain": "50cf5183",
                "symbol": "cf1869cd"
            }
        },
        "v3": {
            "default": {
                "plain": "e6a8c6ec",
                "symbol": "7794477a"
            }
        }
    },
    "line.symbol.vaccine2": {
        "default": {
            "default": {
                "plain": "6a1eb47d",
                "symbol": "17db596e"
            }
        },
        "v3": {
            "default": {
                "plain": "8ade3604",
                "symbol": "e3bde3ea"
            }
        }
    },
    "line.symbol.volume": {
        "default": {
            "default": {
                "plain": "5fd54aa6",
                "symbol": "cfa08b5e"
            }
        },
        "v3": {
            "default": {
                "plain": "6e643182",
                "symbol": "e5ebfcad"
            }
        }
    },
    "line.symbol.volume-no": {
        "default": {
            "default": {
                "plain": "85879e7e",
                "symbol": "6d9e82fb"
            }
        },
        "v3": {
            "default": {
                "plain": "3753ea9e",
                "symbol": "2f08861b"
            }
        }
    },
    "line.symbol.wallet": {
        "default": {
            "default": {
                "plain": "9aa07d01",
                "symbol": "11b39fb7"
            }
        }
    },
    "line.transportation.airbag": {
        "default": {
            "default": {
                "plain": "5e823ebc",
                "symbol": "b6495076"
            }
        }
    },
    "line.transportation.airport": {
        "default": {
            "default": {
                "plain": "e70929d8",
                "symbol": "55e55b90"
            }
        },
        "v3": {
            "default": {
                "plain": "8bfea323",
                "symbol": "9c80819f"
            }
        }
    },
    "line.transportation.airport-check": {
        "default": {
            "default": {
                "plain": "319c95f1",
                "symbol": "374de90d"
            }
        },
        "v3": {
            "default": {
                "plain": "aed7d10c",
                "symbol": "ec8b8946"
            }
        }
    },
    "line.transportation.airport-park": {
        "default": {
            "default": {
                "plain": "cde66a45",
                "symbol": "091a9b6a"
            }
        },
        "v3": {
            "default": {
                "plain": "d2683437",
                "symbol": "1d67da03"
            }
        }
    },
    "line.transportation.airport-pin": {
        "default": {
            "default": {
                "plain": "08c3f14a",
                "symbol": "dabba829"
            }
        },
        "v3": {
            "default": {
                "plain": "a0deefb5",
                "symbol": "5493fbbe"
            }
        }
    },
    "line.transportation.airport-time": {
        "default": {
            "default": {
                "plain": "6c86c90d",
                "symbol": "dc36bf4e"
            }
        },
        "v3": {
            "default": {
                "plain": "4fd6eaaf",
                "symbol": "6c6cc0de"
            }
        }
    },
    "line.transportation.arrival": {
        "default": {
            "default": {
                "plain": "de72cc5d",
                "symbol": "663608a8"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "200febda",
                "symbol": "aa7dd422"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.transportation.bike": {
        "default": {
            "default": {
                "plain": "932b7899",
                "symbol": "99b0450f"
            }
        },
        "v3": {
            "default": {
                "plain": "48a41085",
                "symbol": "18c94f2c"
            }
        }
    },
    "line.transportation.bike-key": {
        "default": {
            "default": {
                "plain": "ebd0206e",
                "symbol": "bd504c4a"
            }
        },
        "v3": {
            "default": {
                "plain": "b07f99fa",
                "symbol": "0405abb5"
            }
        }
    },
    "line.transportation.bike-pay": {
        "default": {
            "default": {
                "plain": "b583a349",
                "symbol": "4bf86012"
            }
        },
        "v3": {
            "default": {
                "plain": "48a41085",
                "symbol": "18c94f2c"
            }
        }
    },
    "line.transportation.bus": {
        "default": {
            "default": {
                "plain": "07ead86b",
                "symbol": "3a6e3e8e"
            }
        },
        "v3": {
            "default": {
                "plain": "69e026fd",
                "symbol": "0fdfd94b"
            }
        }
    },
    "line.transportation.bus-metro": {
        "default": {
            "default": {
                "plain": "a3818b0c",
                "symbol": "63a5c3e0"
            }
        },
        "v3": {
            "default": {
                "plain": "ee6d8f97",
                "symbol": "57262f27"
            }
        }
    },
    "line.transportation.cable-car": {
        "default": {
            "default": {
                "plain": "c385a491",
                "symbol": "e3c65ba2"
            }
        },
        "v3": {
            "default": {
                "plain": "deb2e19a",
                "symbol": "dd0e9a1b"
            }
        }
    },
    "line.transportation.car": {
        "default": {
            "default": {
                "plain": "80aa6262",
                "symbol": "14a53ba5"
            }
        },
        "v3": {
            "default": {
                "plain": "bc7336e5",
                "symbol": "492230c7"
            }
        }
    },
    "line.transportation.car-charge": {
        "default": {
            "default": {
                "plain": "966e9c49",
                "symbol": "d3b6183f"
            }
        },
        "v3": {
            "default": {
                "plain": "98a876ca",
                "symbol": "bcd9f88a"
            }
        }
    },
    "line.transportation.car-flight": {
        "default": {
            "default": {
                "plain": "5343bb9a",
                "symbol": "8ca05cbb"
            }
        },
        "v3": {
            "default": {
                "plain": "cf53cdc6",
                "symbol": "c2937b70"
            }
        }
    },
    "line.transportation.car-key": {
        "default": {
            "default": {
                "plain": "cfff2e6b",
                "symbol": "4541c82c"
            }
        },
        "v3": {
            "default": {
                "plain": "b07f99fa",
                "symbol": "0405abb5"
            }
        }
    },
    "line.transportation.car-park": {
        "default": {
            "default": {
                "plain": "79c35834",
                "symbol": "82a30435"
            }
        },
        "v3": {
            "default": {
                "plain": "994d1cf2",
                "symbol": "cf3f41f4"
            }
        }
    },
    "line.transportation.departure": {
        "default": {
            "default": {
                "plain": "a6e3a2c9",
                "symbol": "4f74e0ca"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "4a3f48dc",
                "symbol": "d282dcd4"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.transportation.ferry": {
        "default": {
            "default": {
                "plain": "022ce794",
                "symbol": "fab92330"
            }
        },
        "v3": {
            "default": {
                "plain": "98bc167c",
                "symbol": "cda00c88"
            }
        }
    },
    "line.transportation.flight-cancel": {
        "default": {
            "default": {
                "plain": "c9f15a94",
                "symbol": "a01ceaf2"
            }
        },
        "v3": {
            "default": {
                "plain": "cc19ad87",
                "symbol": "6bd3dc04"
            }
        }
    },
    "line.transportation.flight-change": {
        "default": {
            "default": {
                "plain": "7d0b0561",
                "symbol": "d34d650e"
            }
        },
        "v3": {
            "default": {
                "plain": "eda94251",
                "symbol": "492b9970"
            }
        }
    },
    "line.transportation.flight-change-no": {
        "default": {
            "default": {
                "plain": "c3fa6a39",
                "symbol": "b5c31142"
            }
        }
    },
    "line.transportation.flight-change-price": {
        "default": {
            "default": {
                "plain": "6fff0e36",
                "symbol": "1ab633a7"
            }
        }
    },
    "line.transportation.flight-check": {
        "default": {
            "default": {
                "plain": "9faa9526",
                "symbol": "315ac0ac"
            }
        },
        "v3": {
            "default": {
                "plain": "e4882655",
                "symbol": "b8c5b007"
            }
        }
    },
    "line.transportation.flight-gate": {
        "default": {
            "default": {
                "plain": "54c1e48d",
                "symbol": "c1ebb5ef"
            }
        },
        "v3": {
            "default": {
                "plain": "65e33f9a",
                "symbol": "7495259e"
            }
        }
    },
    "line.transportation.flight-multiple": {
        "default": {
            "default": {
                "plain": "1a654395",
                "symbol": "ea8e3e7b"
            }
        },
        "v3": {
            "default": {
                "plain": "555df35a",
                "symbol": "b5600c4b"
            }
        }
    },
    "line.transportation.flight-transfer": {
        "default": {
            "default": {
                "plain": "eb2ab213",
                "symbol": "6bff9749"
            }
        },
        "v3": {
            "default": {
                "plain": "48cc2a1f",
                "symbol": "d00f8832"
            }
        }
    },
    "line.transportation.flight1": {
        "default": {
            "default": {
                "plain": "7adab560",
                "symbol": "cf5b6ecc"
            }
        },
        "v3": {
            "default": {
                "plain": "4b985414",
                "symbol": "d4a2a88e"
            }
        }
    },
    "line.transportation.flight2": {
        "default": {
            "default": {
                "plain": "f97611f2",
                "symbol": "300dc781"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        },
        "v3": {
            "default": {
                "plain": "d1d01acb",
                "symbol": "d82fc74e"
            },
            "rtl": {
                "plain": "flip",
                "symbol": "flip"
            }
        }
    },
    "line.transportation.flight3": {
        "default": {
            "default": {
                "plain": "e3000ed4",
                "symbol": "c8482582"
            }
        },
        "v3": {
            "default": {
                "plain": "ecf35d3b",
                "symbol": "4261214b"
            }
        }
    },
    "line.transportation.fuel": {
        "default": {
            "default": {
                "plain": "cfc2246d",
                "symbol": "39b18407"
            }
        }
    },
    "line.transportation.jetski": {
        "default": {
            "default": {
                "plain": "96ab9db7",
                "symbol": "3c765d9c"
            }
        },
        "v3": {
            "default": {
                "plain": "0b4b404b",
                "symbol": "0dd076bb"
            }
        }
    },
    "line.transportation.metro": {
        "default": {
            "default": {
                "plain": "f638677d",
                "symbol": "55e834b9"
            }
        },
        "v3": {
            "default": {
                "plain": "06ba4bfd",
                "symbol": "d8027df5"
            }
        }
    },
    "line.transportation.parking": {
        "default": {
            "default": {
                "plain": "e4d75464",
                "symbol": "4d45095c"
            }
        },
        "v3": {
            "default": {
                "plain": "994d1cf2",
                "symbol": "cf3f41f4"
            }
        }
    },
    "line.transportation.parking-card": {
        "default": {
            "default": {
                "plain": "a07d9945",
                "symbol": "56836ced"
            }
        },
        "v3": {
            "default": {
                "plain": "994d1cf2",
                "symbol": "cf3f41f4"
            }
        }
    },
    "line.transportation.parking-pay": {
        "default": {
            "default": {
                "plain": "49852286",
                "symbol": "ac7a2c85"
            }
        },
        "v3": {
            "default": {
                "plain": "994d1cf2",
                "symbol": "cf3f41f4"
            }
        }
    },
    "line.transportation.roundtrip": {
        "default": {
            "default": {
                "plain": "4c36c840",
                "symbol": "57bad5b1"
            }
        },
        "v3": {
            "default": {
                "plain": "8081909c",
                "symbol": "0e6091b3"
            }
        }
    },
    "line.transportation.seat": {
        "default": {
            "default": {
                "plain": "0ecc8e9b",
                "symbol": "68ba223e"
            }
        },
        "v3": {
            "default": {
                "plain": "3404b555",
                "symbol": "ac13440e"
            }
        }
    },
    "line.transportation.seat-no": {
        "default": {
            "default": {
                "plain": "122a8eb4",
                "symbol": "d2736577"
            }
        },
        "v3": {
            "default": {
                "plain": "6d503b04",
                "symbol": "eaa24eb1"
            }
        }
    },
    "line.transportation.seat-pay": {
        "default": {
            "default": {
                "plain": "f65afc0f",
                "symbol": "09802339"
            }
        },
        "v3": {
            "default": {
                "plain": "4e4cc5bc",
                "symbol": "82b90752"
            }
        }
    },
    "line.transportation.shuttle": {
        "default": {
            "default": {
                "plain": "5cde981c",
                "symbol": "ad19d82f"
            }
        },
        "v3": {
            "default": {
                "plain": "fd506268",
                "symbol": "25903cf7"
            }
        }
    },
    "line.transportation.shuttle-time": {
        "default": {
            "default": {
                "plain": "58a98bf4",
                "symbol": "78a9d439"
            }
        },
        "v3": {
            "default": {
                "plain": "e26664c3",
                "symbol": "323f9431"
            }
        }
    },
    "line.transportation.taxi": {
        "default": {
            "default": {
                "plain": "5eaee418",
                "symbol": "5a66acc4"
            }
        },
        "v3": {
            "default": {
                "plain": "3d58cfba",
                "symbol": "2b81fd47"
            }
        }
    },
    "line.transportation.tram": {
        "default": {
            "default": {
                "plain": "e90cefbe",
                "symbol": "c4fdb00f"
            }
        },
        "v3": {
            "default": {
                "plain": "63fdbee9",
                "symbol": "598c2368"
            }
        }
    },
    "line.transportation.transportation-system": {
        "default": {
            "default": {
                "plain": "07c08fd5",
                "symbol": "b42a5842"
            }
        }
    },
    "line.transportation.yacht": {
        "default": {
            "default": {
                "plain": "fc30dfd2",
                "symbol": "3f39b902"
            }
        },
        "v3": {
            "default": {
                "plain": "fd8d889f",
                "symbol": "3eb95a4b"
            }
        }
    }
};
